(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-video"] && !Shopify.designMode) return;
  try {
    
  class SvastikaStoryFilm extends HTMLElement {
    connectedCallback() {
      this._btn = this.querySelector('[data-film-play]');
      // Whole-frame reach (2026-09-30): a tap ANYWHERE on the poster does what the play control does —
      // inline play, or for the link-out fallback (a plain <a>) the same new-tab link. Forwarded as a
      // click on the real control so it stays the one focusable element. Once playing, the frame is
      // left alone so the native <video>/iframe controls own every tap. data-svstk-film
      this._out = this._btn ? null : this.querySelector('a.sv-film__play');
      this.addEventListener('click', (e) => {
        if (this.classList.contains('is-playing')) return;
        if (e.target.closest('.sv-film__play')) return;
        if (this._btn) this.play();
        else if (this._out) this._out.click();
      });
      if (!this._btn) return;
      this._btn.addEventListener('click', (e) => { e.preventDefault(); this.play(); });
    }
    play() {
      if (this._played) return;
      this._played = true;
      const embed = this.getAttribute('data-embed');
      if (embed) {
        // YouTube / Vimeo: build the autoplay iframe on demand (zero bytes until now).
        const box = this.querySelector('[data-film-player]');
        if (box) {
          const f = document.createElement('iframe');
          f.src = embed;
          f.className = 'sv-film__embed';
          f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          f.setAttribute('allowfullscreen', '');
          f.setAttribute('title', this._btn.getAttribute('aria-label') || 'Video');
          box.appendChild(f);
          box.hidden = false;
        }
      } else {
        // Native <video>: enable the browser controls (pause/scrub) and start it.
        const v = this.querySelector('video');
        if (v) { v.controls = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      }
      this.classList.add('is-playing'); // CSS removes the facade button + veil so controls take over.
    }
  }
  if (!customElements.get('svastika-story-film')) customElements.define('svastika-story-film', SvastikaStoryFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bottom-nav"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBottomNav extends HTMLElement {
    connectedCallback() {
      // The nav is hidden by CSS above 768px — don't spend any work marking the active link there. Compute on mount
      // only when visible, and (cheaply) re-evaluate if the viewport later crosses into the mobile range.
      this._mq = matchMedia('(max-width: 768px)');
      this._onMq = () => { if (this._mq.matches && !this._marked) this.markActive(); };
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
      if (this._mq.matches) this.markActive();
      this.guardHelp();
    }
    // popovertarget does the open with no JS. This only covers the two ways that can silently
    // do nothing: the header rendered no help sheet (no help_link blocks), or the browser
    // predates the popover API. Either way, fall back to navigating to the item's own Link
    // rather than leaving a dead tab bar button.
    guardHelp() {
      const btn = this.querySelector('[data-bnav-help]');
      if (!btn) return;
      const supported = typeof HTMLElement !== 'undefined' && 'popover' in HTMLElement.prototype;
      const sheet = document.getElementById('svstk-help-sheet');
      if (supported && sheet) return;
      const href = btn.dataset.fallbackHref;
      btn.addEventListener('click', () => { if (href) window.location.href = href; });
    }
    disconnectedCallback() {
      if (this._mq && this._mq.removeEventListener && this._onMq) this._mq.removeEventListener('change', this._onMq);
    }
    // Exactly ONE tab is active: the one whose link is the LONGEST prefix of the current path.
    // A plain prefix test marked Shop (/collections) AND On Sale (/collections/on-sale) together.
    markActive() {
      this._marked = true;
      const path = window.location.pathname;
      let best = null;
      let bestLen = -1;
      this.querySelectorAll('.bnav__item').forEach((el) => {
        const href = el.dataset.href || '';
        if (!href) return;
        try {
          const url = new URL(href, window.location.origin);
          const p = url.pathname.replace(/\/$/, '') || '/';
          const hit = p === '/' ? path === '/' : (path === p || path.indexOf(p + '/') === 0);
          if (hit && p.length > bestLen) { best = el; bestLen = p.length; }
        } catch (e) {}
      });
      if (best) {
        best.setAttribute('data-active', '');
        best.setAttribute('aria-current', 'page');
      }
    }
  }
  if (!customElements.get('svastika-bottom-nav')) customElements.define('svastika-bottom-nav', SvastikaBottomNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-enquiry"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBulkEnquiry extends HTMLElement {
    connectedCallback() {
      const send = this.querySelector('[data-bsend]');
      this.base = send ? send.getAttribute('href') : '';
      const m = this.base.match(/wa\.me\/(\d+)/);
      this.num = m ? m[1] : '';
      this._rebuild = () => this.rebuild();
      this.addEventListener('input', this._rebuild);
      this.addEventListener('change', this._rebuild);
      this.querySelectorAll('[data-bneed]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const on = btn.getAttribute('aria-pressed') === 'true';
          btn.setAttribute('aria-pressed', on ? 'false' : 'true');
          this.rebuild();
        });
      });
      this.rebuild();
    }
    val(k) { const el = this.querySelector('[data-bfield="' + k + '"]'); return el ? el.value.trim() : ''; }
    rebuild() {
      const real = (v) => v && v !== 'Select…';
      const lines = ['Hi Svastika team, I would like a bulk / corporate enquiry.'];
      const push = (label, v) => { if (v) lines.push(label + ': ' + v); };
      push('Name', this.val('name'));
      push('Company', this.val('company'));
      push('Phone', this.val('phone'));
      push('Email', this.val('email'));
      if (real(this.val('category'))) lines.push('Looking for: ' + this.val('category'));
      if (real(this.val('qty'))) lines.push('Quantity: ' + this.val('qty'));
      const needs = Array.from(this.querySelectorAll('[data-bneed][aria-pressed="true"]')).map((b) => b.getAttribute('data-bneed'));
      if (needs.length) lines.push('Customisation: ' + needs.join(', '));
      push('Message', this.val('message'));
      const href = 'https://wa.me/' + this.num + '?text=' + encodeURIComponent(lines.join('\n'));
      const a = this.querySelector('[data-bsend]');
      if (a) a.setAttribute('href', href);
    }
  }
  if (!customElements.get('svastika-bulk-enquiry')) customElements.define('svastika-bulk-enquiry', SvastikaBulkEnquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-floating-cta"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBulkFloat extends HTMLElement {
    connectedCallback() {
      this.hero = document.getElementById('herotop');
      this.enq = document.getElementById('enquiry');
      this.heroVisible = !!this.hero;
      this.enqVisible = false;
      this.update = () => {
        const show = !this.heroVisible && !this.enqVisible;
        this.classList.toggle('is-show', show);
      };
      if (!('IntersectionObserver' in window)) { this.update(); return; }
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.target === this.hero) this.heroVisible = e.isIntersecting;
          if (e.target === this.enq) this.enqVisible = e.isIntersecting;
        });
        this.update();
      }, { threshold: 0, rootMargin: '-8% 0px -8% 0px' });
      if (this.hero) this.io.observe(this.hero);
      if (this.enq) this.io.observe(this.enq);
      this.update();
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  if (!customElements.get('svastika-bulk-float')) customElements.define('svastika-bulk-float', SvastikaBulkFloat);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-gifted"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBulkGifted extends HTMLElement {
    connectedCallback() {
      this._grid = this.querySelector('[data-bg-grid]');
      this._prev = this.querySelector('[data-bg-prev]');
      this._next = this.querySelector('[data-bg-next]');
      this._dots = this.querySelectorAll('[data-bg-dots] .bulk-gifted__dot');
      this._reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this._grid) return;
      var self = this;
      this._syncArrows = this._syncArrows.bind(this);
      this._sync = function () { self._syncArrows(); self._syncDots(); };
      if (this._prev) this._prev.addEventListener('click', function () { self._page(-1); });
      if (this._next) this._next.addEventListener('click', function () { self._page(1); });
      this._grid.addEventListener('scroll', this._sync, { passive: true });
      window.addEventListener('resize', this._syncArrows);
      this.addEventListener('contentvisibilityautostatechange', this._syncArrows);
      this._syncArrows();
      this._syncDots();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this._syncArrows);
      if (this._grid) this._grid.removeEventListener('scroll', this._sync);
      this.removeEventListener('contentvisibilityautostatechange', this._syncArrows);
    }
    _page(dir) {
      if (!this._grid) return;
      this._grid.scrollBy({ left: dir * this._grid.clientWidth, behavior: this._reduce ? 'auto' : 'smooth' });
    }
    _syncArrows() {
      var g = this._grid;
      if (!g || !this._prev || !this._next) return;
      if (g.clientWidth === 0) { this._prev.disabled = true; this._next.disabled = false; return; }
      var single = g.scrollWidth <= g.clientWidth + 1;
      this._prev.hidden = single;
      this._next.hidden = single;
      if (single) return;
      var max = g.scrollWidth - g.clientWidth - 1;
      this._prev.disabled = g.scrollLeft <= 0;
      this._next.disabled = g.scrollLeft >= max;
    }
    _syncDots() {
      if (!this._dots || !this._dots.length || !this._grid) return;
      var per = this._grid.clientWidth || 1;
      var active = Math.round(this._grid.scrollLeft / per);
      if (active < 0) active = 0;
      if (active > this._dots.length - 1) active = this._dots.length - 1;
      for (var i = 0; i < this._dots.length; i++) {
        this._dots[i].classList.toggle('bulk-gifted__dot--on', i === active);
      }
    }
  }
  if (!customElements.get('svastika-bulk-gifted')) customElements.define('svastika-bulk-gifted', SvastikaBulkGifted);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buyback-check"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBuybackCheck extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-bbpanel]');
      this.headEl = this.querySelector('[data-bbh]');
      this.bodyEl = this.querySelector('[data-bbb]');
      this.countEl = this.querySelector('[data-bbcount]');
      this.fields = Array.prototype.slice.call(this.querySelectorAll('[data-bbfield]'));
      if (!this.panel || !this.bodyEl || this.fields.length === 0) return;

      const attr = (n) => this.getAttribute(n) || '';
      this.messages = {
        neutral: [attr('data-msg-neutral-h'), attr('data-msg-neutral')],
        yes: [attr('data-msg-yes-h'), attr('data-msg-yes-b')],
        partial: [attr('data-msg-partial-h'), attr('data-msg-partial-b')],
        dates: [attr('data-msg-dates-h'), attr('data-msg-dates-b')]
      };
      this.lastState = this.panel.getAttribute('data-state') || 'neutral';
      this.timer = 0;
      // An UNTICKED box means "not answered yet", not "no". Only a row the
      // shopper has actually interacted with may count as an answer, and only
      // the hard facts can produce the outside-the-window message — otherwise
      // a first tap on a condition row tells a truthful shopper they do not
      // qualify before they have answered a single date question.
      this.touched = new WeakSet();
      this.onChange = (e) => {
        if (e && e.target && e.target.hasAttribute('data-bbfield')) this.touched.add(e.target);
        this.schedule();
      };
      this.addEventListener('change', this.onChange);
      this.tally();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.timer) { clearTimeout(this.timer); this.timer = 0; }
    }

    read() {
      let facts = 0, factsOn = 0, factsAnswered = 0, judges = 0, judgesOn = 0, on = 0;
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        const isFact = f.getAttribute('data-bbkind') === 'fact';
        if (f.checked) on++;
        if (isFact) {
          facts++;
          if (f.checked) factsOn++;
          if (this.touched.has(f)) factsAnswered++;
        } else { judges++; if (f.checked) judgesOn++; }
      }
      let state = 'partial';
      if (on === 0) state = 'neutral';
      else if (factsAnswered === facts && factsOn < facts) state = 'dates';
      else if (factsOn === facts && judgesOn === judges) state = 'yes';
      return { state: state, on: on, total: this.fields.length };
    }

    tally() {
      const r = this.read();
      if (this.countEl) this.countEl.textContent = r.on + ' / ' + r.total;
      return r;
    }

    schedule() {
      const r = this.tally();
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.timer = 0;
        this.apply(r.state);
      }, 400);
    }

    apply(state) {
      if (state === this.lastState) return;
      this.lastState = state;
      const m = this.messages[state] || this.messages.neutral;
      if (this.headEl) this.headEl.textContent = m[0];
      this.bodyEl.textContent = m[1];
      this.panel.setAttribute('data-state', state);
    }
  }
  if (!customElements.get('svastika-buyback-check')) customElements.define('svastika-buyback-check', SvastikaBuybackCheck);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buyback-steps"] && !Shopify.designMode) return;
  try {
    
  class SvastikaBuybackRail extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-bb-list]');
      this.fill = this.querySelector('[data-bb-fill]');
      this.track = this.querySelector('[data-bb-track]');
      if (!this.list || !this.fill) return;

      this.items = Array.prototype.slice.call(this.list.querySelectorAll('[data-bb-item]'));
      if (this.items.length < 2) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce && reduce.matches) return;
      if (typeof window.IntersectionObserver !== 'function') return;

      this.done = 0;
      this.list.classList.add('is-armed');

      var self = this;
      this.observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry.isIntersecting) continue;
          var idx = self.items.indexOf(entry.target);
          if (idx < 0) continue;
          self.observer.unobserve(entry.target);
          self.advance(idx);
        }
      }, { threshold: 0.5, rootMargin: '0px 0px -20% 0px' });

      for (var j = 0; j < this.items.length; j++) this.observer.observe(this.items[j]);

      this.resizeTimer = 0;
      this.onResize = function () {
        if (self.resizeTimer) clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function () { self.resizeTimer = 0; self.measure(); }, 150);
      };
      window.addEventListener('resize', this.onResize);
    }

    advance(idx) {
      var reached = idx + 1;
      if (reached > this.done) this.done = reached;
      this.measure();
      for (var i = 0; i <= idx; i++) this.items[i].classList.add('is-on');
    }

    // The rail only exists below 900px, but the offsets are read in whatever
    // layout happens to be active when a step is reached. On the desktop
    // column grid every offsetTop is 0, so a desktop-to-mobile resize would
    // otherwise leave the vertical rail holding a 2.5px fill.
    measure() {
      if (!this.done) return;
      var y = this.items[this.done - 1].offsetTop + 2.5;
      this.fill.style.setProperty('--bb-fill-h', y + 'px');
      if (this.track) {
        var last = this.items[this.items.length - 1];
        this.track.style.setProperty('--bb-track-h', (last.offsetTop + 2.5) + 'px');
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.resizeTimer) { clearTimeout(this.resizeTimer); this.resizeTimer = 0; }
    }
  }
  if (!customElements.get('svastika-buyback-rail')) {
    customElements.define('svastika-buyback-rail', SvastikaBuybackRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Svastika 2.0 · cart drawer SHELL — SVSTK-ORIGIN-7Q2X9K3 · svstk-7q2x9k3 · slowmade
     Only what every page view needs: the sliding dialog, the listener surface, and a loader for
     assets/cart-engine.js — the optimistic renderer, coupon engine, gift/milestone subsystems,
     upsell carousel, volume tiers and reconciliation, none of which is reachable until the shopper
     opens the drawer or adds to cart. Behaviour after load is identical to the pre-split file. */
  class SvastikaCartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-drawer]');
      this.region = this.querySelector('[data-cart-render]');
      this.live = this.querySelector('[data-cart-live]');
      if (!this.dialog) return;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.moneyFormat = (this.dataset.moneyFormat || ('₹' + '{' + '{amount}}')).replace(/<[^>]+>/g, '');
      this.seq = 0;
      this.chain = Promise.resolve();
      this.hasOrderDiscount = false;
      this.autoDisc = null;
      // readAutoDisc() + detectDiscount() + syncGift() now run inside the engine's install()
      // (assets/cart-engine.js), in the same order they ran here — see _engine() below.

      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) { this.close(); return; }
        const clr = e.target.closest('[data-cart-clear]');
        if (clr) {
          // Two-tap confirm so a stray tap can't wipe the cart: first tap arms, second tap (within 3s) clears.
          if (clr.classList.contains('is-confirm')) { clr.classList.remove('is-confirm'); clearTimeout(this._clearArm); this.clearCart(); }
          else { clr.classList.add('is-confirm'); clearTimeout(this._clearArm); this._clearArm = setTimeout(() => clr.classList.remove('is-confirm'), 3000); }
          return;
        }
        const rm = e.target.closest('[data-cart-remove]');
        if (rm) { const k = this.keyOf(rm); if (k) { const line = rm.closest('.cart-line'); this.trackQtyDelta(line, parseInt((line.querySelector('[data-cart-qty]') || {}).value, 10) || 1, 0); this.cascadeRemoveAddons(line); this.change(k, 0); } return; }
        const step = e.target.closest('[data-cart-minus],[data-cart-plus]');
        if (step) {
          const line = step.closest('.cart-line');
          const input = line.querySelector('[data-cart-qty]');
          const q = (parseInt(input.value, 10) || 0) + (step.matches('[data-cart-plus]') ? 1 : -1);
          this.trackQtyDelta(line, parseInt(input.value, 10) || 0, Math.max(0, q));
          if (q <= 0) this.cascadeRemoveAddons(line); else this.syncAddonQty(line, q);
          this.change(line.dataset.key, Math.max(0, q));
        }
      });
      this.addEventListener('focusin', (e) => { const i = e.target.closest && e.target.closest('[data-cart-qty]'); if (i) i.dataset.prevVal = i.value; });
      this.addEventListener('change', (e) => {
        const gt = e.target.closest('[data-gift-toggle]');
        if (gt) { this.toggleGiftAddon(gt); return; }
        const input = e.target.closest('[data-cart-qty]');
        if (input) {
          const k = this.keyOf(input); if (!k) return;
          const nq = Math.max(0, parseInt(input.value, 10) || 0);
          const line = input.closest('.cart-line');
          const oq = parseInt(input.dataset.prevVal, 10);
          this.trackQtyDelta(line, isNaN(oq) ? nq : oq, nq);
          if (nq <= 0) this.cascadeRemoveAddons(line); else this.syncAddonQty(line, nq);
          this.change(k, nq);
        }
      });

      // Keep the upsell strip's prev/next arrows in sync as the shopper scrolls it (capture — scroll doesn't bubble).
      this.region.addEventListener('scroll', (e) => {
        const t = e.target;
        if (t && t.classList && t.classList.contains('cart-up-strip')) this.syncUpArrows();
      }, true);

      // FAIL OPEN, same philosophy as the submit handler below and the sr-checkout CTA lesson.
      // EVERY add-to-cart on the theme arrives here (main-product, main-product-premium,
      // collection-engine, quick-add-engine, festival-rail, main-on-sale, main-article,
      // mystery-claim, reel-player) and addItems() is one of the promise-gated stubs at the foot
      // of this block — so if assets/cart-engine.js cannot be fetched at all, going through the
      // stub means the add is a silent no-op and the PDP button sits on `is-loading` for ever.
      // Gate on _engine() EXPLICITLY instead, and on rejection hand the add to the browser.
      document.addEventListener('cart:add', (e) => {
        const items = (e.detail && e.detail.items) || [];
        this._engine().then(() => this.addItems(items), () => this.nativeAdd(items));
      });
      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:close', () => this.close());
      document.addEventListener('cart:refresh', () => this.refresh());

      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-cart-skip')) return;
        if (form.hasAttribute('data-coupon-manual')) { e.preventDefault(); this.applyManual(form); return; }
        if (!/\/cart\/add\b/.test(form.getAttribute('action') || '')) return;
        // FAIL OPEN (the sr-checkout lesson, anti-patterns): the engine is what services an AJAX
        // add, so if the module cannot be fetched at all we must not swallow the submit — hand the
        // form back to the browser (a native POST to /cart/add, which Shopify redirects to /cart)
        // rather than leave the shopper with a dead Add button.
        e.preventDefault();
        const fd = new FormData(form);
        this._engine().then(() => this.addForm(fd), () => { form.submit(); });
      });

      // Toggle the coupon-input clear (×) button as the shopper types.
      document.addEventListener('input', (e) => {
        const inp = e.target.closest('[data-coupon-code-input]');
        if (!inp) return;
        const clr = inp.parentNode && inp.parentNode.querySelector('[data-coupon-clear]');
        if (clr) clr.hidden = !inp.value.length;
      });

      document.addEventListener('click', (e) => {
        const uprev = e.target.closest('[data-up-prev]');
        if (uprev) { e.preventDefault(); this.upScroll(-1); return; }
        const unext = e.target.closest('[data-up-next]');
        if (unext) { e.preventDefault(); this.upScroll(1); return; }
        const up = e.target.closest('[data-upsell-add]');
        if (up) { e.preventDefault(); this.addUpsell(up); return; }
        const sumtoggle = e.target.closest('[data-cart-summary-toggle]');
        if (sumtoggle) { const foot = sumtoggle.closest('[data-cart-summary]'); if (foot) { const open = foot.toggleAttribute('data-open'); sumtoggle.setAttribute('aria-expanded', open); if (open && foot.hasAttribute('data-stale')) this.refresh(); } return; }
        const cp = e.target.closest('[data-coupon-apply]');
        if (cp) { e.preventDefault(); this.applyCoupon(cp.dataset.code, cp); return; }
        const copen = e.target.closest('[data-coupon-open]');
        if (copen) { e.preventDefault(); this.togglePanel(); return; }
        const cclose = e.target.closest('[data-coupon-panel-close]');
        if (cclose) { e.preventDefault(); this.closePanel(); return; }
        const cclear = e.target.closest('[data-coupon-clear]');
        if (cclear) { e.preventDefault(); const inp = this.region.querySelector('[data-coupon-code-input]'); if (inp) { inp.value = ''; inp.focus(); cclear.hidden = true; } return; }
        const crm = e.target.closest('[data-coupon-remove]');
        if (crm) { e.preventDefault(); this.removeCoupon(); return; }
        const toggle = e.target.closest('[data-cart-toggle]');
        if (toggle) { e.preventDefault(); this.open(); return; }
        // Same-origin links to the cart route open the drawer instead of navigating (header cart icon, etc.).
        const a = e.target.closest('a[href]');
        if (a) {
          let u; try { u = new URL(a.href, location.origin); } catch (err) { return; }
          if (u.origin === location.origin && /\/cart\/?$/.test(u.pathname)) { e.preventDefault(); this.open(); }
        }
      });

      this.giftBusy = false;
      this.giftFailed = {};
      this.couponActive = false;
      this.coupon = null;
      this.couponBusy = false;
      this._adding = 0;      // in-flight /cart/add.js writes (optimistic path)
      this._flushing = 0;    // in-flight qty-flush /cart/update.js writes

      /* ----- Deferred engine: warm it on the first sign the shopper is heading for the cart -----
         The heavy half of this controller lives in assets/cart-engine.js and is not fetched until
         it can matter. Warming on hover/focus/touch of a cart or add-to-cart control means the
         module is normally resident BEFORE the add fires, so the optimistic paint never waits on
         the network; an add that beats it is queued by the proxies at the foot of this block. */
      const rites = '[data-cart-toggle],[data-svstk-add],[data-svstk-card-add],[data-qa-add],[data-upsell-add],'
        + '[data-cart-remove],[data-cart-plus],[data-cart-minus],[data-cart-qty],[data-cart-clear],'
        + '[data-gift-toggle],[data-coupon-apply],[data-coupon-open],form[action*="/cart/add"],a[href*="/cart"]';
      const WARMS = ['pointerover', 'focusin', 'touchstart'];
      const unwarm = () => WARMS.forEach((n) => document.removeEventListener(n, warm, true));
      const warm = (e) => { const t = e.target; if (t && t.closest && t.closest(rites)) { unwarm(); this._engine(); } };
      WARMS.forEach((n) => document.addEventListener(n, warm, { capture: true, passive: true }));
      // Capture phase so the fetch starts a tick before the handler that needs it.
      ['cart:add', 'cart:open', 'cart:refresh', 'quickadd:open'].forEach((n) => document.addEventListener(n, () => this._engine(), true));
      // A returning shopper already has a cart, so the gift/milestone authority has real work to do:
      // load at idle rather than on first touch. An empty cart ships zero engine bytes.
      if ((parseInt(this.dataset.svstkLines || '0', 10) || 0) > 0) {
        const kick = () => this._engine();
        if (window.requestIdleCallback) requestIdleCallback(kick, { timeout: 2500 });
        else setTimeout(kick, 800);
      }
    }

    /* ----- The loader ---------------------------------------------------------------------------
       `data-engine-src` carries the asset URL because a javascript tag is static — no Liquid may
       appear in this block, so the CDN path has to travel as an attribute. One import per element;
       a transient failure clears the cache so a later interaction can retry. */
    _engine() {
      if (!this._eng) {
        // ONE automatic retry: a single dropped request to the CDN should not push a whole page
        // view onto the fallback path. Only the import() is retried — install() must run once, so
        // it is chained AFTER the retry rather than inside it.
        const imp = () => import(this.dataset.engineSrc);
        this._eng = imp().catch(() => imp()).then((m) => { m.install(this); return m; });
        // Clear the cache on failure so a later interaction can try again from scratch; without
        // this a transient blip would poison every subsequent call for the life of the page.
        this._eng.catch(() => { this._eng = null; });
      }
      return this._eng;
    }


    /* ----- The fail-open path for cart:add ------------------------------------------------------
       Reached only when the engine module cannot be loaded. POST the items to /cart/add.js exactly
       as the engine would, then land the shopper on the REAL cart page whatever the outcome — a
       successful add they cannot see is as broken as a failed one, and /cart renders server-side
       with no engine involved. cart:addfailed goes out first (bubbling, on document, mirroring
       cart:added) so any button still showing a spinner can clear it before we navigate. */
    nativeAdd(items) {
      const leave = () => {
        try { document.dispatchEvent(new CustomEvent('cart:addfailed', { bubbles: true, detail: { items: items } })); } catch (err) {}
        window.location.assign('/cart');
      };
      if (!items || !items.length) { leave(); return; }
      // Mirror cleanItems() from the engine: callers attach client-only keys (display, price,
      // giftAddon) for the optimistic paint, and those must NOT reach /cart/add.js. Four lines
      // duplicated on purpose — the whole point of this path is that the engine is unavailable.
      const clean = items.map((i) => {
        const o = { id: i.id, quantity: i.quantity };
        if (i.properties) o.properties = i.properties;
        if (i.selling_plan) o.selling_plan = i.selling_plan;
        return o;
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: clean })
      }).then(leave, leave);
    }


    keyOf(el) { const l = el.closest('.cart-line'); return l ? l.dataset.key : null; }


    open() {
      this._engine();                                // the drawer's contents are the engine's job
      if (this.pendingClose) this.pendingClose();   // cancel any in-flight close so reopening mid-animation can't strand the drawer
      if (!this.dialog.open) this.dialog.showModal();
      // Lock the page behind the drawer — without this, wheel/touch over the drawer (or at the cart list's ends)
      // scrolls the PAGE instead of the cart. Removed when the close animation finishes.
      document.documentElement.classList.add('svstk-cart-lock');
      if (this.reduce) { this.dialog.classList.add('is-open'); }
      else { void this.dialog.offsetWidth; this.dialog.classList.add('is-open'); }   // force a reflow so the slide-in transition fires reliably (rAF is paused in hidden tabs); idempotent
      const close = this.querySelector('[data-cart-close]');
      if (close) close.focus();
      this.syncUpArrows();                           // strip width is now known (clientWidth was 0 while closed)
      if (this.dirty) this.reconcileDrift();         // catch any drift left by skip-render persists
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      let done = false;
      const finish = () => {
        if (done) return; done = true;
        clearTimeout(t);
        this.dialog.removeEventListener('transitionend', finish);
        this.pendingClose = null;
        document.documentElement.classList.remove('svstk-cart-lock');
        if (this.dialog.open) this.dialog.close();
      };
      // pendingClose() aborts the close (used by open() when reopening mid-animation) without closing the dialog.
      this.pendingClose = () => { done = true; clearTimeout(t); this.dialog.removeEventListener('transitionend', finish); this.pendingClose = null; };
      if (this.reduce) { finish(); return; }
      // Close on the slide-out transition, with a timeout fallback in case transitionend never fires (hidden tab / interrupted transition).
      this.dialog.addEventListener('transitionend', finish, { once: true });
      var t = setTimeout(finish, 420);
    }
  }

  /* Promise-gated proxies for every method that now lives in assets/cart-engine.js. A call that
     arrives before the module resolves — a tap during the fetch, a cart:add from a PDP — is queued
     on the same promise and replayed in registration order once install() has patched the real
     methods onto this prototype. Nothing outside this file changes: every public method name and
     every event name is still answered, just asynchronously until the module lands. */
  SvastikaCartDrawer.RITES = [
    'addUpsell', 'panelEl', 'panelOpen', 'togglePanel', 'openPanel', 'couponExists',
    'closePanel', 'panelMsg', 'currentTotal', 'applyCoupon', 'applyManual', 'couponMeta',
    'couponSaveOn', 'couponMirrorable', 'markCouponApplied', 'applyCode', 'persistCoupon', 'revertCoupon',
    'applyCodeServer', 'removeCoupon', 'replaceDiscount', 'celebrate', 'giftActive', 'syncGiftSkeleton',
    'purgeRealGifts', 'syncGiftDisplay', 'giftIcon', 'closeIcon', 'chevron', 'upScroll',
    'syncUpArrows', 'syncGift', 'renderOptimisticGift', 'trackQtyDelta', 'reconcileDrift', 'busyMutating',
    'payload', 'json', 'enqueue', 'money', 'addItems', 'dropOptimistic',
    'flushOptRemovals', 'propSig', 'healAddedKeys', 'renderOptimisticLine', 'cleanItems', 'addForm',
    'afterAdd', 'change', 'needsServerRender', 'flush', 'lightReconcile', 'clearSyncing',
    'optimistic', 'showEmptyState', 'nonGiftTotal', 'reconcileOptimistic', 'ensureMilestone', 'renderUpsells',
    'upsellCardHTML', 'msTh', 'paintMilestone', 'escapeHtml', 'trustRowHtml', 'showAddingSkeleton',
    'lineTotal', 'optimisticSubtotal', 'countLines', 'recompute', 'readAutoDisc', 'origTotal',
    'autoDiscEst', 'noteCart', 'detectDiscount', 'reanchor', 'refresh', 'pollCart',
    'refreshUntil', 'dropStaleCoupon', 'request', 'apply', 'syncCount', 'toggleGiftAddon',
    'mirrorGiftBreakdown', 'addonQtyFor', 'scheduleGiftRefresh', 'removeAddonFor', 'syncAddonQty', 'cascadeRemoveAddons',
    'syncGiftToggles', 'clearCart'
  ];
  SvastikaCartDrawer.RITES.forEach((n) => {
    const stub = function () {
      const args = arguments, self = this;
      return this._engine().then(() => {
        const fn = SvastikaCartDrawer.prototype[n];
        if (fn && fn !== stub) return fn.apply(self, args);
      }, (err) => {
        // Still resolve (callers are fire-and-forget and an unhandled rejection helps nobody), but
        // say so ONCE — a silent no-op here is exactly how a dead cart looks like a working one.
        // The add path does not rely on this: cart:add gates on _engine() itself and falls back to
        // a native POST + /cart, see the listener above.
        if (!SvastikaCartDrawer._warned) {
          SvastikaCartDrawer._warned = true;
          console.warn('[svstk-7q2x9k3] cart engine failed to load - cart.' + n + '() and later cart calls are inert until it loads', err);
        }
      });
    };
    stub.svstkStub = true;
    SvastikaCartDrawer.prototype[n] = stub;
  });

  if (!customElements.get('svastika-cart-drawer')) customElements.define('svastika-cart-drawer', SvastikaCartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue"] && !Shopify.designMode) return;
  try {
    
  // svstk-7q2x9k3 — parked-image hydration, the page-number rail (mark the slide that fills most of the
  // viewport; links scroll smoothly) and the Download/Share dock. Zero measurement at connect time, so
  // content-visibility on the slides is safe.
  class SvstkCatalogue extends HTMLElement {
    connectedCallback() {
      this.initLazy();
      this.initCards();
      this.initRail();
      this.initShare();
    }

    // Give every parked <img> inside `root` its real src/srcset/sizes (idempotent: the attribute it reads is removed).
    hydrate(root) {
      root.querySelectorAll('img[data-cat-src]').forEach((img) => {
        const d = img.dataset;
        if (d.catSizes) img.sizes = d.catSizes;
        if (d.catSrcset) img.srcset = d.catSrcset;
        img.src = d.catSrc;
        delete d.catSrc;
        delete d.catSrcset;
        delete d.catSizes;
      });
    }

    // Slides 3+ ship parked (snippets/catalogue-img.liquid). Observe the SLIDE, not the img: while a
    // content-visibility:auto slide is skipped its children have no box and IO cannot see them (anti-pattern 361).
    // One viewport of root margin keeps the next page ready before it scrolls in; the state-change event is
    // the second trigger for engines that un-skip without an intersection.
    // During a rail jump (this.jumping) both triggers stand down, so flying past nine pages does not fetch
    // nine pages of pictures; observeParked() re-arms afterwards and the slides then in view hydrate at once.
    initLazy() {
      const slides = this.querySelectorAll('.cat-slide');
      if (!('IntersectionObserver' in window)) { this.hydrate(this); return; }
      const io = new IntersectionObserver((entries) => {
        if (this.jumping) return;
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          this.hydrate(e.target);
          io.unobserve(e.target);
        });
      }, { rootMargin: '100% 0px' });
      this.observeParked = () => {
        io.disconnect();
        slides.forEach((el) => { if (el.querySelector('img[data-cat-src]')) io.observe(el); });
      };
      this.observeParked();
      slides.forEach((el) => {
        el.addEventListener('contentvisibilityautostatechange', (e) => { if (!e.skipped && !this.jumping) this.hydrate(el); });
      });
    }

    initRail() {
      // One list of jump links: the desktop rail AND the phone sheet both carry data-cat-rail-link.
      const links = Array.from(this.querySelectorAll('[data-cat-rail-link]'));
      if (!links.length) return;
      const sheet = this.querySelector('[data-cat-sheet]');
      const pager = this.querySelector('[data-cat-pager]');
      const pagerNum = this.querySelector('[data-cat-pager-num]');
      const canModal = !!(sheet && typeof sheet.showModal === 'function');
      links.forEach((a) => {
        a.addEventListener('click', (ev) => {
          const anchor = a.dataset.catRailLink;
          const target = document.getElementById(anchor);
          if (!target) return;
          ev.preventDefault();
          if (canModal && sheet.open) sheet.close();
          this.hydrate(target);
          this.jumpTo(target);
          history.replaceState(null, '', '#' + anchor);
        });
      });
      if ('onscrollend' in window) window.addEventListener('scrollend', () => this.landed());
      if (pager) {
        if (canModal) {
          pager.addEventListener('click', () => sheet.showModal());
          const close = sheet.querySelector('[data-cat-sheet-close]');
          if (close) close.addEventListener('click', () => sheet.close());
          sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
        } else {
          pager.hidden = true;
        }
      }
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting || e.intersectionRatio < 0.55) return;
          let num = '';
          links.forEach((a) => {
            const on = a.dataset.catRailLink === e.target.id;
            if (on) { a.setAttribute('aria-current', 'location'); num = a.dataset.catNum || num; }
            else a.removeAttribute('aria-current');
          });
          if (pagerNum && num) pagerNum.textContent = num;
        });
      }, { threshold: 0.55 });
      this.querySelectorAll('.cat-slide').forEach((el) => io.observe(el));
    }

    // Phone card rows: the chevron cue hides once the row is scrolled to its end or when it never overflows.
    // A row inside a skipped content-visibility slide measures 0 wide — leave the default (cue shown) and
    // judge again on scroll and when the slide un-skips.
    initCards() {
      this.querySelectorAll('[data-cat-cards]').forEach((wrap) => {
        const row = wrap.querySelector('.cat-cards');
        const btn = wrap.querySelector('[data-cat-cards-more]');
        if (!row || !btn) return;
        const update = () => {
          if (!row.clientWidth) return;
          wrap.classList.toggle('cat-cards-wrap--flat', row.scrollWidth - row.clientWidth < 8);
          wrap.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 8);
        };
        row.addEventListener('scroll', update, { passive: true });
        btn.addEventListener('click', () => {
          const card = row.firstElementChild;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          row.scrollBy({ left: card ? card.offsetWidth + 10 : 160, behavior: reduced ? 'auto' : 'smooth' });
        });
        const slide = wrap.closest('.cat-slide');
        if (slide) slide.addEventListener('contentvisibilityautostatechange', (e) => { if (!e.skipped) update(); });
        update();
      });
    }

    // Scroll a slide to the top. Slides between here and there are content-visibility placeholders whose
    // estimated height is not their real one, so the page lands short (measured 905px off on a 9-page jump);
    // landed() nudges instantly until the target sits at its scroll-margin, two frames apart so the engine
    // can un-skip what each nudge reveals. this.jumping stands the image observers down meanwhile.
    jumpTo(target) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.jumping = true;
      this.jumpTarget = target;
      clearTimeout(this.jumpTimer);
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      this.jumpTimer = setTimeout(() => this.landed(), reduced ? 50 : 1500);
    }

    landed(tries = 4) {
      const target = this.jumpTarget;
      if (!target) return;
      clearTimeout(this.jumpTimer);
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const off = target.getBoundingClientRect().top - margin;
      if (Math.abs(off) > 2 && tries > 0) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        requestAnimationFrame(() => requestAnimationFrame(() => this.landed(tries - 1)));
        return;
      }
      this.jumpTarget = null;
      this.jumping = false;
      if (this.observeParked) this.observeParked();
    }

    initShare() {
      const btn = this.querySelector('[data-cat-share]');
      if (!btn) return;
      const toast = this.querySelector('[data-cat-toast]');
      let timer = 0;
      const showToast = (msg) => {
        if (!toast) return;
        toast.textContent = msg;
        toast.classList.add('is-on');
        clearTimeout(timer);
        timer = setTimeout(() => {
          toast.classList.remove('is-on');
          toast.textContent = '';
        }, 2000);
      };
      btn.addEventListener('click', async () => {
        const url = location.href.split('#')[0];
        const title = btn.dataset.shareTitle || document.title;
        const text = btn.dataset.shareText || '';
        if (navigator.share) {
          try {
            await navigator.share({ title, text, url });
          } catch (err) {
            // AbortError = the shopper closed the sheet; nothing to do.
          }
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
          showToast(btn.dataset.copied || '');
        } catch (err) {
          window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank', 'noopener');
        }
      });
    }
  }
  if (!customElements.get('svastika-catalogue')) customElements.define('svastika-catalogue', SvstkCatalogue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featured"]) return;
  try {
    
  /* svastika-featured-rail — arrow-driven scroller for the dark "Most loved" product rail. SVSTK kept-close. */
  class SvastikaFeaturedRail extends HTMLElement {
    connectedCallback() {
      const section = this.closest('section');
      const scroll = (dir) => {
        const tile = this.querySelector('[data-rail-tile]');
        const step = tile ? tile.getBoundingClientRect().width + 16 : 224;
        const amount = Math.max(step, this.clientWidth - step);
        const rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollBy({ left: amount * dir, behavior: rm ? 'auto' : 'smooth' });
      };
      this._prev = section && section.querySelector('[data-rail-prev]');
      this._next = section && section.querySelector('[data-rail-next]');
      if (this._prev) this._prev.addEventListener('click', () => scroll(-1));
      if (this._next) this._next.addEventListener('click', () => scroll(1));
      this._sync = () => this.syncArrows();
      this.addEventListener('scroll', this._sync, { passive: true });
      window.addEventListener('resize', this._sync);
      // The section is content-visibility:auto (below-fold paint deferral): while skipped
      // this element measures 0px, so re-measure the moment it's revealed.
      this._section = section;
      if (section) section.addEventListener('contentvisibilityautostatechange', this._sync);
      this.syncArrows();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this._sync);
      if (this._section) this._section.removeEventListener('contentvisibilityautostatechange', this._sync);
    }
    syncArrows() {
      // Not yet laid out (off-screen under content-visibility): show the natural
      // start state — prev off, next on — rather than wrongly disabling next.
      if (this.clientWidth === 0) {
        if (this._prev) this._prev.disabled = true;
        if (this._next) this._next.disabled = false;
        return;
      }
      const max = this.scrollWidth - this.clientWidth - 1;
      if (this._prev) this._prev.disabled = this.scrollLeft <= 1;
      if (this._next) this._next.disabled = this.scrollLeft >= max;
    }
  }
  if (!customElements.get('svastika-featured-rail')) customElements.define('svastika-featured-rail', SvastikaFeaturedRail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-pantheon"]) return;
  try {
    
  /* svastika-pantheon-rail — tiny arrow-driven scroller for the relevant-collections pills. SVSTK kept-close. */
  class SvastikaPantheonRail extends HTMLElement {
    connectedCallback() {
      const section = this.closest('section');
      const scroll = (dir) => {
        const tile = this.querySelector('[data-rail-tile]');
        const step = tile ? tile.getBoundingClientRect().width + 8 : 160;
        const amount = Math.max(step, this.clientWidth - step);
        const rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollBy({ left: amount * dir, behavior: rm ? 'auto' : 'smooth' });
      };
      this._prev = section && section.querySelector('[data-rail-prev]');
      this._next = section && section.querySelector('[data-rail-next]');
      this._nav = section && section.querySelector('[data-kept-close]');
      if (this._prev) this._prev.addEventListener('click', () => scroll(-1));
      if (this._next) this._next.addEventListener('click', () => scroll(1));
      this._sync = () => this.syncArrows();
      this.addEventListener('scroll', this._sync, { passive: true });
      window.addEventListener('resize', this._sync);
      this.syncArrows();
    }
    disconnectedCallback() { window.removeEventListener('resize', this._sync); }
    syncArrows() {
      const max = this.scrollWidth - this.clientWidth - 1;
      /* Nothing to scroll (few pills / wide screen) → drop the arrows entirely rather
         than showing two permanently-dead buttons. */
      if (this._nav) this._nav.hidden = max <= 0;
      if (this._prev) this._prev.disabled = this.scrollLeft <= 1;
      if (this._next) this._next.disabled = this.scrollLeft >= max;
    }
  }
  if (!customElements.get('svastika-pantheon-rail')) customElements.define('svastika-pantheon-rail', SvastikaPantheonRail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["festival-rail"] && !Shopify.designMode) return;
  try {
    
  // <svastika-fest-rail> — the two things a shared collection-card needs when it renders in a rail
  // instead of the faceted grid: on-demand images, and an add-to-cart delegate.
  // Arrow behaviour is NOT here — that is <svastika-rail> from snippets/pdp-rail.liquid.
  if (!customElements.get('svastika-fest-rail')) {
    class SvstkFestRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-festrail-track]');
        if (!this.track) return;
        this.addEventListener('click', this._onClick.bind(this));
        this._initCells();
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }

      // Park every card image, then inject per cell as it approaches. collection-card emits a real
      // src (it is written for a grid), and native loading="lazy" does NOT stop a horizontal
      // scroller pre-fetching its off-screen cards — the browser preloads inside its lazy root
      // margin. Same approach as <svastika-related>.
      _initCells() {
        const imgs = Array.prototype.slice.call(this.track.querySelectorAll('img[src]'));
        if (!imgs.length) return;
        imgs.forEach((img) => {
          img.dataset.phSrc = img.getAttribute('src');
          const ss = img.getAttribute('srcset');
          if (ss) { img.dataset.phSrcset = ss; img.removeAttribute('srcset'); }
          img.removeAttribute('src');
        });

        // No IntersectionObserver: hydrate everything rather than ship a rail of empty boxes.
        // Correctness first, bytes second.
        if (!('IntersectionObserver' in window)) {
          imgs.forEach((img) => this._hydrate(img));
          return;
        }

        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this._io.unobserve(entry.target);
              this._hydrate(entry.target);
            });
          },
          { root: null, rootMargin: '300px' }
        );
        imgs.forEach((img) => this._io.observe(img));
      }

      _hydrate(img) {
        if (!img || !img.dataset.phSrc) return;
        if (img.dataset.phSrcset) { img.setAttribute('srcset', img.dataset.phSrcset); delete img.dataset.phSrcset; }
        img.setAttribute('src', img.dataset.phSrc);
        delete img.dataset.phSrc;
      }

      // MIRRORS collection-engine.liquid's addToCart() — keep the two in sync. On the grid that
      // handler lives on <svastika-collection>; a rail is not inside one, and wrapping it in a real
      // one would register a second popstate handler that re-navigates through the Section
      // Rendering API against grid hooks a rail does not have. The cart drawer and the quick-add
      // modal own the actual mutation either way, so this only has to dispatch the same events.
      _onClick(e) {
        const btn = e.target.closest('[data-svstk-card-add]');
        if (!btn) return;
        e.preventDefault();
        // Multi-variant card: let the shopper pick a size instead of adding the smallest variant.
        if (btn.dataset.quickAdd) {
          document.dispatchEvent(new CustomEvent('quickadd:open', { bubbles: true, detail: { url: btn.dataset.quickAdd } }));
          return;
        }
        const id = btn.dataset.variantId;
        if (!id) return;
        const item = { id: Number(id), quantity: 1 };
        // Display data lets the drawer paint the line optimistically instead of a skeleton.
        if (btn.dataset.title) {
          item.price = parseInt(btn.dataset.price, 10) || 0;
          item.display = { title: btn.dataset.title, variant: btn.dataset.variantTitle || '', image: btn.dataset.image || '', price: item.price, mrp: parseInt(btn.dataset.compare, 10) || 0, vol: '', product_id: btn.dataset.productId || '' };
        }
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
      }
    }
    customElements.define('svastika-fest-rail', SvstkFestRail);
  }

  // <svastika-fest-tabs> — the season tabs over a festival rail. Owns: tab state + keyboard, the
  // on-tap fetch of /collections/<handle>?section_id=festival-rail-cards, a per-tab cache, and the
  // frame rebuild (a fresh <svastika-fest-rail> per swap so image parking, hearts and arrows all
  // connect against the new cards instead of being patched in place). No tablist in the markup =
  // nothing to do. A failed fetch navigates to the tab's own href — the collection page — so the
  // rail can never end up empty. svstk-7q2x9k3 / kept-close
  if (!customElements.get('svastika-fest-tabs')) {
    class SvstkFestTabs extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-fest-tablist]');
        this.tpl = this.querySelector('template[data-fest-frame]');
        if (!this.list || !this.tpl) return;
        this.tabs = Array.prototype.slice.call(this.list.querySelectorAll('[data-fest-tab]'));
        if (this.tabs.length < 2) return;
        this.cache = new Map();
        this.current = this.tabs[0].dataset.festTab;
        this.list.addEventListener('click', (e) => {
          const tab = e.target.closest('[data-fest-tab]');
          if (!tab) return;
          e.preventDefault();
          this.activate(tab);
        });
        this.list.addEventListener('keydown', (e) => this._onKey(e));
      }

      _onKey(e) {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        let j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % this.tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + this.tabs.length) % this.tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = this.tabs.length - 1;
        if (j < 0) return;
        e.preventDefault();
        this.tabs[j].focus();
        this.activate(this.tabs[j]);
      }

      _panel() { return this.querySelector('[data-fest-panel]'); }

      // The cards of the panel that is on screen, with fest-rail's image parking undone so a
      // re-inserted copy parks and hydrates again from a clean state.
      _snapshot() {
        const track = this.querySelector('[data-festrail-track]');
        if (!track) return '';
        const clone = track.cloneNode(true);
        clone.querySelectorAll('img[data-ph-src]').forEach((img) => {
          img.setAttribute('src', img.dataset.phSrc);
          if (img.dataset.phSrcset) img.setAttribute('srcset', img.dataset.phSrcset);
          delete img.dataset.phSrc; delete img.dataset.phSrcset;
        });
        return clone.innerHTML;
      }

      // Bring the tapped tab to the middle of the strip. Horizontal only, on the strip itself
      // (the element that actually scrolls), so the page never jumps vertically.
      _center(tab) {
        const lr = this.list.getBoundingClientRect();
        const tr = tab.getBoundingClientRect();
        const dx = (tr.left + tr.width / 2) - (lr.left + lr.width / 2);
        if (Math.abs(dx) < 2) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({ left: dx, behavior: reduce ? 'auto' : 'smooth' });
      }

      activate(tab) {
        const handle = tab.dataset.festTab;
        this._center(tab);
        if (handle === this.current) return;
        const prev = this.tabs.find((t) => t.dataset.festTab === this.current);
        if (prev && !this.cache.has(this.current)) this.cache.set(this.current, this._snapshot());
        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        if (tab.dataset.festTone) this.list.style.setProperty('--fest-accent', 'var(--fest-' + tab.dataset.festTone + ')');
        this._setHead(tab);
        this.current = handle;
        if (this.cache.has(handle)) { this._swap(this.cache.get(handle), tab); return; }
        const panel = this._panel();
        if (panel) panel.setAttribute('aria-busy', 'true');
        const src = tab.dataset.festSrc;
        fetch(src, { credentials: 'same-origin' })
          .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cards = doc.querySelector('[data-festrail-cards]');
            if (!cards || !cards.children.length) throw new Error('empty');
            // Only act if the shopper is still on this tab.
            if (this.current !== handle) { this.cache.set(handle, cards.innerHTML); return; }
            this.cache.set(handle, cards.innerHTML);
            this._swap(cards.innerHTML, tab);
          })
          .catch(() => { if (this.current === handle) window.location.assign(tab.dataset.festUrl || tab.href); });
      }

      _setHead(tab) {
        if (this.hasAttribute('data-fest-autohead')) {
          const h = this.querySelector('[data-fest-heading]');
          if (h) h.textContent = tab.dataset.festName + ' ' + (this.dataset.festPicks || '');
        }
        const all = this.querySelector('[data-fest-all]');
        if (all && tab.dataset.festUrl) all.setAttribute('href', tab.dataset.festUrl);
      }

      _swap(cardsHtml, tab) {
        const old = this._panel();
        if (!old) return;
        const frag = this.tpl.content.cloneNode(true);
        const next = frag.querySelector('[data-fest-panel]');
        const track = frag.querySelector('[data-festrail-track]');
        if (!next || !track) return;
        track.innerHTML = cardsHtml;
        next.setAttribute('aria-labelledby', tab.id);
        old.replaceWith(next);
      }
    }
    customElements.define('svastika-fest-tabs', SvstkFestTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-hero"] && !Shopify.designMode) return;
  try {
    
  /* <svastika-flash-sale> — phase, both clocks, the sticky dock and the code copy chip. svstk-7q2x9k3 */
  if (!customElements.get('svastika-flash-sale')) {
    class SvstkFlashSale extends HTMLElement {
      connectedCallback() {
        this.start = new Date(this.dataset.start || '').getTime();
        this.end = new Date(this.dataset.end || '').getTime();
        this.hrs = this.querySelectorAll('[data-fc-hrs]');
        this.min = this.querySelectorAll('[data-fc-min]');
        this.sec = this.querySelectorAll('[data-fc-sec]');
        this.dock = this.querySelector('[data-flash-dock]');
        this.status = this.querySelector('[data-flash-status]');
        this.addEventListener('click', this._onClick.bind(this));
        if (isNaN(this.end)) return;
        // Reduced motion: tick once a minute; CSS drops the seconds (keys off data-fc-coarse).
        const mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
        this.coarse = !!(mq && mq.matches);
        if (this.coarse) this.setAttribute('data-fc-coarse', '');
        this.tick();
        this._t = setInterval(() => this.tick(), this.coarse ? 60000 : 1000);
        this._watchDock();
      }
      disconnectedCallback() {
        if (this._t) clearInterval(this._t);
        if (this._io) this._io.disconnect();
      }
      // The dock shows only once the hero clock has scrolled UP out of view (boundingClientRect.top
      // < 0) — never on first paint, never over the hero itself.
      _watchDock() {
        const clock = this.querySelector('[data-flash-clock]');
        if (!this.dock || !clock || !('IntersectionObserver' in window)) return;
        this._io = new IntersectionObserver((entries) => {
          const e = entries[0];
          this.toggleAttribute('data-dock-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        this._io.observe(clock);
      }
      pad(n) { return String(n).padStart(2, '0'); }
      _set(list, v) { list.forEach((el) => { if (el.textContent !== v) el.textContent = v; }); }
      tick() {
        const now = Date.now();
        let phase = 'live';
        let target = this.end;
        if (!isNaN(this.start) && now < this.start) { phase = 'before'; target = this.start; }
        else if (now >= this.end) { phase = 'ended'; }
        if (this.dataset.flashPhase !== phase) this.dataset.flashPhase = phase;
        if (phase === 'ended') { if (this._t) clearInterval(this._t); this._closeShelf(); return; }
        let d = Math.max(0, target - now);
        const h = Math.floor(d / 3600000); d -= h * 3600000;
        const m = Math.floor(d / 60000); d -= m * 60000;
        this._set(this.hrs, this.pad(h));
        this._set(this.min, this.pad(m));
        if (!this.coarse) this._set(this.sec, this.pad(Math.floor(d / 1000)));
        // Final hour: the clocks turn urgent red.
        this.toggleAttribute('data-flash-final', phase === 'live' && h === 0);
      }
      // Sale over: take the shelf down. Every section AFTER this one on the template (product grid,
      // FAQ — both about a code that no longer works) is hidden, leaving the ended hero + its
      // WhatsApp pull. Done here because a sibling section cannot be reached from CSS without
      // :has(), which the stylesheet bundler drops (§14). Never in the theme editor, where the
      // merchant still needs to see and edit those sections.
      _closeShelf() {
        if (window.Shopify && window.Shopify.designMode) return;
        const wrap = this.closest('.shopify-section');
        let next = wrap ? wrap.nextElementSibling : null;
        while (next) {
          if (next.classList.contains('shopify-section')) next.style.display = 'none';
          next = next.nextElementSibling;
        }
      }
      _onClick(ev) {
        const btn = ev.target.closest('[data-flash-copy]');
        if (!btn) return;
        const code = btn.getAttribute('data-flash-copy');
        const copied = this.dataset.copied || 'Copied';
        const done = () => {
          const label = btn.querySelector('[data-flash-copy-label]');
          const was = label ? label.textContent : '';
          if (label) label.textContent = copied;
          btn.setAttribute('data-copied', '');
          if (this.status) this.status.textContent = copied + ': ' + code;
          setTimeout(() => { if (label) label.textContent = was; btn.removeAttribute('data-copied'); }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      }
    }
    customElements.define('svastika-flash-sale', SvstkFlashSale);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class SvastikaHeader extends HTMLElement {
    connectedCallback() {
      // Sticky chrome: glassy on scroll + smart auto-hide (slide the bar up when
      // scrolling down, reveal it when scrolling up / near the top). rAF-throttled
      // passive listener — the 2026-standard way to do this without jank. Reduced
      // motion keeps it pinned (no hide).
      const stickyWrap = this.closest('.shopify-section');
      this._stickyWrap = stickyWrap;
      // MediaQueryList objects, built ONCE. matchMedia() inside an event handler re-parses the
      // query string and allocates a new MQL on every mouseenter / focusin / click — these four
      // are read from handlers that fire on pointer moves across the nav bar. svstk-7q2x9k3.
      const mqReduce  = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mqDesktop = window.matchMedia('(min-width: 1025px)');
      const mqDrawer  = window.matchMedia('(max-width: 1024px)');
      const mqHover   = window.matchMedia('(hover: hover) and (min-width: 1025px)');
      const reduceMotion = mqReduce.matches;
      let lastY = window.scrollY;
      let ticking = false;
      // Publish the sticky header height to :root so sub-bars (e.g. the category filter bar) can
      // sit just below it. offsetHeight is a FORCED SYNCHRONOUS LAYOUT, so it must not run once
      // per resize event: a drag-resize or a mobile URL-bar collapse fires these in bursts.
      // rAF-coalesced (one read per painted frame), and the write is skipped when the value has
      // not moved, so the custom property never invalidates style for nothing.
      let headerH = -1, hTick = false;
      const readHeaderH = () => {
        hTick = false;
        if (!stickyWrap) return;
        const h = stickyWrap.offsetHeight;
        if (h === headerH) return;
        headerH = h;
        document.documentElement.style.setProperty('--header-h', h + 'px');
      };
      const setHeaderH = () => { if (!hTick) { hTick = true; requestAnimationFrame(readHeaderH); } };
      readHeaderH();
      // ResizeObserver fires on the element's OWN box changing (a wrapping nav row, a font swap,
      // the announcement bar collapsing) as well as on viewport resizes, so it is both cheaper
      // and more correct than a window resize listener. Fall back where it is unavailable.
      if ('ResizeObserver' in window && stickyWrap) {
        this._headerRO = new ResizeObserver(setHeaderH);
        this._headerRO.observe(stickyWrap);
      } else {
        this._resize = setHeaderH;
        window.addEventListener('resize', this._resize, { passive: true });
      }
      const onScrollFrame = () => {
        ticking = false;
        const y = window.scrollY;
        this.classList.toggle('header--scrolled', y > 40);
        if (stickyWrap && !reduceMotion) {
          if (y < 90) {
            stickyWrap.classList.remove('is-nav-hidden');        // always show near the top
          } else if (y > lastY + 5) {
            stickyWrap.classList.add('is-nav-hidden');           // scrolling down → hide
          } else if (y < lastY - 5) {
            stickyWrap.classList.remove('is-nav-hidden');        // scrolling up → reveal
          }
          // Mirror the hidden state to :root so a sub-bar (category filter bar) can snap to the top when the header slides away.
          document.documentElement.classList.toggle('nav-hidden', stickyWrap.classList.contains('is-nav-hidden'));
        }
        lastY = y;
      };
      this._scroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(onScrollFrame); } };
      onScrollFrame();
      window.addEventListener('scroll', this._scroll, { passive: true });

      const openBtn  = this.querySelector('[data-drawer-open]');
      const closeEls = this.querySelectorAll('[data-drawer-close]');
      const wrap     = this.querySelector('.header__nav-wrap');
      const panel    = wrap?.querySelector('.header__nav-panel');
      const drawerBody = this.querySelector('.header__drawer-body');

      // iOS traps a position:fixed panel inside a scrolling ancestor. While a drilldown
      // is open we set the Level-0 body to overflow:visible so the fixed drilldown panel
      // (incl. its back-button header) escapes and covers the full screen. JS mirrors the
      // CSS :has() rule for browsers without :has() support.
      const syncBodyLock = () => {
        if (drawerBody) drawerBody.style.overflow = this.querySelector('.menu-item-wrap[data-open]') ? 'visible' : '';
      };

      // Lazy image hydration: swap data-src -> src the first time a scope opens.
      const swapNavImg = (img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-nav-img');
        img.removeAttribute('data-nav-defer');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      };
      // [data-nav-defer] opts out here — those are the large What's New drop images, loaded
      // by their own rail observer so opening the drawer doesn't fetch off-screen cards.
      const hydrate = (scope) => {
        if (!scope || scope._navHydrated) return;
        scope._navHydrated = true;
        scope.querySelectorAll('img[data-nav-img]:not([data-nav-defer])').forEach(swapNavImg);
      };

      // What's New rail: hydrate each drop card as it scrolls into the rail, one card ahead.
      const hydrateDropRail = () => {
        const rail = this.querySelector('[data-svstk-drops]');
        if (!rail || rail._svstkDropIO) return;
        if (!('IntersectionObserver' in window)) {
          rail.querySelectorAll('img[data-nav-defer]').forEach(swapNavImg);
          rail._svstkDropIO = true;
          return;
        }
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.querySelectorAll('img[data-nav-defer]').forEach(swapNavImg);
            io.unobserve(e.target);
          });
        }, { root: rail, rootMargin: '0px 260px' });
        rail.querySelectorAll('.header__combo').forEach((c) => io.observe(c));
        rail._svstkDropIO = io;
      };

      const prefersReduced = mqReduce.matches;
      const animate = (forward) => {
        if (!wrap) return;
        for (const a of wrap.getAnimations({ subtree: true })) a.cancel();
        if (prefersReduced) return;
        // fill:'both' holds the end frame DURING the run; we cancel onfinish so no
        // inline transform lingers afterwards. A persistent transform on the panel
        // creates a containing block that would trap the desktop mega panel to the
        // nav's width if the viewport later becomes desktop. The resting open/closed
        // state is held by CSS (mobile media query), so cancelling is seamless.
        const a1 = wrap.animate(forward ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
                     { duration: 220, easing: 'ease', fill: 'both' });
        const a2 = panel?.animate(forward ? [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }]
                               : [{ transform: 'translateX(0)' }, { transform: 'translateX(-100%)' }],
                       { duration: 280, easing: 'ease', fill: 'both' });
        a1.onfinish = () => a1.cancel();
        if (a2) a2.onfinish = () => a2.cancel();
      };
      // ===== Mobile category rail (Level 1) — svstk-7q2x9k3 =====
      // Opens over the Level-0 drawer when a primary is tapped. Left rail = scrollspy
      // tabs; right pane = stacked sub-category sections; images hydrate per-section.
      const rail = this.querySelector('[data-rail]');
      const railContent = rail?.querySelector('[data-rail-content]');
      const railLinks = rail ? Array.from(rail.querySelectorAll('[data-rail-link]')) : [];
      const railSecs = rail ? Array.from(rail.querySelectorAll('[data-rail-sec]')) : [];
      const railReduced = mqReduce.matches;
      const railNav = rail?.querySelector('[data-rail-nav]');
      const railBack = rail?.querySelector('[data-rail-back]');
      let railActiveId = null;
      // The right-pane sections and the left-rail buttons use DIFFERENT id/target schemes:
      // each category section is `.header__cat#header-cat-N` (data-cat=N) — shared with the
      // desktop mega panel — while its left button is `[data-target="rail-sec-N"]`; the Help
      // section keeps `#rail-sec-help` on both sides. These helpers translate between them so
      // the scrollspy + tab clicks join on the shared index (data-cat), not a literal id.
      const secTarget = (sec) => (sec && sec.dataset.cat != null) ? ('rail-sec-' + sec.dataset.cat) : (sec ? sec.id : null);
      const targetSec = (target) => {
        if (!railContent || !target) return null;
        if (target === 'rail-sec-help') return railContent.querySelector('#rail-sec-help');
        const n = target.replace('rail-sec-', '');
        return railContent.querySelector('.header__cat[data-cat="' + (window.CSS && CSS.escape ? CSS.escape(n) : n) + '"]');
      };
      // Scroll the RIGHT pane to a section by moving ONLY railContent.scrollTop — never
      // scrollIntoView, which also scrolls every ancestor (the page/drawer behind the
      // fixed rail) and caused the "scroll flash" on open. behavior is explicit ('instant'
      // not 'auto', since the pane's CSS scroll-behavior is smooth).
      const scrollRailTo = (sec, smooth) => {
        if (!sec || !railContent) return;
        const top = railContent.scrollTop + sec.getBoundingClientRect().top - railContent.getBoundingClientRect().top;
        railContent.scrollTo({ top, behavior: (smooth && !railReduced) ? 'smooth' : 'instant' });
      };
      // Keep the active left tab visible, contained to the left nav (no ancestor/page scroll).
      const revealNav = (btn) => {
        if (!btn || !railNav) return;
        const nr = railNav.getBoundingClientRect(), br = btn.getBoundingClientRect();
        if (br.top < nr.top) railNav.scrollTop += br.top - nr.top;
        else if (br.bottom > nr.bottom) railNav.scrollTop += br.bottom - nr.bottom;
      };
      const setActiveRail = (id) => {
        if (id === railActiveId) return;            // unchanged → skip class thrash + nav scroll (no per-tick jank)
        railActiveId = id;
        railLinks.forEach((b) => {
          const on = b.dataset.target === id;
          b.classList.toggle('is-active', on);
          if (on) { b.setAttribute('aria-current', 'true'); revealNav(b); }
          else b.removeAttribute('aria-current');
        });
      };
      const openRail = (index, trigger) => {
        if (!rail) return;
        this._railTrigger = trigger || null;       // remember what opened it, to restore focus on close
        hydrate(railNav);                          // left-rail category thumbnails (all small, ~6-12)
        [index - 1, index, index + 1].forEach((i) => { if (railSecs[i]) hydrate(railSecs[i]); });
        rail.classList.add('is-open');
        rail.setAttribute('aria-hidden', 'false');
        setActiveRail('rail-sec-' + index);
        // Jump (NOT smooth, contained to the pane) so the right pane is already at the tapped
        // section while the panel slides in — no two-axis animation, no page-scroll flash.
        scrollRailTo(railSecs[index], false);
        // Scrollspy + lazy per-section hydration (idempotent — created on first open).
        if (!this._railSpy && 'IntersectionObserver' in window && railContent) {
          this._railSpy = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) hydrate(e.target); });
            const top0 = railContent.getBoundingClientRect().top;
            const vis = railSecs
              .map((sc) => ({ sc, top: sc.getBoundingClientRect().top - top0 }))
              .filter((o) => o.top < 120)
              .sort((a, b) => b.top - a.top)[0];
            if (vis) setActiveRail(secTarget(vis.sc));
          }, { root: railContent, rootMargin: '200px 0px 0px 0px', threshold: [0, 0.1] });
          railSecs.forEach((sc) => this._railSpy.observe(sc));
        }
        railBack?.focus({ preventScroll: true });  // move focus into the open layer (a11y)
      };
      const closeRail = () => {
        if (!rail) return;
        rail.classList.remove('is-open');
        rail.setAttribute('aria-hidden', 'true');
        const t = this._railTrigger; this._railTrigger = null;
        t?.focus({ preventScroll: true });         // restore focus to the item that opened it
      };
      // Left-rail tab → scroll the right pane to its section.
      railLinks.forEach((b) => {
        b.addEventListener('click', () => {
          const sec = targetSec(b.dataset.target);
          if (sec) { hydrate(sec); scrollRailTo(sec, true); }
          setActiveRail(b.dataset.target);
        });
      });
      // Back arrow → return to Level 0 (close the rail only).
      rail?.querySelector('[data-rail-back]')?.addEventListener('click', closeRail);

      const open = () => {
        this._stickyWrap?.classList.remove('is-nav-hidden');   // reveal first (no transform → drawer not trapped)
        hydrate(wrap);                         // load all drawer images on first open
        hydrateDropRail();                     // …except the What's New drops, which load on approach
        wrap?.classList.add('is-open');
        openBtn?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        animate(true);
        this._startRotate?.();                 // placeholder rotator runs ONLY while the drawer is open
      };
      const close = () => {
        this._stopRotate?.();                   // no timer while the drawer is shut
        closeRail();                            // reset the rail when the whole drawer closes
        animate(false);
        wrap?.classList.remove('is-open');
        openBtn?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        this.querySelectorAll('.menu-item-wrap[data-open]').forEach((el) => {
          el.removeAttribute('data-open');
          el.querySelector('.header__menu-item')?.setAttribute('aria-expanded', 'false');
        });
        syncBodyLock();
      };
      openBtn?.addEventListener('click', open);
      closeEls.forEach((c) => c.addEventListener('click', close));
      // Esc: close the rail first if it's open, otherwise close the drawer.
      this._keydown = (e) => {
        if (e.key !== 'Escape') return;
        if (rail?.classList.contains('is-open')) { closeRail(); return; }
        if (wrap?.classList.contains('is-open')) { close(); return; }
        if (this.querySelector('.header__cat.is-open, .header__cat[data-open]')) closeAllCats();  // desktop mega panel
      };
      window.addEventListener('keydown', this._keydown);

      // ===== Desktop mega panels (≥1025) — svstk-7q2x9k3 =====
      // Panels are now CENTRALIZED `.header__cat` sections inside `.header__nav-content`
      // (siblings of the bar), shared with the mobile rail — NOT nested under the bar label.
      // So a label opens its panel by resolving it via aria-controls / data-cat, and reveal
      // is JS-driven (`.is-open`, `[data-open]` for touch), never a CSS :hover on a wrapper.
      const catPanel = (n) => document.getElementById('header-cat-' + n) || this.querySelector('.header__cat[data-cat="' + n + '"]');
      const catOpen = (p) => p.classList.contains('is-open') || p.hasAttribute('data-open');
      const closeAllCats = (except) => {
        this.querySelectorAll('.header__cat').forEach((p) => {
          if (p === except) return;
          p.classList.remove('is-open');
          p.removeAttribute('data-open');
        });
        this.querySelectorAll('.menu-item-wrap > .header__menu-item[aria-expanded="true"]').forEach((lbl) => {
          if (except && lbl.getAttribute('aria-controls') === except.id) return;
          lbl.setAttribute('aria-expanded', 'false');
        });
      };
      // Open the panel for a bar item, close its siblings, hydrate its images once.
      const revealCat = (mw, useAttr) => {
        const pnl = catPanel(mw.dataset.cat);
        if (!pnl) return;
        closeAllCats(pnl);
        hydrate(pnl);                                        // lazy nav images, once per panel
        // ORDER MATTERS. A closed panel carries `content-visibility: hidden`, which implies SIZE
        // containment — so while it is closed `offsetWidth` reports the contain-intrinsic-size
        // placeholder, and a `width: max-content` dropdown measures as its min-width, not its
        // real content width. Open it FIRST, then measure. Both happen inside this one synchronous
        // task, so the browser never paints the intermediate (still left:0) frame.
        if (useAttr) pnl.setAttribute('data-open', ''); else pnl.classList.add('is-open');
        // A dropdown (compact) panel is narrow — anchor it under ITS bar item (the panels are
        // centralised in one nav-content, so CSS can't do it). Mega panels stay full-width.
        if (pnl.dataset.layout === 'dropdown') {
          const nc = pnl.offsetParent;                       // .header__nav-content (positioning box)
          if (nc) {
            const mwR = mw.getBoundingClientRect(), ncR = nc.getBoundingClientRect();
            const pw = pnl.offsetWidth || 360;
            let left = mwR.left - ncR.left;
            left = Math.max(0, Math.min(left, nc.clientWidth - pw));   // clamp inside the box
            pnl.style.left = left + 'px';
            pnl.style.right = 'auto';
          }
        }
        mw.querySelector('.header__menu-item')?.setAttribute('aria-expanded', 'true');
      };
      // Hover/focus intent (hover-capable desktop pointers). A short close delay bridges the
      // gap between the floating panel and its bar label; entering the panel cancels it.
      const hoverCapable = mqHover;
      let catCloseTimer = null;
      const cancelCatClose = () => { if (catCloseTimer) { clearTimeout(catCloseTimer); catCloseTimer = null; } };
      const scheduleCatClose = () => { cancelCatClose(); catCloseTimer = setTimeout(() => closeAllCats(), 140); };
      this.querySelectorAll('.menu-item-wrap[data-mtype="mega"]').forEach((mw) => {
        // Mouse hover only on hover-capable pointers — a touch tap synthesizes mouseenter.
        mw.addEventListener('mouseenter', () => { if (hoverCapable.matches) { cancelCatClose(); revealCat(mw, false); } });
        mw.addEventListener('mouseleave', () => { if (hoverCapable.matches) scheduleCatClose(); });
        // Keyboard focus into the label opens its panel (a11y); Tab INTO the panel keeps it
        // open (the doc focusin handler only closes when focus leaves both the bar + panels).
        mw.addEventListener('focusin', () => { if (mqDesktop.matches) { cancelCatClose(); revealCat(mw, false); } });
      });
      // Keep the panel open while the pointer is over it; close shortly after it leaves.
      this.querySelectorAll('.header__cat').forEach((pnl) => {
        pnl.addEventListener('mouseenter', () => { if (hoverCapable.matches) cancelCatClose(); });
        pnl.addEventListener('mouseleave', () => { if (hoverCapable.matches) scheduleCatClose(); });
      });

      // Primary click. A PARENT item (has a sub-menu) NEVER navigates on click — it opens
      // its sub-menu instead (mobile → rail, desktop → mega panel). This lets the merchant
      // set a REAL href on parents (for SEO / crawlers / middle-click / open-in-new-tab)
      // without a normal click leaving the page. A SIMPLE item (no sub-menu) navigates.
      // The Level-0 .menu-item-wrap order matches the rail section order; data-rail-index
      // makes the mapping explicit.
      this.querySelectorAll('.menu-item-wrap').forEach((mw) => {
        const link = mw.querySelector('.header__menu-item');
        if (!link) return;
        const railIndex = parseInt(mw.dataset.railIndex, 10) || 0;
        link.addEventListener('click', (e) => {
          if (mw.dataset.mtype === 'simple') return;       // no sub-menu → let the href navigate
          const drawerMode = mqDrawer.matches;
          e.preventDefault();                              // parent → open the sub-menu, don't navigate
          if (drawerMode) { openRail(railIndex, link); return; }   // mobile → category rail
          // Hover-capable desktop opens on mouseenter/focus — a click on the parent just
          // keeps the (already-open) panel; only TOUCH desktop (no hover) toggles on tap.
          if (hoverCapable.matches) return;
          const pnl = catPanel(mw.dataset.cat);
          if (!pnl) return;
          const wasOpen = catOpen(pnl);
          closeAllCats();
          if (!wasOpen) revealCat(mw, true);               // reveal via [data-open] (touch parity)
        });
      });

      // Desktop: close any open mega panel when focus moves outside both the bar labels and the
      // panel itself (panels are siblings of the bar, not nested). The equivalent CLICK rule is
      // folded into the single delegated document-click handler below, beside the Support
      // dropdown's outside-click — two document-level click listeners on every page was two
      // hit-tests + two closest() walks per tap for no reason. svstk-7q2x9k3.
      this._navDocFocus = (e) => {
        if (!mqDesktop.matches) return;
        if (e.target.closest && e.target.closest('.menu-item-wrap, .header__cat')) return;
        closeAllCats();
      };
      document.addEventListener('focusin', this._navDocFocus);

      // "View more / less" toggles on long tile columns (collapsed to 2 rows by CSS).
      this.querySelectorAll('[data-tiles-more]').forEach((btn) => {
        const tiles = btn.previousElementSibling;
        if (!tiles) return;
        btn.addEventListener('click', () => {
          const expanded = tiles.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          btn.textContent = expanded ? (btn.dataset.less || 'View less') : (btn.dataset.more || btn.textContent);
        });
      });

      // Support dropdown (desktop top-right): click toggles open; outside-click / Esc closes.
      const supportEl = this.querySelector('.header__support');
      const supportBtn = supportEl?.querySelector('[data-support-toggle]');
      if (supportEl && supportBtn) {
        supportBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = supportEl.classList.toggle('is-open');
          supportBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      // ONE delegated document click for both outside-click behaviours (Support dropdown +
      // desktop mega panels). Order is deliberate: Support closes at every width, the mega-panel
      // rule is desktop-only, and the Support toggle stops propagation so its own click never
      // reaches here. Registered once whether or not the Support block exists.
      this._docClick = (e) => {
        const t = e.target;
        if (supportEl && supportBtn && !supportEl.contains(t)) {
          supportEl.classList.remove('is-open');
          supportBtn.setAttribute('aria-expanded', 'false');
        }
        if (!mqDesktop.matches) return;
        if (t.closest && t.closest('.menu-item-wrap, .header__cat')) return;
        closeAllCats();
      };
      document.addEventListener('click', this._docClick);

      // Inline drawer search: tapping anywhere on the pill focuses the input; the
      // animated placeholder hides once there's text (so it never sits over a query).
      const searchForm  = this.querySelector('[data-search-form]');
      const searchInput = searchForm?.querySelector('.header__drawer-search-input');
      if (searchForm && searchInput) {
        searchForm.addEventListener('click', (e) => { if (e.target !== searchInput) searchInput.focus(); });
        searchInput.addEventListener('input', () => {
          searchForm.classList.toggle('has-value', searchInput.value.length > 0);
        });
      }

      // Rotating search placeholder — gentle cross-fade + vertical slide between lines.
      // The element it animates (.header__drawer-search) is header__mobile-only AND sits inside
      // the closed drawer, so on desktop it is display:none and on mobile it is behind
      // content-visibility:hidden. The old code started a 3s setInterval at CONNECT on every
      // device and every page — a forever-timer whose body read offsetHeight (a forced
      // synchronous layout) against an element nobody could see. It now starts ONLY when the
      // drawer actually opens at a drawer-width viewport, stops on close, and stops while the
      // tab is hidden (a background tab throttles setInterval but does not stop it).
      // svstk-7q2x9k3.
      const rotateData = this.querySelector('script[data-search-rotate-data]');
      const rotateText = this.querySelector('[data-search-text]');
      let rotateLines = [];
      if (rotateData && rotateText) {
        try { rotateLines = JSON.parse(rotateData.textContent.trim()); } catch (e) { rotateLines = []; }
      }
      const rotateEase = 'opacity 0.4s ease, transform 0.4s ease';
      let rotateIdx = 0;
      const stopRotate = () => {
        clearInterval(this._searchTimer); this._searchTimer = null;
        clearTimeout(this._searchSwap); this._searchSwap = null;
      };
      const startRotate = () => {
        if (this._searchTimer) return;
        if (!rotateText || rotateLines.length < 2) return;
        if (mqReduce.matches || !mqDrawer.matches) return;   // desktop never shows this field
        if (document.hidden) return;
        const interval = parseInt(rotateData.dataset.interval || '3000', 10);
        rotateText.style.transition = rotateEase;
        this._searchTimer = setInterval(() => {
          // Pause while the user is interacting with the field.
          if (searchForm?.classList.contains('has-value') || document.activeElement === searchInput) return;
          rotateIdx = (rotateIdx + 1) % rotateLines.length;
          // Fade + slide the current line up and out.
          rotateText.style.opacity = '0';
          rotateText.style.transform = 'translateY(-7px)';
          this._searchSwap = setTimeout(() => {
            // Drop the new line in below with no transition, then animate it up into place.
            // The old forced reflow (void offsetHeight) is gone: restoring the transition in a
            // rAF restarts it just as reliably, and this branch only ever runs on a VISIBLE
            // drawer in a FOREGROUND tab (both are preconditions of startRotate), which is the
            // one situation where rAF is guaranteed to fire.
            rotateText.style.transition = 'none';
            rotateText.style.transform = 'translateY(7px)';
            rotateText.textContent = rotateLines[rotateIdx];
            requestAnimationFrame(() => {
              rotateText.style.transition = rotateEase;
              rotateText.style.opacity = '1';
              rotateText.style.transform = 'translateY(0)';
            });
          }, 400);
        }, interval);
      };
      this._rotateVis = () => {
        if (document.hidden) stopRotate();
        else if (wrap?.classList.contains('is-open')) startRotate();
      };
      document.addEventListener('visibilitychange', this._rotateVis);
      this._startRotate = startRotate;
      this._stopRotate = stopRotate;
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._scroll);
      if (this._resize) window.removeEventListener('resize', this._resize);
      this._headerRO?.disconnect();
      document.documentElement.classList.remove('nav-hidden');
      window.removeEventListener('keydown', this._keydown);
      if (this._docClick) document.removeEventListener('click', this._docClick);
      if (this._navDocFocus) document.removeEventListener('focusin', this._navDocFocus);
      if (this._rotateVis) document.removeEventListener('visibilitychange', this._rotateVis);
      this._railSpy?.disconnect();
      clearInterval(this._searchTimer);
      clearTimeout(this._searchSwap);
      document.body.style.overflow = '';
    }
  }
  if (!customElements.get('svastika-header')) customElements.define('svastika-header', SvastikaHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class SvastikaSlideshow extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this._slides.length < 2) return;
      this._current = 0;
      this._dots = this.querySelectorAll('[data-slide-to]');
      this._counter = this.querySelector('[data-slide-current]');

      // Slide 1 ships live URLs; the rest are parked in data-* (see the Liquid
      // above). Warm slide 2 once the page has settled so the first auto-advance
      // never crossfades into an undecoded image, then hydrate on demand in go().
      this._slides[0].dataset.svstkKept = '1';
      const warmNext = () => this.hydrate(1);
      if (document.readyState === 'complete') this._whenIdle(warmNext);
      else window.addEventListener('load', () => this._whenIdle(warmNext), { once: true });

      this.querySelector('[data-slide-prev]')?.addEventListener('click', () => this.go(this._current - 1));
      this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.go(this._current + 1));
      this._dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.slideTo, 10))));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  this.go(this._current - 1);
        if (e.key === 'ArrowRight') this.go(this._current + 1);
      });

      // Touch swipe (mobile / tablet / any touchscreen). Passive listeners + a
      // horizontal-dominance check so vertical page scrolling is never hijacked.
      let sx = 0, sy = 0, swiping = false;
      this.addEventListener('touchstart', (e) => {
        const t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (!swiping) return; swiping = false;
        const t = e.changedTouches[0];
        const dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.go(this._current + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });

      // Autoplay is gated on TWO independent pause reasons — hover and viewport —
      // so they can't fight each other (the previous mouseleave handler restarted
      // the timer unconditionally). Off-screen matters more than it used to: since
      // slides hydrate on advance, a hero left auto-rotating below the fold keeps
      // pulling banners nobody is looking at. IntersectionObserver's first callback
      // fires with the current state, so it starts playback when the hero is in
      // view; browsers without it just play, as before.
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._autoplay = this.dataset.autoplay === 'true' && !reduced;
      this._interval = parseInt(this.dataset.interval || '6000', 10);
      this._hovered = false;
      this._inView = true;
      if (this._autoplay) {
        this.addEventListener('mouseenter', () => { this._hovered = true;  this._pause(); });
        this.addEventListener('mouseleave', () => { this._hovered = false; this._play();  });
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            this._inView = entries[entries.length - 1].isIntersecting;
            if (this._inView) this._play(); else this._pause();
          }, { threshold: 0 });
          this._io.observe(this);
        } else {
          this._play();
        }
      }
    }
    _play() {
      if (this._timer || !this._autoplay || this._hovered || !this._inView) return;
      this._timer = setInterval(() => this.go(this._current + 1), this._interval);
    }
    _pause() {
      clearInterval(this._timer);
      this._timer = null;
    }
    _whenIdle(fn) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 1200);
    }
    // Swap a parked slide's data-srcset/data-src onto the live attributes. The
    // <source> is set before the <img> so the picture resolves against the mobile
    // candidate list on the first evaluation rather than re-fetching a desktop one.
    hydrate(i) {
      const slide = this._slides[(((i % this._slides.length) + this._slides.length) % this._slides.length)];
      if (!slide || slide.dataset.svstkKept) return;
      slide.dataset.svstkKept = '1';
      slide.querySelectorAll('source[data-srcset]').forEach((src) => {
        src.setAttribute('srcset', src.dataset.srcset);
        src.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-srcset]').forEach((img) => {
        img.setAttribute('srcset', img.dataset.srcset);
        img.removeAttribute('data-srcset');
        if (img.dataset.src) {
          img.setAttribute('src', img.dataset.src);
          img.removeAttribute('data-src');
        }
      });
    }
    go(n) {
      const len = this._slides.length;
      const next = ((n % len) + len) % len;
      // Start the fetch before the crossfade begins, and stay one slide ahead.
      this.hydrate(next);
      this.hydrate(next + 1);
      this._slides[this._current].removeAttribute('data-active');
      this._slides[next].setAttribute('data-active', '');
      this._dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === next);
        d.setAttribute('aria-selected', i === next ? 'true' : 'false');
      });
      if (this._counter) this._counter.textContent = String(next + 1).padStart(2, '0');
      this._current = next;
    }
    disconnectedCallback() { this._pause(); if (this._io) this._io.disconnect(); }
  }
  if (!customElements.get('svastika-slideshow')) customElements.define('svastika-slideshow', SvastikaSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-strip"] && !Shopify.designMode) return;
  try {
    
  // Traffic-triggered, fully deferred feed refresh. Fires ONCE per session and ONLY when the
  // cached feed is >6h stale (the section carries data-ig-refresh then). Fire-and-forget,
  // no-cors — the storefront never blocks on it and never touches Instagram directly.
  (function () {
    var el = document.querySelector('[data-svstk-ig][data-ig-refresh]');
    if (!el) return;
    var shop = (window.Shopify && window.Shopify.shop) || '';
    if (!shop) return;
    var KEY = 'svstk:ig-ping';
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    var fire = function () {
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      try {
        fetch('https://apps.svastika.in/api/instagram/refresh?shop=' + encodeURIComponent(shop), { mode: 'no-cors', keepalive: true });
      } catch (e) {}
    };
    if ('requestIdleCallback' in window) requestIdleCallback(fire, { timeout: 6000 });
    else setTimeout(fire, 2500);
  })();

  // Deterministic on-demand thumbnails. The tile <img>s ship with NO src (the IG CDN
  // URL sits in data-svstk-ig-src), so nothing is requested until the strip is genuinely
  // near the viewport — native loading="lazy" alone still background-fetches all 12.
  // Two triggers: an IntersectionObserver at rootMargin 200px, and the section's
  // content-visibility:auto reveal (while skipped the tiles have no layout box, so IO
  // cannot see them). hydrate() is idempotent — it clears the attribute it reads.
  (function () {
    var secs = Array.prototype.slice.call(document.querySelectorAll('[data-svstk-ig]'));
    if (!secs.length) return;
    function hydrate(img) {
      var u = img.getAttribute('data-svstk-ig-src');
      if (!u) return;
      img.removeAttribute('data-svstk-ig-src');
      img.setAttribute('src', u);
    }
    secs.forEach(function (sec) {
      var imgs = Array.prototype.slice.call(sec.querySelectorAll('img.ig__img[data-svstk-ig-src]'));
      if (!imgs.length) return;
      var hydrateAll = function () { imgs.forEach(hydrate); };
      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (!en.isIntersecting) return;
            hydrate(en.target);
            io.unobserve(en.target);
          });
        }, { rootMargin: '200px' });
        imgs.forEach(function (i) { io.observe(i); });
      } else {
        hydrateAll();
      }
      var host = sec.closest ? sec.closest('.shopify-section') : null;
      if (host) {
        host.addEventListener('contentvisibilityautostatechange', function (e) {
          if (!e.skipped) hydrateAll();
        });
      }
    });
  })();

  // Single-row slider arrows (desktop only — touch/mobile use native swipe). Pure DOM,
  // deferred; reveals/disables arrows from real measurements (cv:auto-safe re-measure).
  class SvstkIgRail extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-ig-track]');
      if (!track) return;
      var prev = this.querySelector('[data-ig-prev]');
      var next = this.querySelector('[data-ig-next]');
      if (!prev || !next) return;
      var mqArrow = window.matchMedia('(hover: hover) and (min-width: 1025px)');
      var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var sync = function () {
        // Off-screen under content-visibility:auto, clientWidth is 0 → keep arrows hidden
        // (natural start state); re-measured on reveal via contentvisibilityautostatechange.
        if (!mqArrow.matches || track.scrollWidth <= track.clientWidth + 4) {
          prev.hidden = true; next.hidden = true; return;
        }
        prev.hidden = false; next.hidden = false;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      var page = function (dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: mqReduce.matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      if (mqArrow.addEventListener) mqArrow.addEventListener('change', sync);
      var sec = this.closest('.shopify-section');
      if (sec) sec.addEventListener('contentvisibilityautostatechange', sync);
      sync();
    }
  }
  if (!customElements.get('svastika-ig-rail')) customElements.define('svastika-ig-rail', SvstkIgRail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  class SvastikaArticle extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.progress = this.querySelector('[data-jart-progress]');
      this.tocLinks = Array.from(this.querySelectorAll('[data-toc-link]'));
      this.sectionIds = [];
      this.tocLinks.forEach((l) => { const t = l.getAttribute('data-target'); if (t && this.sectionIds.indexOf(t) < 0) this.sectionIds.push(t); });
      this.ticking = false;
      this._onScroll = () => { if (this.ticking) return; this.ticking = true; requestAnimationFrame(() => { this.sync(); this.ticking = false; }); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this.sync();

      // TOC smooth-scroll
      this.tocLinks.forEach((l) => l.addEventListener('click', (e) => {
        const id = l.getAttribute('data-target'); const el = id && document.getElementById(id);
        if (!el) return; e.preventDefault();
        const y = el.getBoundingClientRect().top + window.scrollY - 84;
        window.scrollTo({ top: y, behavior: this.reduce ? 'auto' : 'smooth' });
        this.closeSheet();
      }));

      // Product mention tap toggle (hover handles desktop)
      this._onDocClick = (e) => {
        const m = e.target.closest && e.target.closest('.jpm');
        this.querySelectorAll('.jpm.is-open').forEach((x) => { if (x !== m) { x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); } });
        if (m) { const open = m.classList.toggle('is-open'); m.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      };
      document.addEventListener('click', this._onDocClick);
      this.addEventListener('keydown', (e) => {
        const m = e.target.closest && e.target.closest('.jpm');
        if (m && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); const open = m.classList.toggle('is-open'); m.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        if (e.key === 'Escape') this.closeSheet();
      });

      // Share
      this.querySelectorAll('[data-jart-share]').forEach((b) => b.addEventListener('click', () => {
        const url = b.getAttribute('data-url'), title = b.getAttribute('data-title') || document.title;
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(() => {}); }
        else { this.copy(url, b); }
      }));
      this.querySelectorAll('[data-jart-copy]').forEach((b) => b.addEventListener('click', () => this.copy(b.getAttribute('data-url'), b)));

      // Add-all → one cart:add
      this.querySelectorAll('[data-add-all]').forEach((b) => b.addEventListener('click', () => this.addAll()));

      // Product sliders (arrows on hover devices, swipe hint on touch)
      this.initSliders();

      // Mobile sheets
      this.backdrop = this.querySelector('[data-jart-backdrop]');
      this.querySelectorAll('[data-jart-open]').forEach((b) => b.addEventListener('click', () => this.openSheet(b.getAttribute('data-jart-open'))));
      this.querySelectorAll('[data-jart-close]').forEach((b) => b.addEventListener('click', () => this.closeSheet()));
      if (this.backdrop) this.backdrop.addEventListener('click', () => this.closeSheet());
      this.upgradeTables();
    }
    /* Merchant table HTML is bare: <table><tr><th>…, with no <thead>, no scope and no
       data-label. Style alone cannot fix that, so upgrade it here — progressive
       enhancement only, the un-upgraded table is already correct and readable.
       Builds the missing <thead> (so the header can be hidden when stacked and so
       search engines parse the table cleanly), adds scope="col", labels each body
       cell with its column header for the stacked layout, and re-asserts the table
       roles that display:block strips out of the accessibility tree. */
    upgradeTables() {
      const prose = this.querySelector('[data-jart-prose]');
      if (!prose) return;
      prose.querySelectorAll('table').forEach((table) => {
        if (table.closest('[data-jart-tw]')) return; // idempotent: never double-wrap

        let head = table.tHead;
        if (!head) {
          const first = table.rows[0];
          if (first && first.cells.length && Array.from(first.cells).every((c) => c.tagName === 'TH')) {
            head = table.createTHead();
            head.appendChild(first); // moves the row out of the implicit tbody
          }
        }
        const heads = head && head.rows[0] ? Array.from(head.rows[0].cells) : [];
        heads.forEach((th) => { if (!th.hasAttribute('scope')) th.setAttribute('scope', 'col'); });

        const wrap = document.createElement('div');
        wrap.className = 'jart-tw';
        wrap.setAttribute('data-jart-tw', '');
        wrap.setAttribute('data-svstk-7q2x9k3', 'table');
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);

        if (heads.length) {
          Array.from(table.tBodies).forEach((tb) => Array.from(tb.rows).forEach((tr) => {
            Array.from(tr.cells).forEach((td, i) => {
              const label = heads[i] && heads[i].textContent.trim();
              if (label && !td.hasAttribute('data-label')) td.setAttribute('data-label', label);
            });
          }));
        }

        // 3+ columns will not sit side by side on a phone, and these are comparison
        // tables where the ROW is the unit of meaning — side-scrolling would tear it
        // apart. Stack instead, and restore the roles display:block removes.
        if (heads.length >= 3) {
          wrap.classList.add('jart-tw--stack');
          table.setAttribute('role', 'table');
          Array.from(table.rows).forEach((tr) => {
            tr.setAttribute('role', 'row');
            Array.from(tr.cells).forEach((c) => c.setAttribute('role', c.tagName === 'TH' ? 'columnheader' : 'cell'));
          });
        }
      });
      // A scrollable box must be keyboard-reachable (WCAG 2.1.1), but a tab stop on a
      // box that does NOT scroll is just noise — so gate it on real overflow, measured
      // after layout, and re-measure on resize.
      this._syncTableScroll = () => {
        prose.querySelectorAll('[data-jart-tw]').forEach((w) => {
          const scrolls = w.scrollWidth - w.clientWidth > 1;
          if (scrolls) {
            w.setAttribute('tabindex', '0');
            w.setAttribute('role', 'region');
            if (!w.hasAttribute('aria-label')) w.setAttribute('aria-label', 'Table, scrollable');
          } else {
            w.removeAttribute('tabindex');
            w.removeAttribute('role');
            w.removeAttribute('aria-label');
          }
        });
      };
      requestAnimationFrame(this._syncTableScroll);
      window.addEventListener('resize', this._syncTableScroll, { passive: true });
    }
    disconnectedCallback() {
      if (this._syncTableScroll) window.removeEventListener('resize', this._syncTableScroll);
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('click', this._onDocClick);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }
    initSliders() {
      const sliders = Array.from(this.querySelectorAll('[data-slider]'));
      if (!sliders.length) return;
      const touch = window.matchMedia('(hover: none)').matches;
      const wire = (sl) => {
        const track = sl.querySelector('[data-slide-track]');
        if (!track) return null;
        const prev = sl.querySelector('[data-slide-prev]');
        const next = sl.querySelector('[data-slide-next]');
        const hint = sl.querySelector('[data-slide-hint]');
        let raf = 0;
        const update = () => {
          const over = track.scrollWidth - track.clientWidth > 6;
          const atStart = track.scrollLeft <= 2;
          const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          if (prev) { prev.hidden = !over || touch; prev.disabled = atStart; }
          if (next) { next.hidden = !over || touch; next.disabled = atEnd; }
          if (hint) hint.hidden = !(over && touch);
        };
        const step = () => Math.max(160, Math.round(track.clientWidth * 0.85));
        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: this.reduce ? 'auto' : 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: this.reduce ? 'auto' : 'smooth' }));
        track.addEventListener('scroll', () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; update(); }); }, { passive: true });
        track.addEventListener('scroll', () => { if (hint) hint.hidden = true; }, { once: true, passive: true });
        return update;
      };
      const updaters = sliders.map(wire).filter(Boolean);
      this._onResize = () => updaters.forEach((u) => u());
      window.addEventListener('resize', this._onResize, { passive: true });
      this._onResize();
    }
    sync() {
      const h = document.documentElement;
      if (this.progress) { const max = (h.scrollHeight - h.clientHeight) || 1; this.progress.style.width = Math.min(100, Math.max(0, (window.scrollY || h.scrollTop) / max * 100)) + '%'; }
      if (!this.sectionIds.length) return;
      let cur = this.sectionIds[0];
      for (const id of this.sectionIds) { const el = document.getElementById(id); if (el && el.getBoundingClientRect().top <= 140) cur = id; }
      this.tocLinks.forEach((l) => l.classList.toggle('is-active', l.getAttribute('data-target') === cur));
    }
    copy(url, btn) {
      if (!url) return;
      const done = () => { if (!btn) return; btn.classList.add('is-copied'); setTimeout(() => btn.classList.remove('is-copied'), 1400); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done).catch(() => {});
      else { const t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(t); }
    }
    addAll() {
      const grid = this.querySelector('[data-story-grid]') || this;
      const btns = Array.from(grid.querySelectorAll('[data-upsell-add]'));
      const seen = {}; const items = [];
      btns.forEach((b) => {
        const id = b.getAttribute('data-variant-id'); if (!id || seen[id]) return; seen[id] = 1;
        const price = parseInt(b.getAttribute('data-price'), 10) || 0;
        items.push({ id: id, quantity: 1, price: price, display: { title: b.getAttribute('data-title') || '', variant: b.getAttribute('data-variant-title') || '', image: b.getAttribute('data-image') || '', price: price, mrp: parseInt(b.getAttribute('data-compare'), 10) || 0, vol: '' } });
      });
      if (items.length) document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: items } }));
      this.closeSheet();
    }
    openSheet(which) {
      const sheet = this.querySelector('[data-jart-sheet="' + which + '"]'); if (!sheet) return;
      this.closeSheet(true);
      if (this.backdrop) { this.backdrop.hidden = false; }
      sheet.hidden = false;
      // force reflow so the transition runs (rAF paused in hidden tabs)
      void sheet.offsetWidth;
      if (this.backdrop) this.backdrop.classList.add('is-open');
      sheet.classList.add('is-open');
      this._openSheet = sheet;
      document.documentElement.style.overflow = 'hidden';
    }
    closeSheet(immediate) {
      const sheet = this._openSheet;
      document.documentElement.style.overflow = '';
      if (this.backdrop) { this.backdrop.classList.remove('is-open'); }
      if (!sheet) { if (this.backdrop) this.backdrop.hidden = true; return; }
      sheet.classList.remove('is-open');
      this._openSheet = null;
      const hide = () => { sheet.hidden = true; if (this.backdrop && !this._openSheet) this.backdrop.hidden = true; };
      if (immediate || this.reduce) hide(); else setTimeout(hide, 340);
    }
  }
  if (!customElements.get('svastika-article')) customElements.define('svastika-article', SvastikaArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  // Category strip: center the active chip on load, and toggle edge fades so the strip reads as swipeable.
  // Scroll hook is the .jblog-cats__strip (the element with overflow-x:auto) — never its wrapper (§14).
  (function () {
    function initStrip(strip) {
      var scroller = strip.closest('.jblog-cats__scroller');
      if (!scroller) return;
      function update() {
        var max = strip.scrollWidth - strip.clientWidth;
        scroller.classList.toggle('is-scrollable', max > 2);
        scroller.classList.toggle('at-start', strip.scrollLeft <= 2);
        scroller.classList.toggle('at-end', strip.scrollLeft >= max - 2);
      }
      strip.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      var active = strip.querySelector('.jblog-chip.is-active');
      if (active) {
        strip.scrollLeft = Math.max(0, active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2);
      }
      update();
    }
    function initAll(root) {
      (root || document).querySelectorAll('.jblog-cats__strip').forEach(initStrip);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  // <svastika-hours> — live "open now / closed" status from configurable store hours (IST).
  // Progressive enhancement: the pill server-renders a static fallback; this upgrades it.
  if (!customElements.get('svastika-hours')) {
    class SvastikaHours extends HTMLElement {
      connectedCallback() {
        if (this.dataset.live !== 'true') return;
        try { this.render(); } catch (e) { /* keep static fallback */ }
      }
      _mins(hhmm) { const p = (hhmm || '').split(':'); return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
      _closedDays() {
        const map = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
        return (this.dataset.closedDays || '').split(',')
          .map(d => map[d.trim().slice(0, 3).toLowerCase()])
          .filter(d => d !== undefined);
      }
      _fmt(m) {
        let h = Math.floor(m / 60), mm = m % 60, ap = h < 12 ? 'AM' : 'PM', hh = h % 12; if (hh === 0) hh = 12;
        return hh + (mm ? ':' + String(mm).padStart(2, '0') : '') + ' ' + ap;
      }
      render() {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const closed = this._closedDays();
        const openM = this._mins(this.dataset.open || '10:00');
        const closeM = this._mins(this.dataset.close || '19:00');
        // Current time in India (Asia/Kolkata) regardless of the visitor's timezone.
        const ist = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        const day = ist.getDay();
        const nowM = ist.getHours() * 60 + ist.getMinutes();
        const openToday = closed.indexOf(day) === -1;
        const isOpen = openToday && nowM >= openM && nowM < closeM;
        const dot = this.querySelector('.ct-pill__dot');
        const txt = this.querySelector('.ct-pill__txt');
        if (isOpen) {
          this.classList.add('is-open');
          if (txt) txt.textContent = this.dataset.openText || "We're open now";
          return;
        }
        this.classList.add('is-closed');
        // Next opening: today (if before open) else the next non-closed weekday.
        let label = '';
        for (let i = 0; i < 7; i++) {
          const dd = (day + i) % 7;
          if (closed.indexOf(dd) !== -1) continue;
          if (i === 0 && nowM < openM) { label = 'today ' + this._fmt(openM); break; }
          if (i === 0) continue;
          label = days[dd] + ' ' + this._fmt(openM); break;
        }
        if (txt) txt.textContent = (this.dataset.closedText || "We're closed now") + (label ? ' · Opens ' + label : '');
      }
    }
    customElements.define('svastika-hours', SvastikaHours);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('svastika-faq')) {
    class SvastikaFaq extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search]');
        this.clearBtn = this.querySelector('[data-faq-clear]');
        this.countEl = this.querySelector('[data-faq-count]');
        this.emptyEl = this.querySelector('[data-faq-empty]');
        this.scroller = this.querySelector('[data-faq-chipscroll]');
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
        this.chips = Array.from(this.querySelectorAll('[data-faq-chip]'));
        this.items.forEach(function (it) { it._text = (it.textContent || '').toLowerCase().replace(/\s+/g, ' '); });

        if (this.input) {
          var self = this;
          this.input.addEventListener('input', this._debounce(function () { self.filter(); }, 120));
          this.input.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.clear(); });
        }
        if (this.clearBtn) { var s2 = this; this.clearBtn.addEventListener('click', function () { s2.clear(); }); }
        this._initChips();
        this._initSpy();
      }

      _debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

      filter() {
        var q = (this.input ? this.input.value : '').trim().toLowerCase();
        var searching = q.length > 0;
        this.classList.toggle('is-searching', searching);
        if (this.clearBtn) this.clearBtn.hidden = !searching;

        var total = 0;
        this.items.forEach(function (it) {
          var match = !searching || it._text.indexOf(q) !== -1;
          it.hidden = !match;
          if (match) total++;
        });
        this.groups.forEach(function (g) {
          var any = false, kids = g.querySelectorAll('[data-faq-item]');
          for (var i = 0; i < kids.length; i++) { if (!kids[i].hidden) { any = true; break; } }
          g.hidden = !any;
        });
        var chips = this.chips, groups = this.groups;
        chips.forEach(function (c) {
          var key = c.getAttribute('data-faq-chip'), g = null;
          for (var i = 0; i < groups.length; i++) { if (groups[i].getAttribute('data-faq-group') === key) { g = groups[i]; break; } }
          c.hidden = g ? g.hidden : false;
        });
        if (this.emptyEl) this.emptyEl.hidden = total !== 0;
        if (this.countEl) this.countEl.textContent = searching ? (total + (total === 1 ? ' answer' : ' answers')) : '';
      }

      clear() {
        if (this.input) this.input.value = '';
        this.filter();
        if (this.input) this.input.focus();
      }

      _headerOffset() {
        var v = getComputedStyle(document.documentElement).getPropertyValue('--header-h') ||
                getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        var n = parseInt(v, 10);
        return (isNaN(n) ? 64 : n) + 70; // header + sticky chip bar
      }

      _initChips() {
        var self = this;
        this.chips.forEach(function (c) {
          c.addEventListener('click', function (e) {
            var key = c.getAttribute('data-faq-chip');
            var target = self.querySelector('#faq-' + key);
            if (!target) return;
            e.preventDefault();
            var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
            var top = target.getBoundingClientRect().top + window.pageYOffset - self._headerOffset();
            window.scrollTo({ top: top, behavior: rm ? 'auto' : 'smooth' });
          });
        });
      }

      _setActive(key) {
        this.chips.forEach(function (c) {
          var on = c.getAttribute('data-faq-chip') === key;
          c.classList.toggle('is-active', on);
          if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
        });
        this._scrollChipIntoView(key);
      }

      _scrollChipIntoView(key) {
        var sc = this.scroller; if (!sc) return;
        var chip = null;
        for (var i = 0; i < this.chips.length; i++) { if (this.chips[i].getAttribute('data-faq-chip') === key) { chip = this.chips[i]; break; } }
        if (!chip) return;
        var delta = (chip.offsetLeft + chip.offsetWidth / 2) - (sc.scrollLeft + sc.clientWidth / 2);
        if (Math.abs(delta) > 4) sc.scrollBy({ left: delta, behavior: 'smooth' });
      }

      _initSpy() {
        if (!('IntersectionObserver' in window) || !this.groups.length) return;
        var self = this;
        this._io = new IntersectionObserver(function (entries) {
          var vis = entries.filter(function (e) { return e.isIntersecting; })
                           .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
          if (vis[0]) self._setActive(vis[0].target.getAttribute('data-faq-group'));
        }, { rootMargin: '-22% 0px -70% 0px', threshold: 0 });
        this.groups.forEach(function (g) { self._io.observe(g); });
      }

      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    }
    customElements.define('svastika-faq', SvastikaFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"] && !Shopify.designMode) return;
  try {
    
class SvastikaCollectionsIndex extends HTMLElement {
  connectedCallback() {
    this._tabs = [...this.querySelectorAll('[data-collx-tab]')];
    this._tabsScroller = this.querySelector('.collx__tabs');
    this._shelves = this._tabs.map(t => this.querySelector('#' + t.getAttribute('data-collx-tab'))).filter(Boolean);
    this._reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._bindTabs();
    this._bindPills();
    this._bindSheet();
    this._spy();
  }
  disconnectedCallback() {
    if (this._io) this._io.disconnect();
    document.documentElement.style.overflow = '';
  }

  _bindTabs() {
    this._tabs.forEach(tab => tab.addEventListener('click', (e) => {
      e.preventDefault();
      const el = this.querySelector('#' + tab.getAttribute('data-collx-tab'));
      if (!el) return;
      el.scrollIntoView({ behavior: this._reduce ? 'auto' : 'smooth', block: 'start' });
    }));
  }

  _spy() {
    if (!this._shelves.length) return;
    this._io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) this._setActive(en.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    this._shelves.forEach(sh => this._io.observe(sh));
  }
  _setActive(id) {
    if (id === this._activeId) return;
    this._activeId = id;
    let active = null;
    this._tabs.forEach(t => { const on = t.getAttribute('data-collx-tab') === id; t.classList.toggle('is-active', on); if (on) active = t; });
    // Keep the active tab visible in the horizontally-scrolling strip (esp. mobile, where later tabs sit off-screen).
    if (active && this._tabsScroller) {
      const s = this._tabsScroller.getBoundingClientRect(), a = active.getBoundingClientRect();
      const delta = (a.left - s.left) - (s.width - a.width) / 2;
      if (Math.abs(delta) > 4) this._tabsScroller.scrollBy({ left: delta, behavior: this._reduce ? 'auto' : 'smooth' });
    }
  }

  _bindPills() {
    this.querySelectorAll('[data-collx-pills-toggle]').forEach(btn => {
      const wrap = btn.closest('[data-collx-pills]');
      const label = btn.querySelector('[data-collx-pills-label]');
      btn.addEventListener('click', () => {
        const expanded = wrap.classList.toggle('is-expanded');
        wrap.querySelectorAll('[data-collx-extra]').forEach(el => { el.hidden = !expanded; });
        if (label) label.textContent = expanded ? btn.dataset.less : btn.dataset.more;
      });
    });
  }

  _bindSheet() {
    this._sheet = this.querySelector('[data-collx-sheet]');
    if (!this._sheet) return;
    this.querySelectorAll('[data-collx-more-open]').forEach(b => b.addEventListener('click', () => this._openSheet()));
    this._sheet.querySelectorAll('[data-collx-more-close]').forEach(b => b.addEventListener('click', () => this._closeSheet()));
    // Click on the backdrop (outside the card) closes; native <dialog> reports target === dialog.
    this._sheet.addEventListener('click', (e) => { if (e.target === this._sheet) this._closeSheet(); });
    // Always release the scroll lock — Esc fires `cancel`, and the `close` event is unreliable across engines.
    this._sheet.addEventListener('cancel', () => this._unlock());
    this._sheet.addEventListener('close', () => this._unlock());
  }
  _openSheet() {
    // Native modal <dialog> renders in the top layer, so it escapes the section's
    // content-visibility containment and centers on desktop / bottom-sheets on mobile via CSS.
    if (typeof this._sheet.showModal === 'function') this._sheet.showModal();
    else this._sheet.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  _closeSheet() { this._sheet.close(); this._unlock(); }
  _unlock() { document.documentElement.style.overflow = ''; }
}
customElements.define('svastika-collections-index', SvastikaCollectionsIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-on-sale"] && !Shopify.designMode) return;
  try {
    
  class SvastikaOnSale extends HTMLElement {
    connectedCallback() {
      this.classList.add('is-ticking');
      this.addEventListener('click', this._onClick = (e) => this.onClick(e));
      const end = parseInt(this.dataset.windowEnd, 10);
      if (end) { this._end = end * 1000; this.tick(); this._t = setInterval(() => this.tick(), 1000); }
      // Sticky mini-timer: reveal it once the hero timer scrolls out of view (only when a countdown is running).
      const heroTimer = this.querySelector('.sv-onsale__timer');
      const ticker = this.querySelector('[data-os-ticker]');
      if (end && heroTimer && ticker && 'IntersectionObserver' in window) {
        this._io = new IntersectionObserver((es) => {
          ticker.classList.toggle('is-show', !es[0].isIntersecting);
        }, { threshold: 0, rootMargin: '-8px 0px 0px 0px' });
        this._io.observe(heroTimer);
      }
    }
    disconnectedCallback() {
      if (this._t) clearInterval(this._t);
      if (this._io) this._io.disconnect();
      if (this._onClick) this.removeEventListener('click', this._onClick);
    }
    tick() {
      let left = Math.floor((this._end - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(this._t);
        this.set('hh','00'); this.set('mm','00'); this.set('ss','00');
        // Guard against a full-page-cache reload loop: only reload once per boundary value.
        const key = 'svstk:onsale-reloaded';
        if (sessionStorage.getItem(key) !== String(this._end)) {
          sessionStorage.setItem(key, String(this._end));
          location.reload();
        }
        return;
      }
      const p = (n) => String(n).padStart(2, '0');
      this.set('hh', p(Math.floor(left / 3600)));
      this.set('mm', p(Math.floor((left % 3600) / 60)));
      this.set('ss', p(left % 60));
    }
    set(u, v) { this.querySelectorAll('[data-os-' + u + ']').forEach((el) => { el.textContent = v; }); }

    onClick(e) {
      const chip = e.target.closest('[data-os-chip]');
      if (chip) { e.preventDefault(); this.filter(chip); return; }
      const add = e.target.closest('[data-svstk-card-add]');
      if (add && !add.disabled) { e.preventDefault(); this.addToCart(add); return; }
    }

    filter(chip) {
      const cat = chip.dataset.cat;
      this.querySelectorAll('[data-os-chip]').forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      let shown = 0;
      this.querySelectorAll('[data-os-item]').forEach((item) => {
        const match = cat === 'all' || item.dataset.cat === cat;
        item.toggleAttribute('hidden', !match);
        if (match) shown++;
      });
      const count = this.querySelector('[data-os-count]');
      if (count) count.textContent = shown;
    }

    addToCart(btn) {
      if (btn.dataset.quickAdd) {
        document.dispatchEvent(new CustomEvent('quickadd:open', { bubbles: true, detail: { url: btn.dataset.quickAdd } }));
        return;
      }
      const id = btn.dataset.variantId; if (!id) return;
      const item = { id: Number(id), quantity: 1 };
      if (btn.dataset.title) {
        item.price = parseInt(btn.dataset.price, 10) || 0;
        item.display = { title: btn.dataset.title, variant: '', image: btn.dataset.image || '', price: item.price, mrp: parseInt(btn.dataset.compare, 10) || 0, vol: '', product_id: btn.dataset.productId || '' };
      }
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
    }
  }
  if (!customElements.get('svastika-onsale')) customElements.define('svastika-onsale', SvastikaOnSale);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPageToc extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('.sv-toc-wrap');
      this.links = Array.from(this.querySelectorAll('.sv-toc__link'));
      if (!this.links.length) return;
      this.mq = window.matchMedia('(min-width: 1025px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._apply = this._apply.bind(this);
      this._apply();
      this.mq.addEventListener('change', this._apply);

      this.links.forEach((a) => {
        a.addEventListener('click', (e) => {
          const id = a.getAttribute('href').slice(1);
          const t = document.getElementById(id);
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: this.reduce.matches ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + id);
          if (!this.mq.matches && this.details) this.details.open = false;
          t.setAttribute('tabindex', '-1');
          t.focus({ preventScroll: true });
        });
      });

      const map = new Map();
      this.links.forEach((a) => map.set(a.getAttribute('href').slice(1), a));
      const heads = this.links
        .map((a) => document.getElementById(a.getAttribute('href').slice(1)))
        .filter(Boolean);
      if ('IntersectionObserver' in window && heads.length) {
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((en) => {
              if (!en.isIntersecting) return;
              this.links.forEach((l) => {
                l.classList.remove('on');
                l.removeAttribute('aria-current');
              });
              const a = map.get(en.target.id);
              if (a) {
                a.classList.add('on');
                a.setAttribute('aria-current', 'true');
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
        );
        heads.forEach((h) => this.io.observe(h));
      }
    }

    _apply() {
      if (!this.details) return;
      this.details.open = this.mq.matches;
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mq) this.mq.removeEventListener('change', this._apply);
    }
  }
  if (!customElements.get('svastika-page-toc')) {
    customElements.define('svastika-page-toc', SvastikaPageToc);
  }

  // <svastika-explore> — desktop nav arrows for the "Keep exploring" slider (mobile uses native swipe)
  class SvastikaExplore extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-explore-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-explore-prev]');
      this.next = this.querySelector('[data-explore-next]');
      this.nav = this.querySelector('.legal-explore__nav');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = () => Math.max(240, Math.round(this.track.clientWidth * 0.8));
      const go = (d) => this.track.scrollBy({ left: d * step(), behavior: this.reduce ? 'auto' : 'smooth' });
      if (this.prev) this.prev.addEventListener('click', () => go(-1));
      if (this.next) this.next.addEventListener('click', () => go(1));
      this._upd = this._update.bind(this);
      this.track.addEventListener('scroll', this._upd, { passive: true });
      window.addEventListener('resize', this._upd);
      this._update();
    }
    _update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth - 1;
      const scrollable = t.scrollWidth > t.clientWidth + 2;
      if (this.nav) this.nav.style.visibility = scrollable ? '' : 'hidden';
      if (this.prev) this.prev.disabled = t.scrollLeft <= 0;
      if (this.next) this.next.disabled = t.scrollLeft >= max;
    }
    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this._upd);
      window.removeEventListener('resize', this._upd);
    }
  }
  if (!customElements.get('svastika-explore')) {
    customElements.define('svastika-explore', SvastikaExplore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPremiumPDP extends HTMLElement {
    connectedCallback() {
      this.data = this._read();
      if (!this.data.variants.length) return;
      const first = this.data.variants.find((v) => v.available) || this.data.variants[0];
      this.currentId = first.id;
      this.qty = 1;
      this.adds = [...this.querySelectorAll('[data-svstk-add]')];
      this.initGallery();
      this._deepLink();
      this.initSize();
      this.initQty();
      this.initCart();
      this.initAccordion();
      this.initSticky();
      this.initReviewsLink();
      this.initDelivery();
      this.initZoom();
      this.initSrSync();   // DOWNSTREAM (Fastrr): hidden /cart/add form behind the Fastrr BUY NOW
      // Apply the initial variant's availability (handles a deep-linked ?variant= that lands on a
      // sold-out size). No-ops on a fully OOS product (no [data-svstk-add]).
      this.setAvailability(this.data.variants.find((x) => x.id === this.currentId));
    }

    /* ----- Delivery estimate — Gold & Silver .pdp-pin markup + India Post validation ----- */
    initDelivery() {
      const wrap = this.querySelector('[data-svstk-pincode]');
      if (!wrap) return;
      const input = wrap.querySelector('[data-pin-input]');
      const btn = wrap.querySelector('[data-pin-check]');
      const msg = wrap.querySelector('[data-pin-msg]');
      const err = wrap.querySelector('[data-pin-error]');
      if (!input || !btn || !msg) return;
      const dispatch = parseInt(wrap.dataset.pinDispatch, 10) || 5;
      const rng = parseInt(wrap.dataset.pinRange, 10);
      const span = isNaN(rng) ? 2 : rng;
      const mk = '<span class="pdp-pin__msg-mk"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 L10 17.5 L19 7"/></svg></span>';
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      // Region tiers from the app (data-svpe-delivery, same source as the Gold & Silver PDP). Absent → the fixed dispatch setting.
      let del = null;
      try { const j = wrap.querySelector('[data-svpe-delivery]'); if (j) del = JSON.parse(j.textContent); } catch (e) { del = null; }
      /* Mirrors <svastika-pdp>.resolveDeliveryTier (and the app's resolveTier): district beats state; empty match = catch-all. */
      const daysFor = (district, state) => {
        if (!del || !Array.isArray(del.tiers)) return dispatch;
        const d = (district || '').trim().toLowerCase();
        const s = (state || '').trim().toLowerCase();
        let tier = null;
        let catchAll = null;
        for (const t of del.tiers) {
          if (!t.match || !t.match.length) { if (!catchAll) catchAll = t; continue; }
          if (d && t.match.indexOf(d) !== -1) { tier = t; break; }
        }
        if (!tier) tier = del.tiers.find((t) => t.match && t.match.length && s && t.match.indexOf(s) !== -1) || catchAll;
        return tier ? tier.days : (del.fallbackDays || dispatch);
      };
      const showOk = (district, state) => {
        const days = daysFor(district, state);
        const loc = [district, state].filter(Boolean).join(', ') || 'your area';
        msg.innerHTML = mk + '<span class="pdp-pin__msg-text">Delivery to <strong>' + esc(loc) + '</strong> by ' + this._dateRange(days, days + span) + '</span>';
        if (err) err.hidden = true;
      };
      const showErr = (t) => { msg.innerHTML = ''; if (err) { err.textContent = t; err.hidden = false; } };
      const cache = {}; // pin -> { district, state }
      const run = () => {
        const pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
        if (pin.length !== 6) { showErr('Enter a valid 6-digit pincode'); return; }
        if (cache[pin]) { showOk(cache[pin].district, cache[pin].state); return; }
        msg.innerHTML = '<span class="pdp-pin__msg-text">Checking availability…</span>'; if (err) err.hidden = true;
        fetch('https://api.postalpincode.in/pincode/' + pin)
          .then((r) => r.json())
          .then((d) => {
            const po = d && d[0] && d[0].Status === 'Success' && d[0].PostOffice && d[0].PostOffice[0];
            if (!po) { showErr('We could not find that pincode — please recheck'); return; }
            cache[pin] = { district: po.District, state: po.State };
            showOk(po.District, po.State);
            if (window.svstkDeliveryPin) window.svstkDeliveryPin.remember(pin, po.District, po.State);
          })
          .catch(() => { showErr('Could not check right now — please retry'); });
      };
      btn.addEventListener('click', run);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      // Default estimate on load — NO network request (mirrors the Gold & Silver PDP). Setting format: "City, State".
      const def = wrap.dataset.pinLoc;
      if (def) { const parts = def.split(','); showOk((parts[0] || '').trim(), (parts[1] || '').trim()); }
      // Then the shopper's own place — last typed pincode (instant) or the nearest pincode to their IP
      // once the checker nears the viewport (snippets/pdp-pin-locate). Never over a pincode being typed.
      const defPin = input.value;
      const applyLocated = (p) => {
        if (document.activeElement === input || input.value !== defPin) return;
        input.value = p.pin;
        cache[p.pin] = { district: p.district, state: p.state };
        showOk(p.district, p.state);
        msg.classList.add('is-svstk-located');
      };
      const hook = () => window.svstkDeliveryPin.whenReady(wrap, applyLocated);
      if (window.svstkDeliveryPin) hook();
      else document.addEventListener('svstk:delivery-pin', () => { if (window.svstkDeliveryPin) hook(); }, { once: true });
    }

    /* today+minD … today+maxD, e.g. "21–23 Jun" / "29 Jun – 1 Jul" (span 0 → single date) */
    _dateRange(minD, maxD) {
      const a = new Date(); a.setDate(a.getDate() + minD);
      const b = new Date(); b.setDate(b.getDate() + maxD);
      const mo = (dt) => dt.toLocaleDateString('en-IN', { month: 'short' });
      if (minD === maxD) return a.getDate() + ' ' + mo(a);
      if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + mo(b);
      return a.getDate() + ' ' + mo(a) + ' – ' + b.getDate() + ' ' + mo(b);
    }

    /* Rating link → scroll to the Judge.me reviews widget when it's on the page. */
    initReviewsLink() {
      const link = this.querySelector('[data-reviews-link]');
      if (!link) return;
      link.addEventListener('click', (e) => {
        const target = document.querySelector('.jdgm-widget, .jdgm-all-reviews-rating, [data-svpe-reviews]');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    _read() {
      try {
        const d = JSON.parse(this.querySelector('[data-svpe-data]').textContent);
        /* `prices` / `compares` used to be TWO extra id-keyed maps in the JSON, which meant Liquid
           walked product.variants THREE times per render to serialise one variant list. The formatted
           money now rides on each variant (money / moneyCompare, still produced by the server-side
           `money` filter) and the maps are rebuilt here, so every consumer below is unchanged. */
        d.prices = {};
        d.compares = {};
        (d.variants || []).forEach((v) => { d.prices[v.id] = v.money; d.compares[v.id] = v.moneyCompare; });
        return d;
      } catch (e) { return { variants: [] }; }
    }

    /* Derive a CDN URL at width `w` from a slide's single parked base URL (…?v=…&width=1200).
       snippets/pdp-gallery.liquid ships ONE url per non-first slide (data-ph-base); every srcset
       rung and the 2048 zoom url are built here. Mirrors <svastika-pdp>.phUrl. svstk-7q2x9k3 */
    phUrl(base, w) {
      return base ? base.replace(/([?&])width=\d+/, '$1width=' + w) : '';
    }

    /* srcset for an on-demand gallery slide. MUST match `gwidths` in snippets/pdp-gallery.liquid. */
    phSrcset(base) {
      return [600, 900, 1200, 1600].map((w) => this.phUrl(base, w) + ' ' + w + 'w').join(', ');
    }

    /* ----- Gallery (mirrors <svastika-pdp>.initGallery: on-demand ensure + teleport/fade) ----- */
    initGallery() {
      const stage = this.querySelector('[data-gallery-stage]');
      if (!stage) return;
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      this._mediaIndex = new Map();
      slides.forEach((s, i) => { if (s.dataset.mediaId) this._mediaIndex.set(parseInt(s.dataset.mediaId, 10), i); });
      const ensure = (n) => {
        const s = slides[(n + slides.length) % slides.length];
        if (!s || s.dataset.phDone) return;
        const ph = s.querySelector('[data-ph-img]');
        const base = s.dataset.phBase;
        if (ph && base) {
          const img = document.createElement('img');
          img.className = 'pdpg-gallery__img';
          img.alt = s.dataset.zoomAlt || '';
          img.decoding = 'async';
          if (ph.dataset.phW) img.width = ph.dataset.phW;
          if (ph.dataset.phH) img.height = ph.dataset.phH;
          // Mobile branch is a deliberate DPR cap (170px, not the real box) so every mobile DPR
          // resolves to the 600w rung. MUST match the `sizes:` arg passed to pdp-gallery above.
          img.sizes = '(max-width: 980px) 170px, (min-width: 1410px) 648px, 46vw';
          img.srcset = this.phSrcset(base);
          img.src = this.phUrl(base, 1200);
          ph.replaceWith(img);
        }
        // Video poster: attach the shrunk (900px) poster only when the slide is reached (preload=none keeps bytes off until play).
        const vid = s.querySelector('video[data-ph-poster]');
        if (vid) { vid.poster = vid.dataset.phPoster; vid.removeAttribute('data-ph-poster'); }
        s.dataset.phDone = '1';
      };
      ensure(0);
      this._galleryIdx = 0; // read by the zoom viewer
      if (slides.length < 2) { this._galleryGo = () => {}; return; }
      let idx = 0, primed = false, navTimer;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gallery = stage.closest('.pdpg-gallery');
      const thumbsWrap = this.querySelector('[data-gallery-thumbs]');
      const prime = () => { if (primed) return; primed = true; ensure(1); ensure(-1); };
      const setActive = (n) => {
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === n));
        const t = thumbs[n];
        if (t && thumbsWrap) {
          const l = t.offsetLeft, r = l + t.offsetWidth;
          if (l < thumbsWrap.scrollLeft) thumbsWrap.scrollTo({ left: l - 8, behavior: reduce ? 'auto' : 'smooth' });
          else if (r > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) thumbsWrap.scrollTo({ left: r - thumbsWrap.clientWidth + 8, behavior: reduce ? 'auto' : 'smooth' });
        }
      };
      const go = (i, opts) => {
        opts = opts || {};
        const n = (i + slides.length) % slides.length;
        const far = Math.abs(n - idx) > 1;
        idx = n; this._galleryIdx = n;
        ensure(idx); ensure(idx + 1); ensure(idx - 1);
        this._navving = true;
        clearTimeout(navTimer);
        navTimer = setTimeout(() => { this._navving = false; }, 500);
        if (opts.smooth && !far && !reduce) {
          stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'smooth' });
        } else {
          if (!reduce && !opts.noFade && gallery) { gallery.classList.remove('is-swap'); void gallery.offsetWidth; gallery.classList.add('is-swap'); }
          stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'auto' });
        }
        setActive(idx);
      };
      this._galleryGo = (i, opts) => go(i, opts);
      this.querySelector('[data-gallery-prev]') && this.querySelector('[data-gallery-prev]').addEventListener('click', () => go(idx - 1, { smooth: true }));
      this.querySelector('[data-gallery-next]') && this.querySelector('[data-gallery-next]').addEventListener('click', () => go(idx + 1, { smooth: true }));
      thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.index, 10))));
      stage.addEventListener('pointerdown', prime, { once: true, passive: true });
      const pv = this.querySelector('[data-gallery-prev]'), nx = this.querySelector('[data-gallery-next]');
      if (pv) pv.addEventListener('pointerenter', prime, { once: true });
      if (nx) nx.addEventListener('pointerenter', prime, { once: true });
      let raf;
      stage.addEventListener('scroll', () => {
        if (this._navving) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const n = Math.round(stage.scrollLeft / stage.clientWidth);
          if (n !== idx) { idx = n; this._galleryIdx = n; ensure(idx); ensure(idx + 1); ensure(idx - 1); setActive(idx); }
        });
      }, { passive: true });
    }

    /* ----- Fullscreen zoom viewer — ported from the Gold & Silver <svastika-pdp>.initZoom ----- */
    initZoom() {
      const dlg = this.querySelector('[data-zoom-dialog]');
      const gStage = this.querySelector('[data-gallery-stage]');
      if (!dlg || !gStage) return;
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      // Slide 0 carries its 2048 url outright (data-zoom-src); every other image slide carries only the
      // parked base url and the 2048 is derived here — same string, one URL in the HTML instead of two.
      const items = slides.map((s, i) => ({ i, src: s.dataset.zoomSrc || this.phUrl(s.dataset.phBase, 2048), alt: s.dataset.zoomAlt || '' })).filter((x) => x.src);
      if (!items.length) return;
      const img = dlg.querySelector('[data-zoom-img]');
      const stageEl = dlg.querySelector('[data-zoom-stage]');
      const countEl = dlg.querySelector('[data-zoom-count]');
      const zoomBtn = this.querySelector('[data-gallery-zoom]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const ZMAX = 2.5, ZCEIL = 4;
      let pos = 0, scale = 1, tx = 0, ty = 0;
      const warmed = new Set();
      dlg.classList.toggle('is-solo', items.length < 2);
      const rect = () => stageEl.getBoundingClientRect();
      const applyT = () => { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; };
      const resetT = () => { scale = 1; tx = 0; ty = 0; img.style.transform = 'translate(0,0) scale(1)'; dlg.classList.remove('is-zoomed'); };
      const clamp = () => {
        const r = rect();
        const mx = Math.max(0, (img.clientWidth * scale - r.width) / 2);
        const my = Math.max(0, (img.clientHeight * scale - r.height) / 2);
        tx = Math.min(mx, Math.max(-mx, tx));
        ty = Math.min(my, Math.max(-my, ty));
      };
      const setZoom = (to, px, py) => {
        if (to <= 1.01) { resetT(); return; }
        const r = rect();
        const fx = (px == null ? r.left + r.width / 2 : px) - (r.left + r.width / 2);
        const fy = (py == null ? r.top + r.height / 2 : py) - (r.top + r.height / 2);
        const k = to / scale;
        tx = fx + (tx - fx) * k;
        ty = fy + (ty - fy) * k;
        scale = to;
        dlg.classList.add('is-zoomed');
        clamp(); applyT();
      };
      const warm = (p) => {
        const it = items[(p + items.length) % items.length];
        if (it && !warmed.has(it.i)) { warmed.add(it.i); const im = new Image(); im.decoding = 'async'; im.src = it.src; }
      };
      const render = () => {
        const it = items[pos];
        resetT();
        dlg.classList.add('is-loading');
        img.onload = () => dlg.classList.remove('is-loading');
        img.onerror = () => dlg.classList.remove('is-loading');
        img.alt = it.alt;
        img.src = it.src;                 // 2048 fetched ONLY here; cached by URL for re-open
        warmed.add(it.i);
        if (countEl) countEl.textContent = (pos + 1) + ' / ' + items.length;
        if (this._galleryGo) this._galleryGo(it.i, { noFade: true });
        warm(pos + 1); warm(pos - 1);
      };
      const goTo = (p) => { pos = (p + items.length) % items.length; render(); };
      const open = (galleryIdx) => {
        const p = items.findIndex((x) => x.i === galleryIdx);
        if (p < 0) return;                // slide isn't a zoomable image (e.g. video)
        pos = p;
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
        document.documentElement.classList.add('svstk-zoom-lock');
        render();
        if (reduce) dlg.classList.add('is-in');
        else { dlg.classList.remove('is-in'); void dlg.offsetWidth; dlg.classList.add('is-in'); }
        const cb = dlg.querySelector('[data-zoom-close]'); if (cb) cb.focus({ preventScroll: true });
      };
      this._openZoom = open;
      const close = () => {
        if (dlg.dataset.closing) return;
        dlg.dataset.closing = '1';
        dlg.classList.remove('is-in');
        const done = () => { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } document.documentElement.classList.remove('svstk-zoom-lock'); resetT(); delete dlg.dataset.closing; if (zoomBtn) zoomBtn.focus({ preventScroll: true }); };
        if (reduce) done(); else setTimeout(done, 260);
      };
      if (zoomBtn) zoomBtn.addEventListener('click', () => open(this._galleryIdx || 0));
      let sx = 0, sy = 0, st = 0, sMoved = false, sId = null;
      gStage.addEventListener('pointerdown', (e) => { sId = e.pointerId; sx = e.clientX; sy = e.clientY; st = Date.now(); sMoved = false; }, { passive: true });
      gStage.addEventListener('pointermove', (e) => { if (e.pointerId === sId && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) sMoved = true; }, { passive: true });
      gStage.addEventListener('pointerup', (e) => {
        if (e.pointerId !== sId || sMoved || Date.now() - st > 400) return;
        if (e.target.closest('video, .pdpg-gallery__arrow')) return;
        open(this._galleryIdx || 0);
      });
      const bind = (sel, fn) => { const el = dlg.querySelector(sel); if (el) el.addEventListener('click', fn); };
      bind('[data-zoom-close]', close);
      bind('[data-zoom-prev]', () => goTo(pos - 1));
      bind('[data-zoom-next]', () => goTo(pos + 1));
      dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
      dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') goTo(pos - 1); else if (e.key === 'ArrowRight') goTo(pos + 1); });
      const pts = new Map();
      let pan = null, pinch = null, lastTap = 0;
      const distp = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
      stageEl.addEventListener('pointerdown', (e) => {
        if (stageEl.setPointerCapture) stageEl.setPointerCapture(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2) { const a = [...pts.values()]; pinch = { d: distp(a[0], a[1]), s: scale, mx: (a[0].x + a[1].x) / 2, my: (a[0].y + a[1].y) / 2 }; pan = null; }
        else if (pts.size === 1) { pan = { x: e.clientX, y: e.clientY, tx, ty, t: Date.now(), moved: false, type: e.pointerType, target: e.target }; }
      });
      stageEl.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const a = [...pts.values()];
        if (pts.size === 2 && pinch) { const d = distp(a[0], a[1]); setZoom(Math.min(ZCEIL, Math.max(1, pinch.s * (d / pinch.d))), pinch.mx, pinch.my); }
        else if (pts.size === 1 && pan) {
          const dx = e.clientX - pan.x, dy = e.clientY - pan.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) pan.moved = true;
          if (scale > 1) { tx = pan.tx + dx; ty = pan.ty + dy; clamp(); applyT(); }
        }
      });
      const up = (e) => {
        const p = pan;
        pts.delete(e.pointerId);
        if (pts.size < 2) pinch = null;
        if (pts.size !== 0 || !p) return;
        pan = null;
        const dx = e.clientX - p.x, dy = e.clientY - p.y, quick = Date.now() - p.t < 300;
        if (!p.moved && quick) {
          if (p.target === img) {
            if (p.type === 'mouse') setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY);
            else { const now = Date.now(); if (now - lastTap < 300) { setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY); lastTap = 0; } else lastTap = now; }
          } else { close(); }
        } else if (scale <= 1.01 && quick) {
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) goTo(pos + (dx < 0 ? 1 : -1));
          else if (dy > 90 && dy > Math.abs(dx)) close();
        }
      };
      stageEl.addEventListener('pointerup', up);
      stageEl.addEventListener('pointercancel', up);
      stageEl.addEventListener('wheel', (e) => { e.preventDefault(); setZoom(Math.min(ZCEIL, Math.max(1, scale * (e.deltaY < 0 ? 1.18 : 0.85))), e.clientX, e.clientY); }, { passive: false });
    }

    _deepLink() {
      const m = location.search.match(/[?&]variant=(\d+)/);
      if (!m) return;
      const id = parseInt(m[1], 10);
      if (this.data.variants.some((v) => v.id === id)) { this.selectVariant(id, true); }
    }

    /* ----- Size / variant ----- */
    initSize() {
      this.querySelectorAll('[data-svpe-size]').forEach((btn) => {
        btn.addEventListener('click', () => { if (!btn.disabled) this.selectVariant(parseInt(btn.dataset.vid, 10)); });
      });
    }

    /* DOWNSTREAM (Fastrr): keep the hidden /cart/add form that wraps the Fastrr BUY NOW in step with
       the picker. shiprocketCheckoutEvents.buyProduct() reads that form for id + quantity, and this
       template has no product form of its own — without the sync it would buy the first variant. */
    syncSrForm() {
      const f = this.querySelector('[data-svpe-sr-variant]');
      if (!f) return;
      f.value = String(this.currentId);
      const q = this.querySelector('[data-svpe-sr-qty]');
      if (q) {
        const inp = this.querySelector('[data-svpe-qty-input]');
        q.value = String(Math.max(1, parseInt(inp && inp.value, 10) || this.qty || 1));
      }
    }

    /* Capture phase on the placeholder fires BEFORE the vendor button's inline onclick, so the form
       is authoritative at the moment of purchase whatever else changed on the page. */
    initSrSync() {
      const ph = this.querySelector('.shiprocket-headless[data-type="product"]');
      if (!ph) return;
      ph.addEventListener('click', () => this.syncSrForm(), true);
      this.syncSrForm();
    }

    selectVariant(id, instant) {
      const v = this.data.variants.find((x) => x.id === id);
      if (!v) return;
      this.currentId = id;
      this.syncSrForm();   // DOWNSTREAM (Fastrr): keep the headless BUY NOW on the chosen size
      this.querySelectorAll('[data-svpe-size]').forEach((b) => b.classList.toggle('is-selected', parseInt(b.dataset.vid, 10) === id));
      const money = (this.data.prices && this.data.prices[id]) || '';
      this.querySelectorAll('[data-svpe-price]').forEach((el) => { if (money) el.textContent = money; });
      // MRP + subtle discount (display only; cart/checkout stay authoritative).
      const cmpMoney = (this.data.compares && this.data.compares[id]) || '';
      const off = (v.compare && v.compare > v.price) ? Math.round((v.compare - v.price) / v.compare * 100) : 0;
      this.querySelectorAll('[data-svpe-compare]').forEach((el) => { if (off > 0) { el.textContent = cmpMoney; el.hidden = false; } else { el.hidden = true; } });
      this.querySelectorAll('[data-svpe-off]').forEach((el) => { if (off > 0) { el.textContent = off + '% off'; el.hidden = false; } else { el.hidden = true; } });
      const note = (v.title && v.title !== 'Default Title') ? v.title : '';
      const cm = v.cm ? ' · ' + v.cm : '';
      this.querySelectorAll('[data-svpe-sizenote]').forEach((el) => { el.textContent = note + cm; });
      this.querySelectorAll('[data-svpe-stickysub]').forEach((el) => { el.textContent = note; });
      // Dimensions carousel: buy-box selection scrolls to that size's slide (shared <svastika-dims>, one-way).
      this.querySelector('svastika-dims')?.goToVariant(id);
      const skuWrap = this.querySelector('[data-svpe-sku-wrap]');
      if (skuWrap) {
        if (v.sku) { const sv = skuWrap.querySelector('[data-svpe-sku]'); if (sv) sv.textContent = v.sku; skuWrap.hidden = false; }
        else { skuWrap.hidden = true; }
      }
      this.setAvailability(v);
      if (this._galleryGo && v.mediaId != null && this._mediaIndex && this._mediaIndex.has(v.mediaId)) {
        this._galleryGo(this._mediaIndex.get(v.mediaId), instant ? { noFade: true } : { smooth: true });
      }
    }

    /* Selected-size availability (per-variant OOS). No-ops on a fully OOS product (server-side Sold-out CTA,
       no [data-svstk-add]). Disables + relabels the add button(s) and hides Buy now for a sold-out size. */
    setAvailability(v) {
      const soldOut = v && v.available === false;
      const label = this.dataset.soldoutLabel || 'Sold out';
      (this.adds || []).forEach((btn) => {
        if (soldOut) {
          if (btn.dataset.availLabel == null) {
            const span = btn.querySelector('[data-svstk-add-label]');
            btn.dataset.availLabel = span ? span.textContent : btn.textContent;
          }
          btn.disabled = true;
          btn.classList.add('is-soldout');
          const span = btn.querySelector('[data-svstk-add-label]');
          if (span) { span.textContent = label; } else { btn.textContent = label; }
        } else if (btn.dataset.availLabel != null) {
          btn.disabled = false;
          btn.classList.remove('is-soldout');
          const span = btn.querySelector('[data-svstk-add-label]');
          if (span) { span.textContent = btn.dataset.availLabel; } else { btn.textContent = btn.dataset.availLabel; }
          delete btn.dataset.availLabel;
        }
      });
      this.querySelectorAll('.svpe-buynow, [data-svstk-buynow], [data-sticky-buy]').forEach((el) => { el.hidden = soldOut; });
    }

    /* ----- Qty (Gold & Silver .pdp-qty input) ----- */
    initQty() {
      this.qtyInput = this.querySelector('[data-svpe-qty-input]');
      const dec = this.querySelector('[data-svpe-dec]'), inc = this.querySelector('[data-svpe-inc]');
      const get = () => Math.max(1, parseInt(this.qtyInput && this.qtyInput.value, 10) || 1);
      const set = (n) => { this.qty = Math.max(1, n); if (this.qtyInput) this.qtyInput.value = this.qty; this.syncSrForm(); };
      set(1);
      if (dec) dec.addEventListener('click', () => set(get() - 1));
      if (inc) inc.addEventListener('click', () => set(get() + 1));
      if (this.qtyInput) this.qtyInput.addEventListener('change', () => set(get()));
    }

    /* ----- Cart (mirrors <svastika-pdp>: dispatch cart:add; drawer owns the mutation) ----- */
    initCart() {
      this.adds.forEach((btn) => btn.addEventListener('click', () => this.addToCart(btn)));
      document.addEventListener('cart:added', () => {
        if (!this._selfAdd) return;
        this._selfAdd = false;
        this.adds.forEach((btn) => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          const lbl = btn.querySelector('[data-svstk-add-label]');
          if (lbl) lbl.textContent = 'Added ✓';
          clearTimeout(btn._reset);
          btn._reset = setTimeout(() => {
            btn.classList.remove('is-added');
            if (lbl && btn.dataset.addLabel) lbl.textContent = btn.dataset.addLabel;
          }, 1800);
        });
      });
      // Fail-open partner to the above: when the cart engine cannot load, the drawer POSTs natively
      // and navigates to /cart — clear the spinner first so the button is never left on is-loading.
      document.addEventListener('cart:addfailed', () => {
        this._selfAdd = false;
        this.adds.forEach((btn) => { btn.classList.remove('is-loading'); clearTimeout(btn._reset); });
      });
      this.querySelectorAll('[data-svstk-buynow]').forEach((btn) => btn.addEventListener('click', () => this.buyNow(btn)));
      this.querySelectorAll('[data-sticky-buy]').forEach((btn) => btn.addEventListener('click', () => this.stickyBuy(btn)));
    }

    /* Sticky Buy now = the buy rail's own buy control, whatever is showing (a headless-checkout button rendered into a
       form in .svpe-actions when one is live, else our .svpe-buynow): one checkout decision for the page, as on the
       Gold & Silver PDP. Neither visible -> the native path. */
    stickyBuy(btn) {
      const live = this.liveBuyControl();
      if (live) { live.click(); return; }
      this.buyNow(btn);
    }
    liveBuyControl() {
      const host = this.querySelector('.svpe-actions');
      return host && [...host.querySelectorAll('form button, [data-svstk-buynow]')].find((el) => !el.disabled && el.offsetParent !== null && el.getBoundingClientRect().height > 0);
    }
    /* Mirror the live control's payment-method strip (its <img>) into the sticky Buy now. Called on every reveal;
       if the control has not rendered yet, awaitStickyPay() watches for it (same as the Gold & Silver twin). */
    syncStickyPay() {
      const slot = this.querySelector('[data-sticky-pay]');
      if (!slot) return;
      const live = this.liveBuyControl();
      const img = live && live.querySelector('img');
      if (!img || !img.currentSrc && !img.src) { slot.hidden = true; this.awaitStickyPay(); return; }
      const src = img.currentSrc || img.src;
      if (slot.dataset.src === src) { slot.hidden = false; return; }
      const copy = document.createElement('img');
      copy.src = src; copy.alt = ''; copy.decoding = 'async'; copy.loading = 'lazy';
      slot.replaceChildren(copy); slot.dataset.src = src; slot.hidden = false;
      this.stopStickyPayWait();
    }
    awaitStickyPay() {
      if (this._payWait) return;
      const host = this.querySelector('.svpe-actions');
      if (!host || !('MutationObserver' in window)) return;
      const bar = this.querySelector('[data-svstk-sticky]');
      let queued = false;
      const run = () => { queued = false; if (bar && bar.hidden) return; this.syncStickyPay(); };
      const mo = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(run); } });
      mo.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'style', 'class', 'hidden'] });
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this._payWait = { mo, timer: setTimeout(() => this.stopStickyPayWait(), 15000) };
    }
    stopStickyPayWait() {
      if (!this._payWait) return;
      this._payWait.mo.disconnect();
      clearTimeout(this._payWait.timer);
      this._payWait = null;
    }

    addToCart(btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      const v = this.data.variants.find((x) => x.id === this.currentId);
      const qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : (this.qty || 1);
      const items = [{ id: this.currentId, quantity: qty, properties: {} }];
      if (v) {
        items[0].price = v.price;
        items[0].display = {
          title: this.data.title || '',
          variant: (v.title && v.title !== 'Default Title') ? v.title : '',
          image: this.data.image || '',
          price: v.price,
          mrp: v.compare || 0,   // compare-at (MRP) → the cart line's strike + "% off" badge land with the optimistic line
          vol: '',
          product_id: this.data.product_id || 0
        };
      }
      this._selfAdd = true;
      btn.classList.add('is-loading');
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: items } }));
    }

    buyNow(btn) {
      const qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : (this.qty || 1);
      const items = [{ id: this.currentId, quantity: qty }];
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then((r) => r.json()).then(() => { window.location.href = '/checkout'; })
        .catch(() => { window.location.href = '/cart'; });
    }

    /* ----- Details accordion (single-open) ----- */
    initAccordion() {
      const items = [...this.querySelectorAll('[data-acc-item]')];
      items.forEach((item) => {
        const btn = item.querySelector('[data-acc-btn]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const open = item.classList.contains('is-open');
          items.forEach((o) => { o.classList.remove('is-open'); const b = o.querySelector('[data-acc-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); });
          if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
    }

    /* ----- Sticky bar (mirrors <svastika-pdp>.initSticky) ----- */
    initSticky() {
      const bar = this.querySelector('[data-svstk-sticky]');
      const anchor = this.querySelector('[data-buy-cta]');
      if (!bar || !anchor) return;
      const setOffset = () => {
        const nav = document.querySelector('svastika-bottom-nav');
        const visible = nav && getComputedStyle(nav).display !== 'none' && nav.offsetHeight > 0;
        bar.style.bottom = (visible ? nav.offsetHeight : 0) + 'px';
      };
      setOffset();
      window.addEventListener('resize', setOffset, { passive: true });
      // IO is the only path where it exists; the scroll listener is a true no-IO fallback. Registering
      // both meant a getBoundingClientRect() (forced layout) on every scroll tick for a value IO had.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { bar.hidden = en.isIntersecting || en.boundingClientRect.top > 0; if (!bar.hidden) this.syncStickyPay(); });
        }, { threshold: 0 });
        /* Full-viewport root (2026-10-03). The old rootMargin '0px 0px -100% 0px' shrank the root to a zero-height line at
           the top of the viewport; the CTA crossing that line is "not intersecting" on BOTH sides, so no entry fired and
           the bar never appeared after a fast or long scroll. Now the CTA leaving the viewport is a real state change:
           shown only once it has gone ABOVE the fold (top < 0), as before. svstk-7q2x9k3 */
        io.observe(anchor);
      } else {
        let ticking = false;
        const measure = () => { ticking = false; const r = anchor.getBoundingClientRect(); bar.hidden = r.bottom > 8; if (!bar.hidden) this.syncStickyPay(); };
        const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(measure); };
        window.addEventListener('scroll', onScroll, { passive: true });
        measure();
      }
    }
  }
  if (!customElements.get('svastika-premium-pdp')) customElements.define('svastika-premium-pdp', SvastikaPremiumPDP);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPdp extends HTMLElement {
    connectedCallback() {
      this.data = this.readData();
      this.form = this.querySelector('form.pdp__buy') || this.querySelector('form');
      this.idInput = this.querySelector('[data-svstk-id]');
      this.initGallery();
      this.initZoom();
      this.initVariants();
      this.initQty();
      this.initGift();
      this.initCart();
      this.initSticky();
      this.initPincode();
      this.initModals();
      this.initLadder();
      // Dimensions carousel is now the self-contained <svastika-dims> element (snippets/pdp-dimensions.liquid);
      // selectVariant() drives it via this.querySelector('svastika-dims')?.goToVariant(id) — no init here.
      // Apply the initial variant's availability now that this.adds exists (handles a deep-linked
      // ?variant= that lands on a sold-out size). No-ops on a fully OOS product (no [data-svstk-add]).
      const cv0 = this.data.variants.find((x) => x.id === this.currentId);
      if (cv0) this.setAvailability(cv0);
    }

    readData() {
      try { return JSON.parse(this.querySelector('[data-svstk-data]').textContent); }
      catch (e) { return { variants: [], zones: [] }; }
    }

    money(cents) {
      return (this.data.moneySymbol || '₹') + Math.round(cents / 100).toLocaleString('en-IN');
    }

    /* Derive a CDN URL at width `w` from a slide's single parked base URL (…?v=…&width=1200).
       snippets/pdp-gallery.liquid ships ONE url per non-first slide (data-ph-base); every srcset
       rung and the 2048 zoom url are built here instead of being written out ten times in HTML.
       Byte-identical to what the old Liquid emitted (same protocol-relative form). svstk-7q2x9k3 */
    phUrl(base, w) {
      return base ? base.replace(/([?&])width=\d+/, '$1width=' + w) : '';
    }

    /* srcset for an on-demand gallery slide. MUST match `gwidths` in snippets/pdp-gallery.liquid. */
    phSrcset(base) {
      return [600, 900, 1200, 1600].map((w) => this.phUrl(base, w) + ' ' + w + 'w').join(', ');
    }

    /* ----- Gallery ----- */
    initGallery() {
      const stage = this.querySelector('[data-gallery-stage]');
      if (!stage) return;
      this._galleryIdx = 0; // current slide index, read by the zoom viewer
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const dots = [...this.querySelectorAll('[data-gallery-dot]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      // media id -> slide index, so selecting a variant can scroll to its assigned image.
      this._mediaIndex = new Map();
      slides.forEach((s, i) => { if (s.dataset.mediaId) this._mediaIndex.set(parseInt(s.dataset.mediaId, 10), i); });
      // On-demand media: a slide's image/poster is fetched ONLY when it (or an
      // adjacent slide) becomes active — nothing loads in the background.
      const ensure = (n) => {
        const s = slides[(n + slides.length) % slides.length];
        if (!s || s.dataset.phDone) return;
        const ph = s.querySelector('[data-ph-img]');
        const base = s.dataset.phBase;
        if (ph && base) {
          const img = document.createElement('img');
          img.className = 'pdpg-gallery__img';
          img.alt = s.dataset.zoomAlt || '';
          img.decoding = 'async';
          if (ph.dataset.phW) img.width = ph.dataset.phW;
          if (ph.dataset.phH) img.height = ph.dataset.phH;
          // Mobile branch is a deliberate DPR cap (170px, not the real ~378px box) so every
          // mobile DPR resolves to the 600w rung. MUST match gsizes in snippets/pdp-gallery.liquid.
          img.sizes = '(max-width: 900px) 170px, 46vw';
          img.srcset = this.phSrcset(base);
          img.src = this.phUrl(base, 1200);
          ph.replaceWith(img);
        }
        const vid = s.querySelector('video[data-ph-poster]');
        if (vid) { vid.poster = vid.dataset.phPoster; vid.removeAttribute('data-ph-poster'); }
        s.dataset.phDone = '1';
      };
      ensure(0); // covers a video-first product (image-first slide 0 is already eager)
      if (slides.length < 2) return;
      let idx = 0;
      let primed = false;
      let navTimer;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gallery = stage.closest('.pdpg-gallery');
      const thumbsWrap = this.querySelector('[data-gallery-thumbs]');
      const prime = () => { if (primed) return; primed = true; ensure(1); ensure(-1); };
      // Reflect state on dots/thumbs + keep the active thumb visible WITHOUT scrolling the page.
      const setActive = (n) => {
        this._galleryIdx = n;
        dots.forEach((d, i) => d.classList.toggle('is-active', i === n));
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === n));
        const t = thumbs[n];
        if (t && thumbsWrap) {
          const l = t.offsetLeft, r = l + t.offsetWidth;
          if (l < thumbsWrap.scrollLeft) thumbsWrap.scrollTo({ left: l - 8, behavior: reduce ? 'auto' : 'smooth' });
          else if (r > thumbsWrap.scrollLeft + thumbsWrap.clientWidth) thumbsWrap.scrollTo({ left: r - thumbsWrap.clientWidth + 8, behavior: reduce ? 'auto' : 'smooth' });
        }
      };
      // go(i, {smooth, noFade}): a 1-step arrow move animates; a FAR jump (variant pick /
      // thumbnail / dot / wrap-around) teleports + a quick fade so the gallery never scrolls
      // THROUGH every image in between — that scroll-through (with images injecting mid-scroll)
      // was the glitch. idx is committed up-front and _navving guards the swipe-sync listener
      // so a programmatic move can't fight the scroll-snap track.
      const go = (i, { smooth = false, noFade = false } = {}) => {
        const n = (i + slides.length) % slides.length;
        const far = Math.abs(n - idx) > 1;
        idx = n;
        ensure(idx); ensure(idx + 1); ensure(idx - 1);
        this._navving = true;
        clearTimeout(navTimer);
        navTimer = setTimeout(() => { this._navving = false; }, 500);
        if (smooth && !far && !reduce) {
          stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'smooth' });
        } else {
          if (!reduce && !noFade && gallery) { gallery.classList.remove('is-swap'); void gallery.offsetWidth; gallery.classList.add('is-swap'); }
          stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'auto' });
        }
        setActive(idx);
      };
      this._galleryGo = (i, opts) => go(i, opts); // selectVariant() drives the gallery to a variant's image
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(idx - 1, { smooth: true }));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(idx + 1, { smooth: true }));
      dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.index, 10))));
      thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.index, 10))));
      // Warm the immediate neighbours on first navigation INTENT (press-to-swipe / arrow hover)
      // so the first move is smooth — still interaction-gated, never a page-load background fetch.
      stage.addEventListener('pointerdown', prime, { once: true, passive: true });
      this.querySelector('[data-gallery-prev]')?.addEventListener('pointerenter', prime, { once: true });
      this.querySelector('[data-gallery-next]')?.addEventListener('pointerenter', prime, { once: true });
      // Keep dots/thumbs in sync when the USER swipes (programmatic moves are guarded out).
      let raf;
      stage.addEventListener('scroll', () => {
        if (this._navving) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const n = Math.round(stage.scrollLeft / stage.clientWidth);
          if (n !== idx) { idx = n; ensure(idx); ensure(idx + 1); ensure(idx - 1); setActive(idx); }
        });
      }, { passive: true });
    }

    /* ----- Fullscreen zoom viewer -----
       High-res (2048) image is fetched ONLY when the viewer opens for that slide, then
       cached by URL (browser HTTP cache) so re-open / paging back is instant; ±1 neighbours
       are warmed only AFTER open. Nothing here touches page load / LCP. Top-layer <dialog>
       covers the header + sticky bars; body scroll is locked while open. */
    initZoom() {
      const dlg = this.querySelector('[data-zoom-dialog]');
      const gStage = this.querySelector('[data-gallery-stage]');
      if (!dlg || !gStage) return;
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      // Slide 0 carries its 2048 url outright (data-zoom-src); every other image slide carries only the
      // parked base url and the 2048 is derived here — same string, one URL in the HTML instead of two.
      const items = slides.map((s, i) => ({ i, src: s.dataset.zoomSrc || this.phUrl(s.dataset.phBase, 2048), alt: s.dataset.zoomAlt || '' })).filter((x) => x.src);
      if (!items.length) return;
      const img = dlg.querySelector('[data-zoom-img]');
      const stageEl = dlg.querySelector('[data-zoom-stage]');
      const countEl = dlg.querySelector('[data-zoom-count]');
      const zoomBtn = this.querySelector('[data-gallery-zoom]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const ZMAX = 2.5, ZCEIL = 4;
      let pos = 0, scale = 1, tx = 0, ty = 0;
      const warmed = new Set();
      dlg.classList.toggle('is-solo', items.length < 2);

      const rect = () => stageEl.getBoundingClientRect();
      const applyT = () => { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; };
      const resetT = () => { scale = 1; tx = 0; ty = 0; img.style.transform = 'translate(0,0) scale(1)'; dlg.classList.remove('is-zoomed'); };
      const clamp = () => {
        const r = rect();
        const mx = Math.max(0, (img.clientWidth * scale - r.width) / 2);
        const my = Math.max(0, (img.clientHeight * scale - r.height) / 2);
        tx = Math.min(mx, Math.max(-mx, tx));
        ty = Math.min(my, Math.max(-my, ty));
      };
      // Zoom to `to`, keeping the focal point (screen px) stationary. t' = f - (f - t)*(to/scale).
      const setZoom = (to, px, py) => {
        if (to <= 1.01) { resetT(); return; }
        const r = rect();
        const fx = (px == null ? r.left + r.width / 2 : px) - (r.left + r.width / 2);
        const fy = (py == null ? r.top + r.height / 2 : py) - (r.top + r.height / 2);
        const k = to / scale;
        tx = fx + (tx - fx) * k;
        ty = fy + (ty - fy) * k;
        scale = to;
        dlg.classList.add('is-zoomed');
        clamp(); applyT();
      };
      const warm = (p) => {
        const it = items[(p + items.length) % items.length];
        if (it && !warmed.has(it.i)) { warmed.add(it.i); const im = new Image(); im.decoding = 'async'; im.src = it.src; }
      };
      const render = () => {
        const it = items[pos];
        resetT();
        dlg.classList.add('is-loading');
        img.onload = () => dlg.classList.remove('is-loading');
        img.onerror = () => dlg.classList.remove('is-loading');
        img.alt = it.alt;
        img.src = it.src;               // 2048 fetched ONLY here; cached by URL for re-open
        warmed.add(it.i);
        if (countEl) countEl.textContent = (pos + 1) + ' / ' + items.length;
        if (this._galleryGo) this._galleryGo(it.i, { noFade: true }); // keep the gallery in sync for on-close
        warm(pos + 1); warm(pos - 1);
      };
      const goTo = (p) => { pos = (p + items.length) % items.length; render(); };
      const open = (galleryIdx) => {
        const p = items.findIndex((x) => x.i === galleryIdx);
        if (p < 0) return;             // slide isn't a zoomable image (e.g. video)
        pos = p;
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
        document.documentElement.classList.add('svstk-zoom-lock');
        render();
        if (reduce) dlg.classList.add('is-in');
        else { dlg.classList.remove('is-in'); void dlg.offsetWidth; dlg.classList.add('is-in'); }
        dlg.querySelector('[data-zoom-close]')?.focus({ preventScroll: true });
      };
      this._openZoom = open;
      const close = () => {
        if (dlg.dataset.closing) return;   // guard against double-close
        dlg.dataset.closing = '1';
        dlg.classList.remove('is-in');     // opacity 1 → 0 (fade out)
        const done = () => { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } document.documentElement.classList.remove('svstk-zoom-lock'); resetT(); delete dlg.dataset.closing; zoomBtn?.focus({ preventScroll: true }); };
        // Deterministic wait for the fade, NOT transitionend: a child button's `transition:background`
        // bubbles a transitionend to the dialog and would cut the fade-out short (the weird abrupt close).
        if (reduce) done(); else setTimeout(done, 260);
      };

      // Triggers: the gold button + a movement-guarded tap on the active gallery image.
      zoomBtn?.addEventListener('click', () => open(this._galleryIdx || 0));
      let sx = 0, sy = 0, st = 0, sMoved = false, sId = null;
      gStage.addEventListener('pointerdown', (e) => { sId = e.pointerId; sx = e.clientX; sy = e.clientY; st = Date.now(); sMoved = false; }, { passive: true });
      gStage.addEventListener('pointermove', (e) => { if (e.pointerId === sId && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) sMoved = true; }, { passive: true });
      gStage.addEventListener('pointerup', (e) => {
        if (e.pointerId !== sId || sMoved || Date.now() - st > 400) return;
        if (e.target.closest('video, .pdpg-gallery__arrow')) return;
        open(this._galleryIdx || 0);
      });

      // Viewer chrome
      dlg.querySelector('[data-zoom-close]')?.addEventListener('click', close);
      dlg.querySelector('[data-zoom-prev]')?.addEventListener('click', () => goTo(pos - 1));
      dlg.querySelector('[data-zoom-next]')?.addEventListener('click', () => goTo(pos + 1));
      dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
      dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') goTo(pos - 1); else if (e.key === 'ArrowRight') goTo(pos + 1); });

      // Gestures on the image stage: pinch-zoom, drag-pan, tap/dbl-tap, wheel, swipe.
      const pts = new Map();
      let pan = null, pinch = null, lastTap = 0;
      const distp = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
      stageEl.addEventListener('pointerdown', (e) => {
        stageEl.setPointerCapture?.(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2) { const a = [...pts.values()]; pinch = { d: distp(a[0], a[1]), s: scale, mx: (a[0].x + a[1].x) / 2, my: (a[0].y + a[1].y) / 2 }; pan = null; }
        else if (pts.size === 1) { pan = { x: e.clientX, y: e.clientY, tx, ty, t: Date.now(), moved: false, type: e.pointerType, target: e.target }; }
      });
      stageEl.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const a = [...pts.values()];
        if (pts.size === 2 && pinch) { const d = distp(a[0], a[1]); setZoom(Math.min(ZCEIL, Math.max(1, pinch.s * (d / pinch.d))), pinch.mx, pinch.my); }
        else if (pts.size === 1 && pan) {
          const dx = e.clientX - pan.x, dy = e.clientY - pan.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) pan.moved = true;
          if (scale > 1) { tx = pan.tx + dx; ty = pan.ty + dy; clamp(); applyT(); }
        }
      });
      const up = (e) => {
        const p = pan;
        pts.delete(e.pointerId);
        if (pts.size < 2) pinch = null;
        if (pts.size !== 0 || !p) return;
        pan = null;
        const dx = e.clientX - p.x, dy = e.clientY - p.y, quick = Date.now() - p.t < 300;
        if (!p.moved && quick) {
          if (p.target === img) {
            if (p.type === 'mouse') setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY);
            else { const now = Date.now(); if (now - lastTap < 300) { setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY); lastTap = 0; } else lastTap = now; }
          } else { close(); }              // tap on the dark letterbox → close
        } else if (scale <= 1.01 && quick) {
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) goTo(pos + (dx < 0 ? 1 : -1));
          else if (dy > 90 && dy > Math.abs(dx)) close();   // swipe down → close
        }
      };
      stageEl.addEventListener('pointerup', up);
      stageEl.addEventListener('pointercancel', up);
      stageEl.addEventListener('wheel', (e) => { e.preventDefault(); setZoom(Math.min(ZCEIL, Math.max(1, scale * (e.deltaY < 0 ? 1.18 : 0.85))), e.clientX, e.clientY); }, { passive: false });
    }

    /* ----- Variants ----- */
    initVariants() {
      this.cards = [...this.querySelectorAll('[data-svstk-variant]')];
      this.stickySelect = this.querySelector('[data-svstk-sticky-select]');
      const select = (id) => this.selectVariant(id);
      this.cards.forEach((c) => c.addEventListener('click', () => {
        if (c.getAttribute('aria-disabled') === 'true') return;
        select(parseInt(c.dataset.svstkVariant, 10));
      }));
      this.stickySelect?.addEventListener('change', () => select(parseInt(this.stickySelect.value, 10)));
      this.currentId = parseInt(this.idInput?.value, 10) || (this.data.variants[0] && this.data.variants[0].id);
      const cv = this.data.variants.find((x) => x.id === this.currentId);
      if (cv) this.updateOffersLabel(cv);
      // Deep-linked (?variant=) or first-available variant whose image isn't slide 0:
      // jump there instantly (no load-time animation; common first-variant case = slide 0 = no jump, LCP intact).
      if (cv && cv.mediaId != null && this._galleryGo && this._mediaIndex && this._mediaIndex.has(cv.mediaId)) {
        const t = this._mediaIndex.get(cv.mediaId);
        if (t > 0) this._galleryGo(t, { noFade: true });
      }
    }

    selectVariant(id) {
      const v = this.data.variants.find((x) => x.id === id);
      if (!v) return;
      this.currentId = id;
      if (this.idInput) this.idInput.value = id;
      this.cards.forEach((c) => c.classList.toggle('is-active', parseInt(c.dataset.svstkVariant, 10) === id));
      if (this.stickySelect) this.stickySelect.value = id;
      // Price
      this.querySelectorAll('[data-svstk-price]').forEach((el) => { el.textContent = this.money(v.price); });
      const cmp = this.querySelector('[data-svstk-compare]');
      const off = this.querySelector('[data-svstk-off]');
      if (cmp && off) {
        if (v.compare > v.price) {
          cmp.textContent = this.money(v.compare); cmp.hidden = false;
          off.textContent = Math.round((v.compare - v.price) * 100 / v.compare) + '% off'; off.hidden = false;
        } else { cmp.hidden = true; off.hidden = true; }
      }
      // Dimensions carousel: buy-box selection scrolls to that size's slide (one-way; swipe never selects).
      // The carousel is the shared <svastika-dims> element (snippets/pdp-dimensions.liquid).
      this.querySelector('svastika-dims')?.goToVariant(id);
      // Per-variant SKU (hides when the selected size has no SKU)
      const skuWrap = this.querySelector('[data-svstk-sku-wrap]');
      if (skuWrap) {
        if (v.sku) { const sv = skuWrap.querySelector('[data-svstk-sku]'); if (sv) sv.textContent = v.sku; skuWrap.hidden = false; }
        else { skuWrap.hidden = true; }
      }
      this.updateOffersLabel(v);
      this.updateSubtotal();
      this.renderLadder();
      this.setAvailability(v);
      // Drive the gallery to this variant's assigned image (smooth; instant under reduced-motion).
      if (v.mediaId != null && this._galleryGo && this._mediaIndex && this._mediaIndex.has(v.mediaId)) {
        this._galleryGo(this._mediaIndex.get(v.mediaId));
      }
    }

    /* Selected-variant availability (per-variant OOS). Only runs when the PRODUCT has stock — a fully
       out-of-stock product renders a server-side "Sold out" CTA with no [data-svstk-add], so this no-ops.
       Disables + relabels the add button(s) and hides Buy now for a sold-out size; restores for an in-stock one. */
    setAvailability(v) {
      const soldOut = v && v.available === false;
      const label = this.dataset.soldoutLabel || 'Sold out';
      (this.adds || []).forEach((btn) => {
        if (soldOut) {
          if (btn.dataset.availLabel == null) {
            const span = btn.querySelector('[data-svstk-add-label]');
            btn.dataset.availLabel = span ? span.textContent : btn.textContent;
          }
          btn.disabled = true;
          btn.classList.add('is-soldout');
          const span = btn.querySelector('[data-svstk-add-label]');
          if (span) { span.textContent = label; } else { btn.textContent = label; }
        } else if (btn.dataset.availLabel != null) {
          btn.disabled = false;
          btn.classList.remove('is-soldout');
          const span = btn.querySelector('[data-svstk-add-label]');
          if (span) { span.textContent = btn.dataset.availLabel; } else { btn.textContent = btn.dataset.availLabel; }
          delete btn.dataset.availLabel;
        }
      });
      // Buy now (payment button container + sticky buy button) is meaningless for a sold-out variant.
      this.querySelectorAll('.pdp-buy__now, [data-svstk-buynow], [data-sticky-buy]').forEach((el) => { el.hidden = soldOut; });
    }

    /* "Get it for ₹X with offers" — best precomputed per-variant price, else the fallback label. */
    updateOffersLabel(v) {
      const el = this.querySelector('[data-svstk-offers-label]');
      if (!el) return;
      const pp = el.dataset.prepaidPct;
      if (v && v.bestPrice != null) {
        const fs = el.dataset.freeShip ? ' + free shipping' : '';
        const how = pp ? pp + '% prepaid' + (v.bestCoupon ? ' + coupon' : ' off') : 'offers';
        el.innerHTML = 'Get it for <strong>' + this.money(v.bestPrice) + '</strong> with ' + how + fs;
      } else {
        el.textContent = el.dataset.fallback || '';
      }
      /* Dialog summary mirrors the same breakdown: "₹X · 5% prepaid + best coupon". */
      const sum = this.querySelector('[data-svstk-offer-sum]');
      if (sum) {
        sum.hidden = !(v && v.bestPrice != null);
        if (!sum.hidden) {
          sum.querySelector('[data-svstk-offer-sum-price]').textContent = this.money(v.bestPrice);
          sum.querySelector('[data-svstk-offer-sum-how]').textContent = pp
            ? pp + '% prepaid' + (v.bestCoupon ? ' + best coupon' : ' discount')
            : 'with the best coupon';
        }
      }
    }

    /* ----- Quantity ----- */
    initQty() {
      this.qtyInput = this.querySelector('[data-qty-input]');
      const clamp = () => { let n = parseInt(this.qtyInput.value, 10); if (!n || n < 1) n = 1; this.qtyInput.value = n; this.updateSubtotal(); };
      this.querySelector('[data-qty-dec]')?.addEventListener('click', () => { this.qtyInput.value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) - 1); this.updateSubtotal(); });
      this.querySelector('[data-qty-inc]')?.addEventListener('click', () => { this.qtyInput.value = (parseInt(this.qtyInput.value, 10) || 1) + 1; this.updateSubtotal(); });
      this.qtyInput?.addEventListener('change', clamp);
    }

    /* ----- Gift add-ons ----- */
    initGift() {
      this.addons = [...this.querySelectorAll('[data-svstk-addon]')];
      this.addons.forEach((a) => a.addEventListener('change', () => this.updateSubtotal()));
    }

    updateSubtotal() {
      this.renderLadderNudge();
      const note = this.querySelector('[data-svstk-subtotal]');
      if (!note) return;
      const v = this.data.variants.find((x) => x.id === this.currentId);
      if (!v) return;
      const qty = parseInt(this.qtyInput?.value, 10) || 1;
      let total = v.price * qty;
      let extras = 0;
      this.addons.forEach((a) => { if (a.checked) extras += (parseInt(a.dataset.addonPrice, 10) || 0); });
      if (extras > 0) { note.hidden = false; note.textContent = 'Subtotal: ' + this.money(total + extras) + ' (incl. add-ons)'; }
      else { note.hidden = true; }
    }

    /* ----- Volume ladder ("Buy more, save more") — display-only; mirrors the checkout Function (highest tier whose min ≤ qty). Recomputes per-unit ₹ from the active variant price; the discount itself auto-applies server-side. ----- */
    initLadder() {
      const vol = this.data.volume;
      if (!vol || !vol.tiers || !vol.tiers.length) return;
      this.grid = this.querySelector('[data-svstk-ladder]');
      // Whole-card selection: tapping a tier sets the quantity to that tier's minimum qualifying qty.
      this.grid?.addEventListener('click', (e) => {
        const card = e.target.closest('[data-svstk-tier]');
        if (!card) return;
        const q = parseInt(card.dataset.tierQty, 10) || 1;
        if (this.qtyInput && this.qtyInput.value !== String(q)) {
          this.qtyInput.value = q;
          this.bumpQty();
        }
        this.updateSubtotal();
        this.markSelected();
      });
      this.renderLadder();
    }

    tierPerUnit(price, tier) {
      const off = tier.type === 'amount' ? tier.value * 100 : Math.round(price * tier.value / 100);
      return Math.max(0, price - off);
    }

    /* The tier the current quantity falls into (highest min ≤ qty), else 1 (base). Mirrors the checkout Function. */
    selectedTierQty() {
      const vol = this.data.volume;
      if (!vol) return 1;
      const qty = parseInt(this.qtyInput?.value, 10) || 1;
      let sel = 1;
      vol.tiers.forEach((t) => { if (qty >= t.min) sel = t.min; });
      return sel;
    }

    markSelected() {
      if (!this.grid) return;
      const sel = this.selectedTierQty();
      this.grid.querySelectorAll('[data-svstk-tier]').forEach((c) => {
        const on = (parseInt(c.dataset.tierQty, 10) || 1) === sel;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    bumpQty() {
      const w = this.querySelector('[data-svstk-qty]');
      if (!w) return;
      w.classList.remove('is-bumped');
      void w.offsetWidth;
      w.classList.add('is-bumped');
    }

    renderLadder() {
      const vol = this.data.volume;
      if (!vol || !this.grid) return;
      const v = this.data.variants.find((x) => x.id === this.currentId);
      if (!v) return;
      const price = v.price;
      const tiers = vol.tiers;
      const firstMin = tiers[0].min;
      const baseLabel = firstMin <= 2 ? '1 piece' : '1–' + (firstMin - 1) + ' pcs';
      let html = '<button type="button" class="pdp-bulk__tier" data-svstk-tier data-tier-qty="1" aria-pressed="false" aria-label="Buy 1 at ' + this.money(price) + ' each">' +
        '<span class="pdp-bulk__qty">' + baseLabel + '</span><span class="pdp-bulk__per">' + this.money(price) +
        '<span class="pdp-bulk__pc"> /pc</span></span><span class="pdp-bulk__save pdp-bulk__save--muted">Standard</span></button>';
      tiers.forEach((t, i) => {
        const pu = this.tierPerUnit(price, t);
        const save = Math.round((1 - pu / price) * 100);
        const last = i === tiers.length - 1;
        const range = last ? (t.min + '+ pcs') : (t.min + '–' + (tiers[i + 1].min - 1) + ' pcs');
        const badge = t.highlight ? '<span class="pdp-bulk__badge">' + this.esc(t.label || 'Best value') + '</span>' : '';
        html += '<button type="button" class="pdp-bulk__tier' + (t.highlight ? ' is-best' : '') + '" data-svstk-tier data-tier-qty="' + t.min +
          '" aria-pressed="false" aria-label="Buy ' + t.min + ' or more at ' + this.money(pu) + ' each, save ' + save + '%">' + badge +
          '<span class="pdp-bulk__qty">' + range + '</span><span class="pdp-bulk__per">' + this.money(pu) +
          '<span class="pdp-bulk__pc"> /pc</span></span><span class="pdp-bulk__save">Save ' + save + '%</span></button>';
      });
      this.grid.innerHTML = html;
      this.markSelected();
      this.renderLadderNudge();
    }

    renderLadderNudge() {
      const vol = this.data.volume;
      const el = this.querySelector('[data-svstk-ladder-nudge]');
      if (!vol || !el) return;
      const v = this.data.variants.find((x) => x.id === this.currentId);
      if (!v) return;
      const price = v.price;
      const qty = parseInt(this.qtyInput?.value, 10) || 1;
      const next = vol.tiers.find((t) => t.min > qty);
      const txt = el.querySelector('[data-nudge-text]');
      if (next) {
        const pu = this.tierPerUnit(price, next);
        const save = Math.round((1 - pu / price) * 100);
        const need = next.min - qty;
        if (txt) txt.textContent = 'Add ' + need + ' more ' + (need === 1 ? 'piece' : 'pieces') + ' and save ' + save + '% on each';
        el.hidden = false;
      } else if (qty >= vol.tiers[0].min) {
        if (txt) txt.textContent = "You're getting the best per-piece price 🎉";
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    esc(s) {
      return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    }

    /* ----- Add to cart (dispatches cart:add → the drawer owns mutation + auto-open) ----- */
    initCart() {
      this.adds = [...this.querySelectorAll('[data-svstk-add]')];
      this.adds.forEach((btn) => {
        const lbl = btn.querySelector('[data-svstk-add-label]');
        if (lbl) btn.dataset.addLabel = lbl.textContent;
        btn.addEventListener('click', (e) => {
          if (btn.type === 'submit') { e.preventDefault(); }
          this.addToCart(btn);
        });
      });
      // When the drawer confirms the add, flip the button to its success state, then it resets.
      document.addEventListener('cart:added', () => {
        // Only react to an add THIS product page initiated — NOT every cart:added the drawer fires for in-drawer
        // gift toggles, upsells, or coupon-driven adds (that made the PDP button flash on all cart activity).
        if (!this._selfAdd) return;
        this._selfAdd = false;
        this.adds.forEach((btn) => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          const lbl = btn.querySelector('[data-svstk-add-label]');
          if (lbl) lbl.textContent = 'Added ✓';
          clearTimeout(btn._reset);
          btn._reset = setTimeout(() => {
            btn.classList.remove('is-added');
            if (lbl && btn.dataset.addLabel) lbl.textContent = btn.dataset.addLabel;
          }, 1800);
        });
      });
      // Fail-open partner to the above: when the cart engine cannot load, the drawer POSTs natively
      // and navigates to /cart — clear the spinner first so the button is never left on is-loading.
      document.addEventListener('cart:addfailed', () => {
        this._selfAdd = false;
        this.adds.forEach((btn) => { btn.classList.remove('is-loading'); clearTimeout(btn._reset); });
      });
      // Sticky "Buy now": add the current variant, then go straight to checkout.
      this.querySelectorAll('[data-svstk-buynow]').forEach((btn) => btn.addEventListener('click', () => this.buyNow(btn)));
      this.querySelectorAll('[data-sticky-buy]').forEach((btn) => btn.addEventListener('click', () => this.stickyBuy(btn)));
    }

    /* Sticky "Buy now" = the buy box's own buy control, whatever is showing right now (a headless-checkout button
       when one is live, else Shopify's dynamic checkout button) — ONE checkout decision for the whole page. Only
       with neither visible (sold out, or a checkout integration still loading) does it take the native path. */
    stickyBuy(btn) {
      const live = this.liveBuyControl();
      if (live) { live.click(); return; }
      this.buyNow(btn);
    }
    /* The buy box's visible, enabled buy button right now (headless-checkout button when live, else Shopify's). */
    liveBuyControl() {
      const host = this.querySelector('.pdp-buy__now');
      return host && [...host.querySelectorAll('button')].find((el) => !el.disabled && el.offsetParent !== null && el.getBoundingClientRect().height > 0);
    }
    /* Mirror the live buy control's payment-method strip (its <img>) into the sticky Buy now, so the two read as the
       same button. Runs each time the sticky bar is revealed (cheap: one query + a src compare); nothing to mirror →
       the slot stays hidden. The image element and its URL come from whatever rendered the buy box at runtime — the
       theme itself carries no vendor asset. */
    syncStickyPay() {
      const slot = this.querySelector('[data-sticky-pay]');
      if (!slot) return;
      const live = this.liveBuyControl();
      const img = live && live.querySelector('img');
      if (!img || !img.currentSrc && !img.src) { slot.hidden = true; this.awaitStickyPay(); return; }
      const src = img.currentSrc || img.src;
      if (slot.dataset.src === src) { slot.hidden = false; return; }
      const copy = document.createElement('img');
      copy.src = src; copy.alt = ''; copy.decoding = 'async'; copy.loading = 'lazy';
      slot.replaceChildren(copy); slot.dataset.src = src; slot.hidden = false;
      this.stopStickyPayWait();
    }
    /* On a phone the buy box loads below the fold, so the sticky bar is revealed on page load — before a deferred
       checkout integration has rendered its button (and its payment strip) into the buy box. The reveal was the only
       sync trigger, so the strip stayed missing until the shopper scrolled the CTA in and out again. Watch the buy
       box (button/img injection, src swaps) and the <html> class (integrations flip visibility there) and re-sync
       while the bar is showing; stop as soon as the strip lands, and give up after 15 s. svstk-7q2x9k3 */
    awaitStickyPay() {
      if (this._payWait) return;
      const host = this.querySelector('.pdp-buy__now');
      if (!host || !('MutationObserver' in window)) return;
      const bar = this.querySelector('[data-svstk-sticky]');
      let queued = false;
      const run = () => {
        queued = false;
        if (bar && bar.hidden) return;
        this.syncStickyPay();
      };
      const mo = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(run); } });
      mo.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'style', 'class', 'hidden'] });
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this._payWait = { mo, timer: setTimeout(() => this.stopStickyPayWait(), 15000) };
    }
    stopStickyPayWait() {
      if (!this._payWait) return;
      this._payWait.mo.disconnect();
      clearTimeout(this._payWait.timer);
      this._payWait = null;
    }

    buyNow(btn) {
      const bqty = parseInt(this.qtyInput?.value, 10) || 1;
      const items = [{ id: this.currentId, quantity: bqty, properties: this.collectProps() }];
      const bgifts = this.collectGiftItems(bqty);
      if (bgifts.length) items.push.apply(items, bgifts);
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      }).then((r) => r.json()).then(() => { window.location.href = '/checkout'; })
        .catch(() => { window.location.href = '/cart'; });
    }

    addToCart(btn) {
      // The cart drawer (svastika-cart-drawer) owns the mutation + render + auto-open. We just show the
      // loading state and dispatch cart:add; the cart:added listener flips to the success state, then the
      // drawer slides in a beat later.
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      const v = this.data.variants.find((x) => x.id === this.currentId);
      const qty = parseInt(this.qtyInput?.value, 10) || 1;
      const items = [{ id: this.currentId, quantity: qty, properties: this.collectProps() }];
      if (v) {
        items[0].price = v.price;   // unit price (cents) → lets the cart fold any unlocked gift into THIS add
        // Display data so the cart can render the line INSTANTLY (no ~2.5s wait) + mirror its volume price.
        let vol = '';
        if (this.data.volume && this.data.volume.tiers) {
          vol = JSON.stringify(this.data.volume.tiers.map((t) => ({ m: t.min, t: t.type, v: t.value })));
        }
        items[0].display = {
          title: this.data.title || '',
          variant: (v.title && v.title !== 'Default Title') ? v.title : '',
          image: this.data.image || '',
          price: v.price,
          mrp: v.compare || 0,   // compare-at (MRP) → the cart line's strike + "% off" badge land with the optimistic line
          vol: vol,
          product_id: this.data.product_id || 0   // lets the cart match upsells to this product instantly
        };
      }
      const gifts = this.collectGiftItems(qty);
      if (gifts.length) items.push.apply(items, gifts);
      this._selfAdd = true;   // scope the cart:added success flip to THIS add only (see the cart:added listener)
      btn.classList.add('is-loading');
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: items } }));
    }

    collectProps() {
      const props = {};
      this.querySelectorAll('[name^="properties["]').forEach((el) => {
        const m = el.name.match(/properties\[(.+)\]/); if (!m) return;
        if (el.type === 'checkbox') { if (el.checked) props[m[1]] = el.value; }
        else if (el.value.trim()) props[m[1]] = el.value;
      });
      return props;
    }

    /* Option A: opted gift add-ons become REAL product lines (charged) linked to this line via For=line_key — the
       same shape the cart drawer's toggleGiftAddon uses — instead of a cosmetic property on the main line. line_key
       MUST mirror cart-line-items.liquid: product title + " (variant)" unless the variant is the default. */
    collectGiftItems(qty) {
      const v = this.data.variants.find((x) => x.id === this.currentId);
      const vt = (v && v.title && v.title !== 'Default Title') ? v.title : '';
      const forKey = (this.data.title || '') + (vt ? ' (' + vt + ')' : '');
      const out = [];
      this.querySelectorAll('[data-gift-vid]').forEach((cb) => {
        if (!cb.checked) return;
        const vid = parseInt(cb.dataset.giftVid, 10);
        if (!vid) return;
        out.push({
          id: vid,
          quantity: qty,
          properties: { For: forKey, _for_vid: String(this.currentId) },   // readable key for the order + exact parent variant id
          giftAddon: true,
          display: { title: cb.dataset.giftTitle || '', variant: '', image: cb.dataset.giftImage || '', price: parseInt(cb.dataset.giftPrice, 10) || 0, vol: '', product_id: 0 }
        });
      });
      return out;
    }

    /* ----- Sticky bar ----- */
    initSticky() {
      const bar = this.querySelector('[data-svstk-sticky]');
      const anchor = this.querySelector('[data-buy-cta]');
      if (!bar || !anchor) return;
      // Sit above the mobile bottom-nav (if it's showing) so the two fixed bars never overlap.
      const setOffset = () => {
        const nav = document.querySelector('svastika-bottom-nav');
        const visible = nav && getComputedStyle(nav).display !== 'none' && nav.offsetHeight > 0;
        bar.style.bottom = (visible ? nav.offsetHeight : 0) + 'px';
      };
      setOffset();
      window.addEventListener('resize', setOffset, { passive: true });
      // Show the bar whenever the CTA block is OFF-SCREEN — above (scrolled past)
      // OR below (not yet reached, e.g. below the fold on mobile page-load).
      // IntersectionObserver is the ONLY path on every browser that has it. The scroll listener below
      // is a genuine no-IO fallback and must stay in the else branch: registered alongside the observer
      // it ran getBoundingClientRect() on every scroll tick (forced layout) for a value IO already had.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { bar.hidden = en.isIntersecting; if (!en.isIntersecting) this.syncStickyPay(); });
        }, { threshold: 0 });
        io.observe(anchor);
      } else {
        // Scroll fallback (no-IO): hide only while any part of the CTA is in view. rAF-throttled so the
        // one layout read happens at most once per painted frame.
        let ticking = false;
        const measure = () => {
          ticking = false;
          const r = anchor.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          bar.hidden = r.top < vh && r.bottom > 0;
          if (!bar.hidden) this.syncStickyPay();
        };
        const onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(measure);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        measure();
      }
    }

    /* ----- Pincode: real validation via India Post + app-driven region timeline ----- */
    initPincode() {
      const wrap = this.querySelector('[data-svstk-pincode]');
      if (!wrap) return;
      this.pinWrap = wrap;
      this.pinInput = wrap.querySelector('[data-pin-input]');
      this.pinMsg = wrap.querySelector('[data-pin-msg]');
      this.pinError = wrap.querySelector('[data-pin-error]');
      this.pinBtn = wrap.querySelector('[data-pin-check]');
      this.pinDefaultLoc = wrap.getAttribute('data-pin-loc') || '';
      this.pinRangeDays = parseInt(wrap.getAttribute('data-pin-range'), 10);
      if (isNaN(this.pinRangeDays)) this.pinRangeDays = 2;
      this.pinCache = {}; // pin -> { ok, state, district } | { ok:false } | { ok:null }
      this.pinBtn?.addEventListener('click', () => this.checkPincode());
      this.pinInput?.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.checkPincode(); } });
      // Default estimate on load — NO network: resolve the configured default location's tier.
      this.showDefaultDelivery();
      // Then swap in the shopper's own place: their last typed pincode (instant, from storage) or,
      // once the checker nears the viewport, the nearest pincode to their IP (snippets/pdp-pin-locate).
      this.pinDefaultPin = this.pinInput ? this.pinInput.value : '';
      this.onDeliveryPin((api) => api.whenReady(wrap, (p) => this.applyLocatedPin(p)));
    }

    onDeliveryPin(fn) {
      if (window.svstkDeliveryPin) { fn(window.svstkDeliveryPin); return; }
      document.addEventListener('svstk:delivery-pin', () => { if (window.svstkDeliveryPin) fn(window.svstkDeliveryPin); }, { once: true });
    }

    /* Replace the editor default with the located place — unless the shopper has started typing. */
    applyLocatedPin(p) {
      if (!this.pinInput || !this.pinMsg) return;
      if (document.activeElement === this.pinInput || this.pinInput.value !== this.pinDefaultPin) return;
      this.pinInput.value = p.pin;
      this.pinCache[p.pin] = { ok: true, state: p.state, district: p.district };
      const del = this.data.delivery;
      const tier = this.resolveDeliveryTier(p.state, p.district);
      this.renderDelivery(p.district, p.state, tier ? tier.days : (del ? del.fallbackDays : 7));
      this.pinMsg.classList.add('is-svstk-located');
    }

    showDefaultDelivery() {
      if (!this.pinMsg) return;
      const parts = this.pinDefaultLoc.split(',');
      const district = (parts[0] || '').trim();
      const state = (parts[1] || '').trim();
      const del = this.data.delivery;
      const tier = this.resolveDeliveryTier(state, district);
      const days = tier ? tier.days : (del ? del.fallbackDays : 7);
      this.renderDelivery(district, state, days);
    }

    /* Format a transit estimate as a date range. window 0 → single date;
       same month → "21–23 Jun"; spanning months → "29 Jun – 1 Jul". */
    formatDateRange(days) {
      const opt = { day: 'numeric', month: 'short' };
      const base = new Date();
      const a = new Date(base); a.setDate(a.getDate() + days);
      const win = this.pinRangeDays || 0;
      if (win <= 0) return this.esc(a.toLocaleDateString('en-IN', opt));
      const b = new Date(base); b.setDate(b.getDate() + days + win);
      const bS = b.toLocaleDateString('en-IN', opt);
      if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
        return this.esc(a.getDate() + '–' + bS);
      }
      return this.esc(a.toLocaleDateString('en-IN', opt) + ' – ' + bS);
    }

    /* Single-line "Delivery to {region} by {range}". */
    renderDelivery(district, state, days) {
      if (!this.pinMsg) return;
      const range = this.formatDateRange(days);
      const region = [district, state].filter(Boolean).join(', ') || 'your area';
      this.pinError.hidden = true;
      this.pinMsg.innerHTML =
        '<span class="pdp-pin__msg-mk" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
        '<span class="pdp-pin__msg-text">Delivery to <strong>' + this.esc(region) + '</strong> by <strong>' + range + '</strong></span>';
    }

    /* Mirrors the app's resolveTier() (lib/metaobjects/delivery.ts) — a tier's names
       match against BOTH district and state (so "delhi" catches the whole NCT); a
       district match beats a state match; empty match list = catch-all; null otherwise. */
    resolveDeliveryTier(state, district) {
      const del = this.data.delivery;
      if (!del || !Array.isArray(del.tiers)) return null;
      const s = (state || '').trim().toLowerCase();
      const d = (district || '').trim().toLowerCase();
      let catchAll = null;
      for (const t of del.tiers) {
        if (!t.match || t.match.length === 0) { if (!catchAll) catchAll = t; continue; }
        if (d && t.match.indexOf(d) !== -1) return t;
      }
      for (const t of del.tiers) {
        if (!t.match || t.match.length === 0) continue;
        if (s && t.match.indexOf(s) !== -1) return t;
      }
      return catchAll;
    }

    async checkPincode() {
      const pin = (this.pinInput.value || '').replace(/\D/g, '');
      this.pinError.hidden = true;
      if (pin.length !== 6 || pin[0] === '0') {
        this.pinError.hidden = false;
        this.pinError.textContent = 'Please enter a valid 6-digit pincode.';
        return;
      }
      let info = this.pinCache[pin];
      if (!info) {
        this.pinBtn.disabled = true;
        const label = this.pinBtn.textContent;
        this.pinBtn.textContent = 'Checking…';
        try {
          const res = await fetch('https://api.postalpincode.in/pincode/' + pin, { headers: { Accept: 'application/json' } });
          const json = await res.json();
          const row = Array.isArray(json) ? json[0] : null;
          if (row && row.Status === 'Success' && row.PostOffice && row.PostOffice.length) {
            const po = row.PostOffice[0];
            info = { ok: true, state: po.State || '', district: po.District || '' };
          } else {
            info = { ok: false };
          }
        } catch (e) {
          info = { ok: null }; // network / API down — soft fallback, don't reject the pincode
        }
        this.pinBtn.disabled = false;
        this.pinBtn.textContent = label;
        if (info.ok !== null) this.pinCache[pin] = info;
      }

      if (info.ok === false) {
        this.pinError.hidden = false;
        this.pinError.textContent = "We couldn't find this pincode. Please double-check it.";
        return;
      }

      const del = this.data.delivery;
      if (info.ok === true) {
        const tier = this.resolveDeliveryTier(info.state, info.district);
        const days = tier ? tier.days : (del ? del.fallbackDays : 7);
        this.renderDelivery(info.district, info.state, days);
        if (window.svstkDeliveryPin) window.svstkDeliveryPin.remember(pin, info.district, info.state);
      } else {
        // API unreachable: single-line fallback to the configured default ETA text, no exact date.
        this.pinError.hidden = true;
        this.pinMsg.innerHTML = '<span class="pdp-pin__msg-text">' + this.esc((del && del.defaultEta) || 'Usually delivered in 4–7 days') + '</span>';
      }
    }

    /* ----- Dialogs ----- */
    initModals() {
      this.querySelectorAll('[data-svstk-open]').forEach((btn) => btn.addEventListener('click', () => {
        const m = this.querySelector('[data-svstk-modal="' + btn.dataset.svstkOpen + '"]');
        if (m && typeof m.showModal === 'function') m.showModal();
      }));
      this.querySelectorAll('[data-svstk-modal]').forEach((m) => {
        m.querySelectorAll('[data-svstk-close]').forEach((c) => c.addEventListener('click', () => m.close()));
        m.addEventListener('click', (e) => { if (e.target === m) m.close(); });
      });
      this.querySelectorAll('[data-svstk-copy]').forEach((btn) => btn.addEventListener('click', () => {
        const code = btn.dataset.svstkCopy;
        navigator.clipboard?.writeText(code);
        btn.classList.add('is-copied');
        const lbl = btn.querySelector('span'); const old = lbl ? lbl.textContent : '';
        if (lbl) { lbl.textContent = 'Copied'; setTimeout(() => { lbl.textContent = old; btn.classList.remove('is-copied'); }, 1600); }
      }));
      this.querySelectorAll('[data-svstk-scroll]').forEach((a) => a.addEventListener('click', (e) => {
        // data-svstk-scroll may be a comma-separated fallback list of ids (e.g. "judgeme-reviews,judgeme_product_reviews"); scroll to the first that exists.
        let el = null;
        for (const id of a.dataset.svstkScroll.split(',')) { el = document.getElementById(id.trim()); if (el) break; }
        if (el) { e.preventDefault(); window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' }); }
      }));
    }
  }
  if (!customElements.get('svastika-pdp')) customElements.define('svastika-pdp', SvastikaPdp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-promise"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPromiseRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-rail-dots] i'));
      if (!this.track || this.dots.length < 2) return;
      this._onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
    }
    disconnectedCallback() {
      if (this.track && this._onScroll) this.track.removeEventListener('scroll', this._onScroll);
    }
    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        var cols = this.track.children;
        if (!cols.length) return;
        var center = this.track.scrollLeft + this.track.clientWidth / 2;
        var active = 0, best = Infinity;
        for (var i = 0; i < cols.length; i++) {
          var mid = cols[i].offsetLeft + cols[i].offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < best) { best = d; active = i; }
        }
        if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) {
          active = cols.length - 1;
        }
        for (var j = 0; j < this.dots.length; j++) {
          this.dots[j].classList.toggle('is-active', j === active);
        }
      });
    }
  }
  if (!customElements.get('svastika-promise-rail')) {
    customElements.define('svastika-promise-rail', SvastikaPromiseRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meenakari-story"] && !Shopify.designMode) return;
  try {
    
  class SvastikaMeenakari extends HTMLElement {
    connectedCallback() {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const items = Array.from(this.querySelectorAll('.reveal'));
      if (reduce || !('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('in'));
        return;
      }
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('in');
            this._io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach((el) => this._io.observe(el));
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
  }
  if (!customElements.get('svastika-meenakari')) customElements.define('svastika-meenakari', SvastikaMeenakari);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-claim"] && !Shopify.designMode) return;
  try {
    
  /* <svastika-mystery-claim> — the claim surfaces.
     Both buttons add through the theme's cart:add contract, so <svastika-cart-drawer> owns the
     mutation and auto-opens exactly as it does for the collection grid and the PDP.
     svstk-7q2x9k3 */
  class SvastikaMysteryClaim extends HTMLElement {
    connectedCallback() {
      this.variant = parseInt(this.dataset.variant, 10) || 0;
      this.sticky = this.querySelector('[data-claim-sticky]');
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-claim-btn]'));
      this.form = this.querySelector('[data-claim-form]');

      if (this.variant) {
        const self = this;
        this.buttons.forEach(function (btn) {
          btn.addEventListener('click', function (e) { e.preventDefault(); self.claim(btn); });
        });
        if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); });
        document.addEventListener('cart:added', this._added = function () { self.flash(); });
      }

      if (this.sticky) this.bindSticky();
    }

    disconnectedCallback() {
      if (this._scroll) window.removeEventListener('scroll', this._scroll);
      if (this._added) document.removeEventListener('cart:added', this._added);
    }

    claim(btn) {
      if (this._busy) return;
      this._busy = true;
      this._self = true;
      const d = this.dataset;
      const item = { id: this.variant, quantity: 1 };
      // Display data → the drawer renders the line instantly instead of a skeleton round-trip.
      if (d.title) {
        item.price = parseInt(d.price, 10) || 0;
        item.display = {
          title: d.title,
          variant: d.variantTitle || '',
          image: d.image || '',
          price: item.price,
          vol: '',
          product_id: d.productId || ''
        };
      }
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
      const self = this;
      // The drawer owns the outcome; release the guard either way so a failed add is retryable.
      setTimeout(function () { self._busy = false; }, 1200);
    }

    flash() {
      if (!this._self) return;
      this._self = false;
      const labels = this.querySelectorAll('[data-claim-label]');
      Array.prototype.forEach.call(labels, function (el) {
        if (el.dataset.was) return;
        el.dataset.was = el.textContent;
        el.textContent = el.getAttribute('data-done') || 'Added';
        setTimeout(function () {
          el.textContent = el.dataset.was;
          delete el.dataset.was;
        }, 1800);
      });
    }

    bindSticky() {
      const after = parseInt(this.dataset.revealAfter, 10) || 380;
      const self = this;
      this._scroll = function () {
        self.classList.toggle('is-sticky', window.scrollY > after);
      };
      window.addEventListener('scroll', this._scroll, { passive: true });
      this._scroll();
    }
  }
  if (!customElements.get('svastika-mystery-claim')) {
    customElements.define('svastika-mystery-claim', SvastikaMysteryClaim);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-hero"] && !Shopify.designMode) return;
  try {
    
  /* <svastika-mystery-room> — the reveal room.
     Ported from the Claude Design logic, with three theme-side additions:
       1. tile images are injected on first reveal (parked in data-ph-src) so an untouched hero
          downloads zero product photography;
       2. prefers-reduced-motion short-circuits to a static, fully-revealed room;
       3. the idle timer never runs while the panel is off-screen.
     svstk-7q2x9k3 */
  class SvastikaMysteryRoom extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-mb-panel]');
      this.veil = this.querySelector('[data-mb-veil]');
      this.glow = this.querySelector('[data-mb-glow]');
      this.host = this.querySelector('[data-mb-tiles]');
      this.hint = this.querySelector('[data-mb-hint]');
      this.rippleEl = this.querySelector('[data-mb-ripple]');
      this.bar = this.querySelector('[data-mb-bar]');
      this.countEl = this.querySelector('[data-mb-count]');
      this.noteEl = this.querySelector('[data-mb-note]');
      if (!this.panel || !this.host) return;

      this.hold = parseInt(this.dataset.hold, 10) || 1800;
      this.word = this.dataset.seenWord || 'glimpsed';
      this.notes = (this.dataset.notes || '').split('\n').map(function (n) { return n.trim(); }).filter(Boolean);
      this.tiles = Array.prototype.slice.call(this.host.querySelectorAll('[data-sv-tile]'));
      this.total = this.tiles.length;
      this._lit = new Map();
      this._seen = new Set();
      this._last = 0;
      this._thr = 0;

      this.calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.tiles.forEach(function (el) {
        el._zx = parseFloat(el.style.left);
        el._zy = parseFloat(el.style.top);
      });

      if (this.calm) { this.revealAll(); return; }

      this.tiles.forEach(this.place, this);
      this.paint(0);
      this.bindPanel();
      this.startIdle();
    }

    disconnectedCallback() {
      clearInterval(this._idle);
      if (this._io) this._io.disconnect();
      this._lit.forEach(function (t) { clearTimeout(t); });
      this._lit.clear();
    }

    /* Inject the parked image the first time a tile is asked for. */
    hydrate(el) {
      const img = el.querySelector('[data-ph-img]');
      if (!img || img.dataset.phDone) return;
      img.dataset.phDone = '1';
      if (img.dataset.phSrcset) img.srcset = img.dataset.phSrcset;
      if (img.dataset.phSrc) img.src = img.dataset.phSrc;
    }

    revealAll() {
      this.tiles.forEach(function (el) {
        this.hydrate(el);
        this._seen.add(el.getAttribute('data-sv-tile'));
      }, this);
      this.paint(this.total);
    }

    /* Tiles drift to a new spot every time they hide, so the room never becomes a map. */
    place(el) {
      el.style.left = Math.max(12, Math.min(88, el._zx + (Math.random() - 0.5) * 14)) + '%';
      el.style.top = Math.max(12, Math.min(90, el._zy + (Math.random() - 0.5) * 14)) + '%';
      el._rot = (Math.random() - 0.5) * 10;
    }

    light(el) {
      if (this._lit.has(el)) return;
      this.hydrate(el);
      el.style.opacity = '1';
      el.style.filter = 'blur(0px)';
      el.style.transform = 'translate(-50%,-50%) scale(1) rotate(' + (el._rot || 0) + 'deg)';
      const self = this;
      this._lit.set(el, setTimeout(function () { self.dim(el); }, this.hold));
      const key = el.getAttribute('data-sv-tile');
      if (!this._seen.has(key)) {
        this._seen.add(key);
        this.paint(this._seen.size);
      }
    }

    dim(el) {
      clearTimeout(this._lit.get(el));
      this._lit.delete(el);
      el.style.opacity = '0';
      el.style.filter = 'blur(7px)';
      el.style.transform = 'translate(-50%,-50%) scale(.84) rotate(' + (el._rot || 0) * 0.4 + 'deg)';
      const self = this;
      setTimeout(function () { if (!self._lit.has(el)) self.place(el); }, 600);
    }

    paint(n) {
      if (this.bar && this.total) this.bar.style.width = Math.round((n / this.total) * 100) + '%';
      if (this.countEl) this.countEl.textContent = n + ' / ' + this.total + ' ' + this.word;
      if (this.noteEl && this.notes.length) {
        this.noteEl.textContent = this.notes[Math.min(n, this.notes.length - 1)];
      }
    }

    moveLight(x, y) {
      if (this.veil) {
        this.veil.style.background = 'radial-gradient(circle 122px at ' + x + 'px ' + y + 'px, ' +
          'rgba(12,9,6,0) 0%, rgba(12,9,6,.45) 36%, rgba(10,8,5,.98) 74%)';
      }
      if (this.glow) { this.glow.style.left = x + 'px'; this.glow.style.top = y + 'px'; }
    }

    probe(x, y, wide) {
      if (!this.tiles.length) return;
      const hr = this.host.getBoundingClientRect();
      const r2 = wide ? 260 : 150;
      const near = [];
      this.tiles.forEach(function (el) {
        if (this._lit.has(el)) return;
        const r = el.getBoundingClientRect();
        const cx = r.left - hr.left + r.width / 2;
        const cy = r.top - hr.top + r.height / 2;
        if (Math.hypot(cx - x, cy - y) < r2) near.push(el);
      }, this);
      if (!near.length) return;
      this.light(near[Math.floor(Math.random() * near.length)]);
    }

    fadeHint() {
      if (this.hint && this.hint.style.opacity !== '0') this.hint.style.opacity = '0';
    }

    ripple(x, y) {
      const el = this.rippleEl;
      if (!el) return;
      el.style.left = x + 'px';
      el.style.top = y + 'px';
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = 'mbRipple .75s ease-out';
    }

    local(cx, cy) {
      const r = this.host.getBoundingClientRect();
      return {
        x: Math.max(0, Math.min(r.width, cx - r.left)),
        y: Math.max(0, Math.min(r.height, cy - r.top))
      };
    }

    bindPanel() {
      const self = this;
      const at = function (cx, cy, wide) {
        const p = self.local(cx, cy);
        self._last = Date.now();
        self.fadeHint();
        self.moveLight(p.x, p.y);
        if (wide) { self.ripple(p.x, p.y); self.probe(p.x, p.y, true); return; }
        const now = Date.now();
        if (now - self._thr > 110) { self._thr = now; self.probe(p.x, p.y); }
      };
      this.panel.addEventListener('pointermove', function (e) { at(e.clientX, e.clientY); });
      this.panel.addEventListener('touchmove', function (e) {
        const t = e.touches[0];
        if (t) at(t.clientX, t.clientY);
      }, { passive: true });
      this.panel.addEventListener('click', function (e) { at(e.clientX, e.clientY, true); });
    }

    /* The room offers a piece on its own when nobody is touching — but only while it is on screen,
       so a scrolled-past hero isn't animating (and fetching) in the background. */
    startIdle() {
      if (this.dataset.auto !== '1') return;
      this._onScreen = true;
      if ('IntersectionObserver' in window) {
        const self = this;
        this._onScreen = false;
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self._onScreen = en.isIntersecting; });
        }, { threshold: 0.15 });
        this._io.observe(this.panel);
      }
      const self = this;
      this._idle = setInterval(function () {
        if (!self._onScreen) return;
        if (Date.now() - self._last < 2200) return;
        const free = self.tiles.filter(function (el) { return !self._lit.has(el); });
        if (!free.length) return;
        const el = free[Math.floor(Math.random() * free.length)];
        const box = self.host.getBoundingClientRect();
        const r = el.getBoundingClientRect();
        self.moveLight(r.left - box.left + r.width / 2, r.top - box.top + r.height / 2);
        self.light(el);
      }, 1600);
    }
  }
  if (!customElements.get('svastika-mystery-room')) {
    customElements.define('svastika-mystery-room', SvastikaMysteryRoom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-shelf"] && !Shopify.designMode) return;
  try {
    
  /* <svastika-mystery-shelf> — two rows that drift in opposite directions.
     Ported from the Claude Design row logic, with theme-side additions:
       1. the seamless set is CLONED client-side (the server ships each product once);
       2. every card image is injected on approach by a per-cell IntersectionObserver, so an
          off-screen row never fetches the catalogue;
       3. the rAF loop runs only while the section is on screen — which also makes it safe under
          content-visibility:auto, where a connect-time measurement reads 0 (§14).
     svstk-7q2x9k3 */
  class SvastikaMysteryShelf extends HTMLElement {
    connectedCallback() {
      this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-sv-row]'));
      if (!this.rows.length) return;

      this.calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._flip = false;

      this.bindImages();
      // Start drifting on page 1 straight away — waiting on the network would leave the rows dead.
      // The tail is folded in afterwards, which means re-cloning (prepare() builds the seamless set
      // from whatever is in the DOM, so a later append would otherwise land after the clones).
      this.setup();
      const self = this;
      if (this.dataset.more) this.loadMore().then(function () { self.rebuild(); }, function () {});
    }

    rebuild() {
      if (!this._pending || !this._pending.length) return;
      this.stop();
      this.rows.forEach(function (row) {
        Array.prototype.forEach.call(row.querySelectorAll('[data-sv-clone]'), function (c) { c.remove(); });
        row._period = null;
        row._pos = 0;
        row.scrollLeft = 0;
      });
      this._pending.forEach(function (cell) { this.place(cell); }, this);
      this._pending = null;
      this.setup();
    }

    setup() {
      this.rows.forEach(function (row) {
        const speed = row.dataset.svRow === 'b'
          ? parseFloat(this.dataset.speedB)
          : parseFloat(this.dataset.speedA);
        this.prepare(row, isNaN(speed) ? 26 : speed);
      }, this);
      if (this.calm) return;
      this.watch();
    }

    /* Walk the remaining pages of this same section. Shopify caps one render at 50 products (20
       under paginate), so the server gave us page 1 and this fetches the rest through the Section
       Rendering API — `&section_id=` returns the section alone, a few KB, instead of a ~330 KB
       full-page render. We follow each response's own data-more rather than counting pages, since
       Shopify picks the page size, and de-duplicate by href so any overlap is free. */
    loadMore() {
      const url = this.dataset.more;
      if (!url) return Promise.resolve();

      const seen = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-sv-card]'), function (a) {
        seen[a.getAttribute('href')] = 1;
      });
      let count = Object.keys(seen).length;
      const max = parseInt(this.dataset.max, 10) || 0;
      const self = this;

      const walk = function (next, guard) {
        if (!next || guard > 12) return Promise.resolve();
        const sep = next.indexOf('?') > -1 ? '&' : '?';
        return fetch(next + sep + 'section_id=' + encodeURIComponent(self.dataset.sectionId), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const cells = doc.querySelectorAll('.sv-shelf__cell');
            let added = 0;
            Array.prototype.forEach.call(cells, function (cell) {
              if (max && count >= max) return;
              const a = cell.querySelector('[data-sv-card]');
              const href = a && a.getAttribute('href');
              if (!href || seen[href]) return;
              seen[href] = 1;
              count++;
              added++;
              self.absorb(cell);
            });
            if (max && count >= max) return;
            const nx = doc.querySelector('svastika-mystery-shelf');
            const nextUrl = nx ? nx.getAttribute('data-more') : null;
            if (!nextUrl || (!added && guard > 1)) return;
            return walk(nextUrl, guard + 1);
          })
          .catch(function () { /* the shelf is still complete-looking without the tail */ });
      };
      return walk(url, 1);
    }

    /* Queue a fetched card; rebuild() places them once the whole tail has arrived. */
    absorb(cell) {
      (this._pending = this._pending || []).push(cell);
    }

    /* Alternate fetched cards between the two rows, continuing the server's own alternation, and
       restamp the shape class so a card landing in the square row actually renders square. */
    place(cell) {
      const row = (this._flip && this.rows[1]) ? this.rows[1] : this.rows[0];
      this._flip = !this._flip;
      const square = row.dataset.svRow === 'b';
      const card = cell.querySelector('.sv-shelf__card');
      if (card) {
        card.classList.remove('sv-shelf__card--tall', 'sv-shelf__card--square');
        card.classList.add(square ? 'sv-shelf__card--square' : 'sv-shelf__card--tall');
      }
      cell.setAttribute('role', 'listitem');
      row.appendChild(cell);
      const img = cell.querySelector('[data-ph-img]');
      if (img && this._imgIo) this._imgIo.observe(img);
      else if (img) this.hydrate(img);
    }

    disconnectedCallback() {
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._imgIo) this._imgIo.disconnect();
      if (this._io) this._io.disconnect();
    }

    /* ── on-demand images ── */
    bindImages() {
      const cells = this.querySelectorAll('[data-ph-img]');
      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(cells, this.hydrate, this);
        return;
      }
      const self = this;
      this._imgIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          self.hydrate(en.target);
          self._imgIo.unobserve(en.target);
        });
      }, { root: null, rootMargin: '200px' });
      Array.prototype.forEach.call(cells, function (img) { self._imgIo.observe(img); });
    }

    hydrate(img) {
      if (!img || img.dataset.phDone) return;
      img.dataset.phDone = '1';
      if (img.dataset.phSrcset) img.srcset = img.dataset.phSrcset;
      if (img.dataset.phSrc) img.src = img.dataset.phSrc;
    }

    /* ── row set-up: clone one full set so the wrap is seamless ── */
    prepare(row, speed) {
      const cells = Array.prototype.slice.call(row.children);
      if (cells.length < 2) return;

      // Speed 0 means "don't drift". Leave _period unset so run() skips this row entirely —
      // otherwise the loop would pin scrollLeft to 0 every frame and the shopper could not swipe.
      if (!speed || this.calm) return;

      const frag = document.createDocumentFragment();
      cells.forEach(function (cell) {
        const copy = cell.cloneNode(true);
        copy.setAttribute('data-sv-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('role', 'presentation');
        const link = copy.querySelector('a');
        if (link) link.setAttribute('tabindex', '-1');
        frag.appendChild(copy);
      });
      row.appendChild(frag);
      // The clones carry parked images too — observe the new nodes (re-observing an already
      // observed element is a documented no-op, so the originals are unaffected).
      if (this._imgIo) {
        const self = this;
        Array.prototype.forEach.call(row.querySelectorAll('[data-ph-img]'), function (img) {
          if (!img.dataset.phDone) self._imgIo.observe(img);
        });
      }

      row._setSize = cells.length;
      row._speed = speed;
      row._paused = false;
      row._resume = 0;
      row._pos = speed < 0 ? 1 : 0;
      // Measure the wrap period from ONE full set so the loop is exact at any card width.
      row._period = function () {
        const kids = row.children;
        const a = kids[0];
        const b = kids[row._setSize];
        return (a && b) ? (b.offsetLeft - a.offsetLeft) : (row.scrollWidth / 2);
      };

      const pause = function () { row._paused = true; row._resume = performance.now() + 2600; };
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        row.addEventListener(ev, pause, { passive: true });
      });
      row.addEventListener('mouseenter', pause);
      row.addEventListener('focusin', function () { row._paused = true; row._resume = Infinity; });
      row.addEventListener('focusout', function () { row._resume = performance.now() + 600; });
    }

    /* Run the loop only while on screen. Under content-visibility:auto a connect-time measurement
       reads 0 — deferring to the observer sidesteps that entirely (§14). */
    watch() {
      const self = this;
      if (!('IntersectionObserver' in window)) { this.run(); return; }
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) self.run();
          else self.stop();
        });
      }, { threshold: 0 });
      this._io.observe(this);
    }

    run() {
      if (this._raf) return;
      const self = this;
      let prev = performance.now();
      const step = function (now) {
        const dt = Math.min(0.05, (now - prev) / 1000);
        prev = now;
        self.rows.forEach(function (row) {
          if (!row._period) return;
          const period = row._period();
          if (!period) return;
          if (row._paused) {
            if (now > row._resume) {
              row._paused = false;
              // pick up exactly where the finger left off
              row._pos = ((row.scrollLeft % period) + period) % period;
            }
            return;
          }
          row._pos = ((row._pos + row._speed * dt) % period + period) % period;
          row.scrollLeft = Math.round(row._pos);
        });
        self._raf = requestAnimationFrame(step);
      };
      this._raf = requestAnimationFrame(step);
    }

    stop() {
      if (!this._raf) return;
      cancelAnimationFrame(this._raf);
      this._raf = null;
    }
  }
  if (!customElements.get('svastika-mystery-shelf')) {
    customElements.define('svastika-mystery-shelf', SvastikaMysteryShelf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["not-found"] && !Shopify.designMode) return;
  try {
    
  // Slug hint: turn the dead URL's last path segment into words and offer it as a search.
  // svstk-7q2x9k3 — runs once, touches only this section, does nothing when the slug is useless.
  (function () {
    var root = document.querySelector('[data-svstk-lostpath]');
    if (!root) return;
    var hint = root.querySelector('[data-kept-close-hint]');
    var link = root.querySelector('[data-kept-close-link]');
    var q = root.querySelector('[data-kept-close-q]');
    var input = root.querySelector('input[name="q"]');
    if (!hint || !link || !q) return;

    var seg = location.pathname.split('/').filter(Boolean).pop() || '';
    try { seg = decodeURIComponent(seg); } catch (e) { /* keep the raw segment */ }
    seg = seg
      .replace(/\.[a-z0-9]{1,5}$/i, '')
      .replace(/[-_+.]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    var routeWords = ['products', 'collections', 'pages', 'blogs', 'search', 'cart', 'account', 'index', 'home', 'checkout', 'apps'];
    if (seg.length < 3 || /^\d+$/.test(seg) || routeWords.indexOf(seg.toLowerCase()) !== -1) return;
    if (seg.length > 60) seg = seg.slice(0, 60).trim();

    q.textContent = seg;
    link.href = (link.getAttribute('data-base') || '/search?q=') + encodeURIComponent(seg);
    if (input && !input.value) input.value = seg;
    hint.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-feature"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPremiumFeature extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-in');
        return;
      }
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { this.classList.add('is-in'); this._io.disconnect(); }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      this._io.observe(this);
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
  }
  if (!customElements.get('svastika-premium-feature')) customElements.define('svastika-premium-feature', SvastikaPremiumFeature);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-band"] && !Shopify.designMode) return;
  try {
    
  class SvastikaPress extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-press-trigger]');
        if (!trigger) return;
        const id = trigger.dataset.pressTrigger;
        this.querySelectorAll('[data-press-feat]').forEach(f => {
          if (f.dataset.id === id) f.setAttribute('data-active', '');
          else f.removeAttribute('data-active');
        });
        this.querySelectorAll('[data-press-trigger]').forEach(b => {
          if (b.dataset.pressTrigger === id) b.setAttribute('data-active', '');
          else b.removeAttribute('data-active');
        });
      });
    }
  }
  if (!customElements.get('svastika-press')) customElements.define('svastika-press', SvastikaPress);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-size-guide"] && !Shopify.designMode) return;
  try {
    
  class SvastikaSizeGuide extends HTMLElement {
    connectedCallback() {
      const tabs = [...this.querySelectorAll('[data-sguide-tab]')];
      const panels = [...this.querySelectorAll('[data-sguide-panel]')];
      if (!tabs.length || !panels.length) return;
      const show = (i) => {
        tabs.forEach((t, n) => { const on = n === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach((p, n) => { p.hidden = n !== i; });
      };
      tabs.forEach((t, n) => t.addEventListener('click', () => show(n)));
      this.setAttribute('data-ready', '');
      show(0);
    }
  }
  if (!customElements.get('svastika-size-guide')) customElements.define('svastika-size-guide', SvastikaSizeGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
  class SvastikaStorySwitcher extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-story-pill]'));
      this.panels = Array.from(this.querySelectorAll('[data-story-panel]'));
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.select(pill.getAttribute('data-story-pill')));
      });
    }
    select(key) {
      this.pills.forEach((p) => {
        const on = p.getAttribute('data-story-pill') === key;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const on = panel.getAttribute('data-story-panel') === key;
        panel.hidden = !on;
        if (on && !this.reduce) {
          panel.classList.remove('is-in');
          void panel.offsetWidth;
          panel.classList.add('is-in');
        }
      });
    }
  }
  if (!customElements.get('svastika-story-switcher')) {
    customElements.define('svastika-story-switcher', SvastikaStorySwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-slider"] && !Shopify.designMode) return;
  try {
    
  class SvastikaReelsTrack extends HTMLElement {
    connectedCallback() {
      const section = this.closest('section');
      const step = parseInt(this.dataset.step || '2', 10);
      const scroll = (dir) => {
        const card = this.querySelector('[data-reel-card]');
        const px = card ? card.getBoundingClientRect().width + 14 : 280;
        this.scrollBy({ left: px * dir * step, behavior: 'smooth' });
      };
      section?.querySelector('[data-reels-prev]')?.addEventListener('click', () => scroll(-1));
      section?.querySelector('[data-reels-next]')?.addEventListener('click', () => scroll(1));
    }
  }
  if (!customElements.get('svastika-reels-track')) customElements.define('svastika-reels-track', SvastikaReelsTrack);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-by-category"] && !Shopify.designMode) return;
  try {
    
  class SvastikaRelated extends HTMLElement {
    connectedCallback() {
      this.app = (this.dataset.app || '').replace(/\/$/, '');
      this.shop = this.dataset.shop || '';
      // Beacons fire ONLY on the tracked breadcrumb path, and only when an app URL is configured.
      this.tracked = this.dataset.tracked === 'true' && !!this.app;
      this._grid = this.querySelector('[data-rel-grid]');
      this._prev = this.querySelector('[data-rel-prev]');
      this._next = this.querySelector('[data-rel-next]');
      this._dots = this.querySelectorAll('[data-rel-dots] .sv-related__dot');
      this._reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._touch = matchMedia('(hover: none)').matches;
      this._impressBatch = [];
      this._flushT = 0;
      this._syncArrows = this._syncArrows.bind(this);
      this._syncDots = this._syncDots.bind(this);
      this._onClick = this._onClick.bind(this);
      var self = this;
      this._onScroll = function () { self._syncArrows(); self._syncDots(); };

      this._initCarousel();
      this._initCells();
      this.addEventListener('click', this._onClick);
      if (this.tracked && this.dataset.stale === 'true') this._refreshPing();
    }
    disconnectedCallback() {
      if (this._cellIO) this._cellIO.disconnect();
      this.removeEventListener('click', this._onClick);
      if (this._grid) this._grid.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._syncArrows);
      this.removeEventListener('contentvisibilityautostatechange', this._syncArrows);
      if (this._flushT) clearTimeout(this._flushT);
    }

    /* ---- Paged carousel (arrows + swipe). Runs regardless of tracking. ---- */
    _initCarousel() {
      if (!this._grid || !this._prev || !this._next) return;
      this._prev.addEventListener('click', () => this._page(-1));
      this._next.addEventListener('click', () => this._page(1));
      this._grid.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._syncArrows);
      // cv:auto un-skips off-screen → re-measure arrows on reveal (§14).
      this.addEventListener('contentvisibilityautostatechange', this._syncArrows);
      this._syncArrows();
      this._syncDots();
    }
    _syncDots() {
      if (!this._dots || !this._dots.length || !this._grid) return;
      var per = this._grid.clientWidth || 1;
      var active = Math.round(this._grid.scrollLeft / per);
      if (active < 0) active = 0;
      if (active > this._dots.length - 1) active = this._dots.length - 1;
      for (var i = 0; i < this._dots.length; i++) {
        this._dots[i].classList.toggle('sv-related__dot--on', i === active);
      }
    }
    _page(dir) {
      if (!this._grid) return;
      this._grid.scrollBy({ left: dir * this._grid.clientWidth, behavior: this._reduce ? 'auto' : 'smooth' });
    }
    _syncArrows() {
      var g = this._grid;
      if (!g || !this._prev || !this._next) return;
      // Paint-skipped off-screen (cv:auto) → clientWidth 0: keep the natural start state, don't
      // mis-disable; the contentvisibilityautostatechange/scroll listeners re-sync on reveal (§14).
      if (g.clientWidth === 0) { this._prev.disabled = true; this._next.disabled = false; return; }
      var single = g.scrollWidth <= g.clientWidth + 1;
      var hide = single || this._touch;
      this._prev.hidden = hide;
      this._next.hidden = hide;
      if (hide) return;
      var max = g.scrollWidth - g.clientWidth - 1;
      this._prev.disabled = g.scrollLeft <= 0;
      this._next.disabled = g.scrollLeft >= max;
    }

    /* ---- Deterministic on-demand images (§14) + per-cell in-view impressions ----
       Park every card image; the per-cell observer injects it (and, on the tracked path, fires
       that card's impression) only when the cell is actually about to be seen — so off-screen
       carousel pages don't over-fetch, and un-swiped products aren't counted as "impressed"
       (which would tank their CTR and wrongly demote them). */
    _initCells() {
      var cells = Array.prototype.slice.call(this.querySelectorAll('.sv-related__cell'));
      if (!cells.length) return;
      cells.forEach(function (cell) {
        var img = cell.querySelector('img');
        if (img && img.getAttribute('src')) {
          img.dataset.phSrc = img.getAttribute('src');
          var ss = img.getAttribute('srcset');
          if (ss) { img.dataset.phSrcset = ss; img.removeAttribute('srcset'); }
          img.removeAttribute('src');
        }
      });
      var self = this;
      this._cellIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var cell = entries[i].target;
          self._cellIO.unobserve(cell);
          self._hydrate(cell);
          if (self.tracked && cell.dataset.product) {
            self._impressBatch.push({ k: 'i', h: cell.dataset.handle, p: cell.dataset.product });
            self._scheduleFlush();
          }
        }
      }, { rootMargin: '200px', threshold: 0.01 });
      cells.forEach(function (c) { self._cellIO.observe(c); });
    }
    _hydrate(cell) {
      var img = cell.querySelector('img[data-ph-src]');
      if (!img) return;
      if (img.dataset.phSrcset) img.setAttribute('srcset', img.dataset.phSrcset);
      img.setAttribute('src', img.dataset.phSrc);
      delete img.dataset.phSrc;
      delete img.dataset.phSrcset;
    }
    _scheduleFlush() {
      if (this._flushT) return;
      var self = this;
      this._flushT = setTimeout(function () {
        self._flushT = 0;
        var ev = self._impressBatch.splice(0);
        if (ev.length) self._beacon('/api/related/track', { shop: self.shop, ev: ev });
      }, 300);
    }

    _onClick(e) {
      if (!this.tracked) return;
      var cell = e.target.closest('[data-product]');
      if (!cell || !this.contains(cell)) return;
      this._beacon('/api/related/track', { shop: this.shop, ev: [{ k: 'c', h: cell.dataset.handle, p: cell.dataset.product }] });
    }
    _refreshPing() {
      try { if (sessionStorage.getItem('svstk:rel-refresh')) return; sessionStorage.setItem('svstk:rel-refresh', '1'); } catch (e) {}
      var self = this;
      // The shop MUST ride on the query string — the app's refresh route reads it from
      // there, not from the body (the track route is the one that parses the body).
      var go = function () { self._beacon('/api/related/refresh?shop=' + encodeURIComponent(self.shop), {}); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1200);
    }
    _beacon(path, body) {
      try {
        var url = this.app + path;
        var payload = JSON.stringify(body);
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }));
        } else {
          fetch(url, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors' }).catch(function () {});
        }
      } catch (e) {}
    }
  }
  if (!customElements.get('svastika-related')) customElements.define('svastika-related', SvastikaRelated);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  // Built-in transliteration table — kept-close spellings of the same deity / product, in the
  // shoppers' own Hindi/Sanskrit romanisations. Keys are matched AFTER normalisation (see
  // normWord), so only genuinely different words need a row. The merchant's `synonyms`
  // setting is merged OVER this (merchant wins). svstk-7q2x9k3
  const SVSTK_SYNONYMS = {
    'ganpati': 'Ganesha', 'ganpathi': 'Ganesha', 'ganapati': 'Ganesha', 'vinayaka': 'Ganesha', 'vinayak': 'Ganesha', 'ganesh': 'Ganesha',
    'laxmi': 'Lakshmi', 'laksmi': 'Lakshmi', 'mahalakshmi': 'Lakshmi', 'mahalaxmi': 'Lakshmi',
    'bajrangbali': 'Hanuman', 'bajrang bali': 'Hanuman', 'maruti': 'Hanuman',
    'venkateswara': 'Balaji', 'venkateshwara': 'Balaji', 'tirupati balaji': 'Balaji',
    'shivling': 'Shivling', 'shivalinga': 'Shivling', 'shivlinga': 'Shivling', 'shiva linga': 'Shivling',
    'laddu gopal': 'Laddu Gopal', 'ladoo gopal': 'Laddu Gopal', 'bal gopal': 'Laddu Gopal',
    'kamadhenu': 'Kamdhenu', 'kamdhenu': 'Kamdhenu', 'kamadhenu cow': 'Kamdhenu',
    'jaganath': 'Jagannath', 'jagganath': 'Jagannath',
    'murugan': 'Murugan', 'kartikeya': 'Murugan', 'kartik': 'Murugan', 'subramanya': 'Murugan',
    'saraswathi': 'Saraswati',
    'durga maa': 'Durga', 'sherawali': 'Durga', 'ambe': 'Durga',
    'sai': 'Sai Baba',
    'radhe krishna': 'Radha Krishna', 'radha krishn': 'Radha Krishna',
    'diya': 'Diya', 'deepak': 'Diya', 'deep': 'Diya',
    'thali': 'Pooja Thali', 'thaali': 'Pooja Thali',
    'agarbatti': 'Loban', 'dhoop': 'Loban', 'loban': 'Loban',
    'murti': 'Idol', 'moorti': 'Idol', 'statue': 'Idol', 'idol': 'Idol'
  };
  // Anything that opens (or reasonably leads to) search — warmed on intent, before the tap lands.
  const SVSTK_SEARCH_INTENT = '[data-search-trigger], [data-search-open], a[href="/search"], a[href^="/search?"]';

  class SvastikaSearch extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.ss__panel');
      this.input = this.querySelector('.ss__input');
      this.body  = this.querySelector('[data-ss-body]');
      this.form  = this.querySelector('.ss__bar');
      this.searchUrl = this.dataset.searchUrl;
      this.currency = this.dataset.currency || '₹';
      this.productLimit = Math.max(6, parseInt(this.dataset.productLimit || '8', 10));
      this.min = parseInt(this.dataset.min || '2', 10);
      this.recentEnabled = this.dataset.recent === 'true';
      // Result cache: successes only, capped (oldest evicted) so a long session never grows it unbounded.
      this.cache = new Map(); this.cacheMax = 40;
      // Translated strings come from a data-* JSON blob (no inline <script>). Parsed once; t()
      // falls through to the English defaults for any key that is missing or if the blob is bad.
      this.strings = this.json('[data-ss-strings]') || {};
      this.fuse = null; this.fuseLoading = null; this.synList = null;
      this.vocab = null; this.vocabLoading = null;
      this._open = false; this._lastTrigger = null; this._debounce = null; this._abort = null;
      // Monotonic query ticket — the LATEST search() call owns the body. Any older call that
      // resolves afterwards (slow response, retry, fuzzy refetch) sees a stale ticket and bails.
      this._seq = 0;

      this._onTriggerClick = (e) => {
        const t = e.target.closest('[data-search-trigger]');
        if (!t) return;
        e.preventDefault();
        this.open(t);
      };
      document.addEventListener('click', this._onTriggerClick);

      // Warm on INTENT: hover / touch / keyboard focus of any search trigger starts the Fuse
      // script + vocabulary fetch, so they are usually ready by the time the overlay opens.
      // One-shot — the listeners remove themselves after the first warm.
      this._warmOpts = { capture: true, passive: true };
      this._onIntent = (e) => {
        const el = e.target && e.target.closest ? e.target.closest(SVSTK_SEARCH_INTENT) : null;
        if (el) this.warm();
      };
      ['pointerover', 'touchstart', 'focusin'].forEach((ev) => document.addEventListener(ev, this._onIntent, this._warmOpts));

      this._onKeydown = (e) => {
        if (this._open) { if (e.key === 'Escape') this.close(); return; }
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); this.open(); return; }
        const tag = (document.activeElement && document.activeElement.tagName || '').toLowerCase();
        const typing = tag === 'input' || tag === 'textarea' || tag === 'select' || (document.activeElement && document.activeElement.isContentEditable);
        if (e.key === '/' && !typing) { e.preventDefault(); this.open(); }
      };
      document.addEventListener('keydown', this._onKeydown);

      this.querySelectorAll('[data-ss-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.clearBtn = this.querySelector('[data-ss-clear-input]');
      if (this.clearBtn) this.clearBtn.addEventListener('click', () => this.clearInput());
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown') { const f = this.body.querySelector('a,button:not([disabled])'); if (f) { e.preventDefault(); f.focus(); } } });

      this.form.addEventListener('submit', (e) => {
        const q = this.input.value.trim();
        if (!q) { e.preventDefault(); } else { this.addRecent(q); }
      });

      this.body.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-term]');
        if (chip) { e.preventDefault(); this.setTerm(chip.dataset.term); return; }
        const did = e.target.closest('[data-correct]');
        if (did) { e.preventDefault(); this.setTerm(did.dataset.correct); return; }
        const clr = e.target.closest('[data-ss-clear]');
        if (clr) { e.preventDefault(); this.clearRecent(); this.renderEmpty(); }
      });
      this.body.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const items = Array.from(this.body.querySelectorAll('a,button:not([disabled])'));
        const i = items.indexOf(document.activeElement);
        e.preventDefault();
        if (e.key === 'ArrowDown') (items[i + 1] || this.input).focus();
        else (i <= 0 ? this.input : items[i - 1]).focus();
      });
    }

    warm() {
      if (this._warmed) return;
      this._warmed = true;
      ['pointerover', 'touchstart', 'focusin'].forEach((ev) => document.removeEventListener(ev, this._onIntent, this._warmOpts));
      this.loadFuse();
    }

    open(trigger) {
      if (this._open) return;
      this._open = true;
      this._lastTrigger = trigger || document.activeElement;
      this.removeAttribute('hidden');
      void this.offsetWidth;
      this.classList.add('is-open');
      // No body scroll-lock: setting body overflow:hidden removes the page scrollbar and shifts
      // the background by its width (the "horizontal scroll" on open). The fixed full-screen
      // overlay already covers the page. Mirrors the login popup / PDP contact modal.
      this.warm();
      this.body.removeAttribute('aria-busy');
      this.renderEmpty();
      this.syncFilled();
      this.startType();
      requestAnimationFrame(() => this.input.focus());
      this._trap = (e) => this.trap(e);
      document.addEventListener('keydown', this._trap, true);
    }

    close() {
      if (!this._open) return;
      this._open = false;
      this.stopType();
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._trap, true);
      clearTimeout(this._debounce); this._seq++;
      if (this._abort) this._abort.abort();
      this.input.value = '';
      const hide = () => { if (!this._open) this.setAttribute('hidden', ''); };
      this.panel.addEventListener('transitionend', hide, { once: true });
      setTimeout(hide, 320);
      if (this._lastTrigger && this._lastTrigger.focus) this._lastTrigger.focus();
    }

    trap(e) {
      if (e.key !== 'Tab') return;
      const list = Array.from(this.panel.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // The debounced call reads the field AT FIRE TIME (not a captured copy), and every path that
    // writes the field programmatically (chip, "Did you mean", clear, close) cancels the pending
    // debounce — otherwise a stale timer would fire after them and take the latest query ticket.
    onInput() { clearTimeout(this._debounce); this.syncFilled(); this._debounce = setTimeout(() => this.search(this.input.value), 150); }
    setTerm(term) { clearTimeout(this._debounce); this.input.value = term; this.syncFilled(); this.input.focus(); this.search(term); }
    syncFilled() { if (this.clearBtn) this.clearBtn.hidden = !this.input.value; }
    clearInput() { clearTimeout(this._debounce); this._seq++; this.input.value = ''; this.syncFilled(); if (this._abort) this._abort.abort(); this.body.removeAttribute('aria-busy'); this.input.focus(); this.renderEmpty(); }

    // Typewriter placeholder — types and erases each phrase in a loop while the overlay
    // is open and the field is empty. Runs only on open (no timers at page load) and
    // pauses its DOM writes the moment the shopper starts typing.
    startType() {
      const phrases = this.json('[data-ss-placeholders]');
      if (this._basePlaceholder == null) this._basePlaceholder = this.input.getAttribute('placeholder') || '';
      if (!phrases || !phrases.length) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.input.setAttribute('placeholder', phrases[0]); return; }
      const st = { pi: 0, ci: 0, del: false };
      const tick = () => {
        if (!this._open) return;
        if (this.input.value) { this._twT = setTimeout(tick, 500); return; }
        const phrase = phrases[st.pi];
        if (!st.del) {
          st.ci++;
          this.input.setAttribute('placeholder', phrase.slice(0, st.ci));
          if (st.ci >= phrase.length) { st.del = true; this._twT = setTimeout(tick, 1600); return; }
          this._twT = setTimeout(tick, 58);
        } else {
          st.ci--;
          this.input.setAttribute('placeholder', phrase.slice(0, st.ci));
          if (st.ci <= 0) { st.del = false; st.pi = (st.pi + 1) % phrases.length; this._twT = setTimeout(tick, 320); return; }
          this._twT = setTimeout(tick, 30);
        }
      };
      clearTimeout(this._twT);
      this._twT = setTimeout(tick, 350);
    }

    stopType() {
      clearTimeout(this._twT); this._twT = null;
      if (this._basePlaceholder != null) this.input.setAttribute('placeholder', this._basePlaceholder);
    }

    // svstk-7q2x9k3 · kept-close search contract (2026-09-30):
    //  1. The results fetch starts IMMEDIATELY. The optional fuzzy layer loads in parallel and is
    //     only awaited when the literal term came back empty (that is the one case its correction
    //     is used as a fetch term). It used to sit in FRONT of the fetch for up to 1.2s on every
    //     search until Fuse + the vocabulary section had loaded — on a slow connection the shopper
    //     stared at the resting Popular/Featured state and read it as "not found".
    //  2. A FAILED request (429 throttle, 403/challenge page, offline, non-JSON) is NOT "no
    //     results". It is retried once, never cached, and if it still fails the body says so and
    //     links the full results page. Before this, any failure rendered "No form by that name"
    //     and a throttled JSON 429 was CACHED, so the term stayed "not found" for the rest of the
    //     page session — on that one machine only.
    //  3. Latest query wins: a ticket (_seq) plus the field check drop any older response that
    //     lands late, whatever path it took (retry, fuzzy refetch, SKU lookup).
    async search(term) {
      const t = (term || '').trim();
      const seq = ++this._seq;
      if (t.length < this.min) {
        if (this._abort) this._abort.abort();
        this.body.removeAttribute('aria-busy');
        this.renderEmpty();
        return;
      }
      const fuseP = Promise.race([this.loadFuse(), new Promise((r) => setTimeout(r, 1200))]);
      const wantSku = this.looksLikeSku(t);
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const sig = this._abort.signal;
      this.body.setAttribute('aria-busy', 'true');
      // Synonym / transliteration path — synchronous, no Fuse, no wait. A known alternate
      // spelling ("ganpati" -> Ganesha) is fetched IN PARALLEL with the shopper's own words and
      // merged, so it never costs a second round-trip. Skipped when the normaliser already
      // says the two are the same word (laxmi/Lakshmi, jaganath/Jagannath) — Shopify's own
      // typo tolerance returns those on the literal request.
      const canon = this.canonical(t);
      const fetchCanon = !!canon && this.norm(canon) !== this.norm(t);
      let data = null, skuData = null, usedCorrection = false, failed = false, correction = null;
      try {
        // Fetch predictive with the USER'S term. Shopify prefix-matches it, so "rajaraj" finds the
        // product "…Rajarajeshwari…". Fuse's correction is ONLY fetched when everything came back
        // empty: predictive AND-matches every word, so fetching a multi-word correction instead of
        // the literal drops real products (§14).
        const skuP = wantSku ? this._suggestSku(t, sig).catch(() => null) : Promise.resolve(null);
        const canonP = fetchCanon ? this._suggest(canon, sig).catch(() => null) : Promise.resolve(null);
        let lit = null;
        try { lit = await this._suggestRetry(t, sig); } catch (e) { if (e && e.name === 'AbortError') throw e; }
        const cd = await canonP;
        if (seq !== this._seq) return;
        const litOk = !!lit && !this._emptyRes(lit);
        const cdOk = !!cd && !this._emptyRes(cd);
        if (!lit && !cdOk) throw new Error('suggest failed');
        data = (litOk && cdOk) ? this._merge(lit, cd) : (cdOk ? cd : lit);
        if (!litOk && cdOk) usedCorrection = true;
        // The synonym's own "Did you mean" only when it was fetched as a different word; a
        // normaliser-equal spelling (laxmi / Lakshmi) may still get Fuse's hint below.
        if (fetchCanon) correction = canon;
        if (this._emptyRes(data)) {
          // Nothing at all: try the normaliser-equal canonical spelling (not fetched yet), then Fuse.
          if (canon && !fetchCanon && canon.toLowerCase() !== t.toLowerCase()) {
            const nd = await this._suggest(canon, sig).catch(() => null);
            if (nd && !this._emptyRes(nd)) { data = nd; usedCorrection = true; correction = canon; }
          }
          if (this._emptyRes(data)) {
            await fuseP;
            if (seq !== this._seq) return;
            const fc = this.fuseCorrect(t);
            if (fc && fc.toLowerCase() !== t.toLowerCase() && (!canon || fc.toLowerCase() !== canon.toLowerCase())) {
              const fd = await this._suggest(fc, sig).catch(() => null);
              if (fd && !this._emptyRes(fd)) { data = fd; usedCorrection = true; correction = fc; }
            }
          }
        } else if (!correction) {
          correction = this.fuseCorrect(t); // only if Fuse is already loaded — never waits
        }
        skuData = await skuP;
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        failed = true;
      }
      if (seq !== this._seq || (this.input.value || '').trim() !== t) return;
      this.body.removeAttribute('aria-busy');
      if (failed) { this.renderError(t); return; }
      this.renderResults(t, correction, data, skuData, usedCorrection);
    }

    // Interleave literal + synonym results (dedupe by handle / url) so neither side crowds the other out.
    _merge(a, b) {
      const ra = a.resources.results, rb = b.resources.results;
      const pa = ra.products || [], pb = rb.products || [];
      const seen = new Set(), products = [];
      for (let i = 0; products.length < this.productLimit && (i < pa.length || i < pb.length); i++) {
        [pa[i], pb[i]].forEach((p) => { if (p && !seen.has(p.handle) && products.length < this.productLimit) { seen.add(p.handle); products.push(p); } });
      }
      const cseen = new Set(), collections = [];
      (rb.collections || []).concat(ra.collections || []).forEach((c) => { if (c && !cseen.has(c.url) && collections.length < 6) { cseen.add(c.url); collections.push(c); } });
      return { resources: { results: { products, collections } } };
    }

    _cacheGet(k) {
      const key = k.toLowerCase();
      if (!this.cache.has(key)) return null;
      const v = this.cache.get(key);
      this.cache.delete(key); this.cache.set(key, v); // refresh recency
      return v;
    }
    _cachePut(k, v) {
      const key = k.toLowerCase();
      this.cache.delete(key); this.cache.set(key, v);
      while (this.cache.size > this.cacheMax) this.cache.delete(this.cache.keys().next().value);
    }

    // One retry for a transient failure (throttle / flaky mobile network). Aborts pass straight through.
    async _suggestRetry(term, sig) {
      try { return await this._suggest(term, sig); } catch (err) {
        if (err && err.name === 'AbortError') throw err;
        await new Promise((r) => setTimeout(r, 700));
        if (sig.aborted) { const e = new Error('aborted'); e.name = 'AbortError'; throw e; }
        return this._suggest(term, sig);
      }
    }

    // Only a well-formed 200 is a result, and only a result is cached.
    _okJson(r) {
      if (!r.ok) throw new Error('suggest ' + r.status);
      return r.json().then((d) => {
        if (!d || !d.resources || !d.resources.results) throw new Error('suggest shape');
        return d;
      });
    }

    renderError(term) {
      const href = this.searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
      this.body.innerHTML = '<div class="ss-zero" data-svstk-reach="offline">' +
        '<span class="ss-zero__icon" aria-hidden="true">' + this.zeroIcon() + '</span>' +
        '<h3 class="ss-zero__title">' + this.t('error_title') + '</h3>' +
        '<p class="ss-zero__body">' + this.t('error_body') + '</p>' +
        '<div class="ss__chips ss__chips--center">' +
          '<button type="button" class="ss__poppill" data-term="' + this.esc(term) + '">' + this.t('retry') + '</button>' +
        '</div>' +
        '<a class="ss-g__all ss-g__all--err" href="' + href + '">' + this.t('see_all').replace('%s', this.esc(term)) + '</a></div>';
    }

    _emptyRes(d) {
      const r = (d && d.resources && d.resources.results) || {};
      return !(r.products && r.products.length) && !(r.collections && r.collections.length);
    }

    _suggest(term, sig) {
      const cached = this._cacheGet(term);
      if (cached) return Promise.resolve(cached);
      // limit_scope=each: without it `resources[limit]` is ONE budget shared by products AND
      // collections, so every matching collection chip evicted a product card (measured live
      // 2026-09-30 at limit 6: "krish" 4 products + 2 collections, "jagannath" 5 + 1 — the 6th
      // product never reached the overlay). With `each`, products get the full limit.
      const url = this.searchUrl + '/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection&resources[limit]=' + this.productLimit +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      return fetch(url, { signal: sig, headers: { 'Accept': 'application/json' } })
        .then((r) => this._okJson(r)).then((d) => { this._cachePut(term, d); return d; });
    }

    _suggestSku(t, sig) {
      const key = 'sku:' + t;
      const cached = this._cacheGet(key);
      if (cached) return Promise.resolve(cached);
      const surl = this.searchUrl + '/suggest.json?q=' + encodeURIComponent(t) +
        '&resources[type]=product&resources[limit]=4' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=variants.sku';
      return fetch(surl, { signal: sig, headers: { 'Accept': 'application/json' } })
        .then((r) => this._okJson(r)).then((d) => { this._cachePut(key, d); return d; });
    }

    // A term worth an exact-SKU lookup: alphanumeric code with at least one digit, length >= 3.
    looksLikeSku(t) { return /^[A-Za-z0-9][A-Za-z0-9._\-\/]{2,}$/.test(t) && /\d/.test(t); }

    renderResults(term, correction, data, skuData, usedCorrection) {
      const res = (data && data.resources && data.resources.results) || {};
      let products = (res.products || []).slice();
      const collections = res.collections || [];
      const skuRes = (skuData && skuData.resources && skuData.resources.results) || {};
      const pinned = skuRes.products || [];
      if (pinned.length) {
        const pinnedHandles = new Set(pinned.map((p) => p.handle));
        products = products.filter((p) => !pinnedHandles.has(p.handle));
      }
      const all = pinned.map((p) => [p, true]).concat(products.map((p) => [p, false]));
      const cards = all.map(([p, isSku], i) => this.gridCard(p, isSku, i < 3));
      if (!cards.length && !collections.length) { this.renderZero(term); return; }
      let h = '';
      if (correction && correction.toLowerCase() !== term.toLowerCase()) {
        h += '<p class="ss__did">' + this.t('did') + ' <button type="button" data-correct="' + this.esc(correction) + '">' + this.esc(correction) + '</button>?</p>';
      }
      if (collections.length) {
        h += '<div class="ss-g__colsect"><p class="ss-g__colhead">' + this.t('collections_with').replace('%s', this.esc(term)) + '</p>' +
          '<div class="ss-g__cols">' + collections.map((c) => '<a class="ss-res__chip" href="' + this.esc(c.url) + '">' + this.esc(c.title) + '</a>').join('') + '</div></div>';
      }
      if (cards.length) {
        h += '<div class="ss-g__grid">' + cards.join('') + '</div>';
      }
      h += this.seeAllBtn(usedCorrection ? correction : term, term, cards.length);
      this.body.innerHTML = h;
    }

    renderZero(term) {
      const trending = this.json('[data-ss-trending]') || [];
      const pills = trending.length
        ? '<div class="ss__chips ss__chips--center">' + trending.map((x) => '<button type="button" class="ss__poppill" data-term="' + this.esc(x) + '"><span class="ss__poppill-star" aria-hidden="true">&#10022;</span>' + this.esc(x) + '</button>').join('') + '</div>'
        : '';
      this.body.innerHTML = '<div class="ss-zero">' +
        '<span class="ss-zero__icon" aria-hidden="true">' + this.zeroIcon() + '</span>' +
        '<h3 class="ss-zero__title">' + this.t('none_title') + '</h3>' +
        '<p class="ss-zero__body">' + this.t('none_body').replace('%s', '<strong>' + this.esc(term) + '</strong>') + '</p>' +
        pills + '</div>';
    }

    seeAllBtn(q, term, count) {
      const label = this.t('see_all').replace('%c', count).replace('%s', this.esc(term));
      return '<a class="ss-g__all" href="' + this.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">' + label + '</a>';
    }

    // First row (3 cards) loads EAGER: native lazy-loading inside a fixed overlay's scroll box
    // can wait on the intersection pass, so the cards the shopper is looking at would paint late.
    gridCard(p, isSku, eager) {
      const src = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
      // Card lands at ~132px on desktop (panel min(760px,100vw-32px) - 44px padding, auto-fill
      // minmax(120px,1fr) => 5 cols) and 50vw-29px on the <=600px two-column layout.
      const img = src
        ? '<img src="' + this.esc(this.sized(src, 300)) + '"'
          + ' srcset="' + this.esc(this.srcset(src, [150, 200, 300, 400, 540])) + '"'
          + ' sizes="(max-width: 600px) calc(50vw - 29px), 132px"'
          + ' alt="" loading="' + (eager ? 'eager' : 'lazy') + '" decoding="async" width="150" height="150">'
        : '';
      const priceMin = (p.price_min != null) ? parseFloat(p.price_min) : parseFloat(p.price);
      const cmpMin = (p.compare_at_price_min != null) ? parseFloat(p.compare_at_price_min) : null;
      let badge = '', mrp = '';
      if (cmpMin != null && priceMin != null && !isNaN(cmpMin) && cmpMin > priceMin) {
        const off = Math.round((1 - priceMin / cmpMin) * 100);
        if (off > 0) badge = '<span class="ss-g__badge">' + off + '% off</span>';
        mrp = ' <s>' + this.money(cmpMin) + '</s>';
      }
      const skuTag = isSku ? '<span class="ss-g__skutag">SKU</span>' : '';
      return '<a class="ss-g__card" href="' + this.esc(p.url) + '">' +
        '<span class="ss-g__media">' + img + badge + skuTag + '</span>' +
        '<span class="ss-g__name">' + this.esc(p.title) + '</span>' +
        '<span class="ss-g__price">' + this.price(p) + mrp + '</span></a>';
    }

    zeroIcon() {
      return '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--brand-dk, #8A6D2B)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><line x1="15.6" y1="15.6" x2="20" y2="20"/><path d="M8.4 11 H13.6 M11 8.4 V13.6" opacity=".5"/></svg>';
    }

    // Resting state = Recent (one row, max 4, only when present) + Popular (max 6). Nothing else.
    renderEmpty() {
      const recent = (this.recentEnabled ? this.getRecent() : []).slice(0, 4);
      const trending = (this.json('[data-ss-trending]') || []).slice(0, 6);
      let h = '';
      if (recent.length) {
        h += '<div class="ss__sect" data-svstk-kept-close="recent"><div class="ss__sect-h"><span class="ss__eyebrow">' + this.t('recent') + '</span>' +
          '<button type="button" class="ss__xclear" data-ss-clear aria-label="' + this.esc(this.t('clear_recent')) + '">' + this.xIcon() + '</button></div>' +
          '<div class="ss__chips ss__chips--row">' +
          recent.map((x) => '<button type="button" class="ss__chip" data-term="' + this.esc(x) + '">' + this.esc(x) + '</button>').join('') + '</div></div>';
      }
      if (trending.length) {
        h += '<div class="ss__sect"><div class="ss__sect-h"><span class="ss__eyebrow">' + this.trendIcon() + this.t('popular') + '</span></div><div class="ss__chips">' +
          trending.map((x) => '<button type="button" class="ss__poppill" data-term="' + this.esc(x) + '"><span class="ss__poppill-star" aria-hidden="true">&#10022;</span>' + this.esc(x) + '</button>').join('') + '</div></div>';
      }
      this.body.innerHTML = h || '<p class="ss__hint">' + this.t('hint') + '</p>';
    }

    xIcon() {
      return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6 L18 18 M18 6 L6 18"/></svg>';
    }

    trendIcon() {
      return '<svg class="ss__eyebrow-ico" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17l6-6 4 4 8-8"/><path d="M17 7h4v4"/></svg>';
    }

    // Idempotent: SETS width rather than appending one, so it is safe on a URL that already
    // carries `width=` (suggest.json image URLs can arrive with one).
    // Appending a second width= would leave `?width=300&width=450` and let the CDN pick.
    sized(url, w) {
      if (!url) return url;
      const i = url.indexOf('?');
      const base = i === -1 ? url : url.slice(0, i);
      const qs = new URLSearchParams(i === -1 ? '' : url.slice(i + 1));
      qs.set('width', String(w || 96));
      return base + '?' + qs.toString();
    }
    // Real responsive srcset. Without this a phone downloaded one fixed width for every box
    // (§3: a bare width with no widths/sizes is a bug) — 300w into a 132px card on a DPR1
    // screen, and not enough pixels on a DPR3 one.
    srcset(url, widths) {
      if (!url) return '';
      return widths.map((w) => this.sized(url, w) + ' ' + w + 'w').join(', ');
    }

    money(v) {
      const n = Math.round(parseFloat(v));
      if (isNaN(n)) return '';
      return this.currency + n.toLocaleString('en-IN');
    }

    price(p) {
      const min = (p.price_min != null) ? p.price_min : p.price;
      const max = (p.price_max != null) ? p.price_max : p.price;
      if (max != null && min != null && parseFloat(max) > parseFloat(min)) {
        return this.t('from') + ' ' + this.money(min);
      }
      return this.money(p.price);
    }

    // Fuse is a PROGRESSIVE ENHANCEMENT (typo tolerance only) — search must work without it.
    // This promise therefore ALWAYS resolves: a script that loads but fails to define
    // window.Fuse (a third-party bundle declaring a global lexical `e` collides with the UMD's
    // top-level `var e` and kills it at eval) used to throw inside onload, so `resolve` never
    // ran, `fuseLoading` stayed pending forever, and `await loadFuse()` in search() hung —
    // silently dead search on the live theme. Never let this reject or stall. See §14.
    // The keyword vocabulary is a SEPARATE section fetched on first open (it is 250 collection
    // titles and is read by nothing but the fuzzy layer — see sections/search-index.liquid).
    // Same never-reject/never-stall contract as loadFuse below: every path resolves, with [] as
    // the degraded value, because a hang here has no stack trace and just looks like dead search.
    loadVocab() {
      if (this.vocab) return Promise.resolve(this.vocab);
      if (this.vocabLoading) return this.vocabLoading;
      const url = this.dataset.ssIndexUrl;
      const done = (v) => { this.vocab = v || []; return this.vocab; };
      if (!url) { this.vocabLoading = Promise.resolve(done([])); return this.vocabLoading; }
      this.vocabLoading = fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return done([]);
          try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const el = doc.querySelector('[data-ss-index]');
            return done(el ? JSON.parse(el.textContent) : []);
          } catch (e) { return done([]); }
        })
        .catch(() => done([]));
      return this.vocabLoading;
    }

    loadFuse() {
      if (this.fuse) return Promise.resolve(this.fuse);
      if (this.fuseLoading) return this.fuseLoading;
      this.fuseLoading = new Promise((resolve) => {
        const done = (v) => { this.fuse = v; resolve(v); };
        // Vocabulary fetch and script load run in PARALLEL, and neither can reject.
        const vocabP = this.loadVocab();
        const sc = document.createElement('script');
        sc.src = this.dataset.fuseSrc;
        sc.onload = () => {
          if (typeof window.Fuse !== 'function') { done(null); return; }
          vocabP.then((terms) => {
            try {
              done(new window.Fuse(this.buildIndex(terms), { keys: ['n'], includeScore: true, threshold: 0.4, ignoreLocation: true, minMatchCharLength: 2 }));
            } catch (e) { done(null); }
          }, () => done(null));
        };
        sc.onerror = () => done(null);
        document.head.appendChild(sc);
      });
      return this.fuseLoading;
    }

    // Fuse scores against the NORMALISED form of every vocabulary term (so "laxmee" and
    // "Lakshmi" are near-identical) and hands back the original spelling for "Did you mean".
    buildIndex(vocab) {
      const syn = this.synonyms();
      const terms = Array.from(new Set((vocab || []).filter(Boolean).concat(syn.map((e) => e.v))));
      return terms.map((o) => ({ o, n: this.norm(o) })).filter((x) => x.n);
    }

    // Transliteration normaliser — applied to BOTH sides (vocab + term, synonym keys + term).
    // Comparison only: never used as a fetch term.
    norm(str) {
      return String(str || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean).map((w) => this.normWord(w)).join(' ');
    }
    normWord(w) {
      if (/\d/.test(w)) return w;
      w = w.replace(/x/g, 'ksh')                  // laxmi -> lakshmi
        .replace(/w/g, 'v')                       // swastika -> svastika, venkateswara
        .replace(/ph/g, 'f')
        .replace(/ee/g, 'i').replace(/oo/g, 'u')  // lakshmee, moorti
        .replace(/([bdgkt])h/g, '$1')             // aspirates: thali/tali, saraswathi, dhoop (sh kept)
        .replace(/(.)\1+/g, '$1');                // doubled letters: aa, gg, nn, dd
      if (w.length > 3 && w.charAt(w.length - 1) === 'a') w = w.slice(0, -1); // ganesha/ganesh, krishna/krishn
      return w;
    }

    // Built-in table + the merchant's `synonyms` setting (merchant wins), keys normalised and
    // tokenised, longest phrase first. Built once, lazily — needs no network.
    synonyms() {
      if (this.synList) return this.synList;
      const map = {};
      Object.keys(SVSTK_SYNONYMS).forEach((k) => { map[this.norm(k)] = SVSTK_SYNONYMS[k]; });
      (this.json('[data-ss-synonyms]') || []).forEach((line) => {
        const m = String(line).split('->');
        const w = (m[0] || '').trim(), r = (m[1] || '').trim();
        if (w && r) map[this.norm(w)] = r;
      });
      this.synList = Object.keys(map).filter(Boolean).map((k) => ({ k: k.split(' '), v: map[k] }))
        .sort((x, y) => y.k.length - x.k.length);
      return this.synList;
    }

    // Replace every known alternate spelling (phrase or single word) with its canonical name;
    // untouched words keep the shopper's own spelling. null when nothing matched.
    canonical(term) {
      const raw = String(term || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
      if (!raw.length) return null;
      const nt = raw.map((w) => this.normWord(w));
      const list = this.synonyms();
      const out = [];
      let hit = false;
      for (let i = 0; i < nt.length;) {
        const m = list.find((e) => i + e.k.length <= nt.length && e.k.every((w, j) => w === nt[i + j]));
        if (m) { out.push(m.v); i += m.k.length; hit = true; } else { out.push(raw[i]); i++; }
      }
      return hit ? out.join(' ') : null;
    }

    // Fuse suggestion for the term (scored on the normalised form), or null. Never waits:
    // null if Fuse isn't loaded yet.
    fuseCorrect(term) {
      if (!this.fuse) return null;
      const t = term.toLowerCase().trim();
      const res = this.fuse.search(this.norm(t), { limit: 1 });
      if (res.length && res[0].score < 0.35 && res[0].item.o.toLowerCase() !== t) return res[0].item.o;
      return null;
    }

    getRecent() { try { return JSON.parse(localStorage.getItem('ss_recent') || '[]'); } catch (e) { return []; } }
    addRecent(term) { if (!this.recentEnabled) return; const t = term.trim(); if (!t) return; let r = this.getRecent().filter((x) => x.toLowerCase() !== t.toLowerCase()); r.unshift(t); try { localStorage.setItem('ss_recent', JSON.stringify(r.slice(0, 6))); } catch (e) {} }
    clearRecent() { try { localStorage.removeItem('ss_recent'); } catch (e) {} }

    esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
    json(sel) { const el = this.querySelector(sel); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
    t(k) { return (this.strings && this.strings[k]) || { did: 'Did you mean', all: 'View all results for “%s” →', recent: 'Recent', trending: 'Trending', popular: 'Popular right now', products: 'Products', collections: 'Collections', collections_with: 'Collections with “%s”', see_all: 'See more results for “%s” →', from: 'From', none: 'No results for “%s”.', none_title: 'No form by that name', none_body: 'Nothing matches “%s”. Try a popular search below.', clear: 'Clear', hint: 'Start typing to search…', clear_recent: 'Clear recent searches', error_title: 'Live results are taking a moment', error_body: 'We could not reach the search just now. Try again, or open the full results page.', retry: 'Try again' }[k]; }

    disconnectedCallback() {
      document.removeEventListener('click', this._onTriggerClick);
      ['pointerover', 'touchstart', 'focusin'].forEach((ev) => document.removeEventListener(ev, this._onIntent, this._warmOpts));
      clearTimeout(this._debounce);
      document.removeEventListener('keydown', this._onKeydown);
      document.removeEventListener('keydown', this._trap, true);
      clearTimeout(this._twT);
    }
  }
  if (!customElements.get('svastika-search')) customElements.define('svastika-search', SvastikaSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-hero"] && !Shopify.designMode) return;
  try {
    
  /* svstk-7q2x9k3 — welcome landing motion engine. Runs only where a welcome hero renders (the thank-you-card
     pages), never under prefers-reduced-motion. Reveal targets: the welcome sections' own data-svstk-in hooks
     plus the care card, the rail cards and the closing band by class (shared sections stay untouched). Elements
     already on screen are marked is-in BEFORE html.svstk-motion flips, so nothing visible ever blinks out.
     [data-svstk-watch] sections get is-off while off-screen: their infinite animations pause (kept-close). */
  (function () {
    var hero = document.querySelector('.wlh[data-ritual-welcome]');
    if (!hero || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '[data-svstk-in], .mpromise__seal, .mpromise__eyebrow, .mpromise__h, .mpromise__body, .mpromise__col, .mpromise__badge, .fest-rail__head, .fest-rail .sv-card, .fest-band__txt, .fest-band__media, .editorial__flourish, .editorial__eyebrow, .editorial__heading, .editorial__body';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!els.length) return;
    var vh = window.innerHeight || 800;
    var tops = els.map(function (el) { return el.getBoundingClientRect().top; });   /* read all, then write all */
    var counts = [];
    els.forEach(function (el, i) {
      var p = el.parentNode, g = counts.find(function (c) { return c.p === p; });
      if (!g) { g = { p: p, n: 0 }; counts.push(g); }
      el.style.setProperty('--svstk-d', Math.min(g.n++, 6) * 90 + 'ms');
      el.classList.add('svstk-in');
      if (tops[i] < vh * 0.92) el.classList.add('is-in');
    });
    document.documentElement.classList.add('svstk-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
    var watched = document.querySelectorAll('[data-svstk-watch], .mpromise');
    var wio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    }, { rootMargin: '120px 0px' });
    Array.prototype.forEach.call(watched, function (el) { wio.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-reward"] && !Shopify.designMode) return;
  try {
    
  /* svstk-7q2x9k3 — tap-to-copy for the welcome reward ticket. Clipboard API first, a throwaway
     textarea + execCommand as the fallback for older WebViews. The label swap is the only state. */
  class SvastikaReward extends HTMLElement {
    connectedCallback() {
      // Animations only while visible: pause the glint + gleam when the ticket leaves the viewport.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.classList.toggle('is-resting', !entries[0].isIntersecting);
        }, { rootMargin: '80px 0px' });
        this.io.observe(this);
      }
      this.btn = this.querySelector('[data-wrd-copy]');
      this.live = this.querySelector('[data-wrd-live]');
      if (!this.btn) return;
      this.label = this.btn.textContent;
      this.onClick = this.copy.bind(this);
      this.btn.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.btn) this.btn.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }
    copy() {
      const code = this.dataset.code || '';
      const done = () => this.flash();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => this.legacy(code) && done());
      } else if (this.legacy(code)) {
        done();
      }
    }
    legacy(code) {
      try {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        ta.remove();
        return ok;
      } catch (e) {
        return false;
      }
    }
    flash() {
      const copied = this.dataset.copied || this.label;
      this.btn.textContent = copied;
      this.btn.classList.add('is-copied');
      if (this.live) this.live.textContent = copied;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.btn.textContent = this.label;
        this.btn.classList.remove('is-copied');
      }, 2200);
    }
  }
  if (!customElements.get('svastika-reward')) customElements.define('svastika-reward', SvastikaReward);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-new"] && !Shopify.designMode) return;
  try {
    
  // What's-new: keep every card title on ONE line by scaling its font-size DOWN to fit
  // the card width (never up). Titles are content-sized (the copy is flex, align-items:
  // flex-start), so scrollWidth with nowrap is the true one-line width.
  // The section has content-visibility:auto, so while it is skipped its descendants have
  // NO layout box and measure 0 → an early fit would never shrink. So we fit only when a
  // grid is actually on screen (IntersectionObserver, rootMargin 0), re-fit the moment
  // content-visibility reveals it, and re-fit after the brand serif loads (its metrics
  // differ from the fallback) and on resize. No-JS keeps the wrapping fallback.
  (function () {
    // Batched in three phases — reset ALL, read ALL, write ALL. The per-tile
    // write->read->write of the first cut forced a synchronous layout per card
    // (5 tiles = 5 forced reflows on every fit, and fit runs on reveal, on
    // fonts.ready and on every resize tick). One read phase = one reflow.
    function fit(grid) {
      if (!grid || !grid.clientWidth) return;
      grid.classList.add('wn-fit');
      var titles = Array.prototype.slice.call(grid.querySelectorAll('.ctile__title'));
      if (!titles.length) return;
      // 1 — write: clear every previous override first.
      titles.forEach(function (t) { t.style.fontSize = ''; });
      // 2 — read: one layout flush for the whole grid, no writes in between.
      var measured = titles.map(function (t) {
        return {
          el: t,
          avail: t.parentElement ? t.parentElement.clientWidth : 0,
          natural: t.scrollWidth,
          base: parseFloat(getComputedStyle(t).fontSize) || 22
        };
      });
      // 3 — write: nothing is read after this point, so no further reflow.
      measured.forEach(function (m) {
        if (m.avail && m.natural > m.avail) {
          m.el.style.fontSize = Math.max(11, Math.floor(m.base * m.avail / m.natural)) + 'px';
        }
      });
    }
    var grids = Array.prototype.slice.call(document.querySelectorAll('.wn-grid'));
    if (!grids.length) return;
    function all() { grids.forEach(fit); }

    grids.forEach(function (grid) {
      // Re-fit exactly when content-visibility:auto reveals the section.
      for (var n = grid; n && n !== document.body; n = n.parentElement) {
        if (getComputedStyle(n).contentVisibility === 'auto') {
          n.addEventListener('contentvisibilityautostatechange', function (e) {
            if (!e.skipped) fit(grid);
          });
          break;
        }
      }
      if ('IntersectionObserver' in window) {
        // Keep observing (no disconnect) so a later real reveal re-fits.
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) fit(en.target); });
        }, { rootMargin: '0px' }).observe(grid);
      } else { fit(grid); }
    });

    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(all);
    });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(all); }
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();
})();
